import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Bool: { input: boolean; output: boolean; }
  Date: { input: string; output: string; }
  JSON: { input: unknown; output: unknown; }
};

/** An Addon That Is Unique Per Product */
export type Addon = IContent & IData & {
  __typename?: 'Addon';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Core Name */
  CoreName?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Description visible in the addon selector */
  Description?: Maybe<Scalars['String']['output']>;
  /** Display Name */
  DisplayName?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Is this addon a fixed price, paid once(travel fixed for example)? */
  FixedPrice?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** Description to be added inside of the modal for the addon */
  ModalDescription?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Is this the recommended addon? */
  Recommended?: Maybe<Scalars['Bool']['output']>;
  /** Label for the recommended bubble for this addon */
  RecommendedLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  /** List of Selling Points for this addon */
  SellingPoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** Order relative to other addons */
  SortOrder?: Maybe<Scalars['Int']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An Addon That Is Unique Per Product */
export type AddonCoreNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Addon That Is Unique Per Product */
export type AddonDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Addon That Is Unique Per Product */
export type AddonDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Addon That Is Unique Per Product */
export type AddonModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Addon That Is Unique Per Product */
export type AddonNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Addon That Is Unique Per Product */
export type AddonRecommendedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Addon That Is Unique Per Product */
export type Addon_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An Addon That Is Unique Per Product */
export type Addon_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AddonAutocomplete = {
  __typename?: 'AddonAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SellingPoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AddonAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteSellingPointsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AddonAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AddonFacet = {
  __typename?: 'AddonFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CoreName?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FixedPrice?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  ModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Recommended?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SellingPoints?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type AddonFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddonFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetCoreNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddonFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetFixedPriceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetRecommendedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetRecommendedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddonFacetSellingPointsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetSortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type AddonFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddonFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AddonFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AddonFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type AddonOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CoreName?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisplayName?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FixedPrice?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  ModalDescription?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Recommended?: InputMaybe<OrderBy>;
  RecommendedLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SellingPoints?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SortOrder?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type AddonOutput = {
  __typename?: 'AddonOutput';
  autocomplete?: Maybe<AddonAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AddonFacet>;
  item?: Maybe<Addon>;
  items?: Maybe<Array<Maybe<Addon>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AddonOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddonWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CoreName?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FixedPrice?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  ModalDescription?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Recommended?: InputMaybe<BoolFilterInput>;
  RecommendedLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SellingPoints?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SortOrder?: InputMaybe<IntFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AddonWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AddonWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AddonWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Reusable migrated block for Baby common content. */
export type BabyCommonBlock = IContent & IData & {
  __typename?: 'BabyCommonBlock';
  Adress?: Maybe<BabyCommonBlockQuestionBase>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** This field is the for the Electronic Health Declaration Timer text. Add {{lastDate}} to show the last date to send in the EHD */
  ElectronicHealthDeclarationTimer?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MotherFirstName?: Maybe<BabyCommonBlockQuestionBase>;
  MotherLastName?: Maybe<BabyCommonBlockQuestionBase>;
  Municipality?: Maybe<BabyCommonBlockQuestionBase>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PostalCode?: Maybe<BabyCommonBlockQuestionBase>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  Residency?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Term?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Reusable migrated block for Baby common content. */
export type BabyCommonBlockElectronicHealthDeclarationTimerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Baby common content. */
export type BabyCommonBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Baby common content. */
export type BabyCommonBlockResidencyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Baby common content. */
export type BabyCommonBlockTermArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Baby common content. */
export type BabyCommonBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Baby common content. */
export type BabyCommonBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BabyCommonBlockAutocomplete = {
  __typename?: 'BabyCommonBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BabyCommonBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BabyCommonBlockFacet = {
  __typename?: 'BabyCommonBlockFacet';
  Adress?: Maybe<BabyCommonBlockQuestionBaseFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ElectronicHealthDeclarationTimer?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MotherFirstName?: Maybe<BabyCommonBlockQuestionBaseFacet>;
  MotherLastName?: Maybe<BabyCommonBlockQuestionBaseFacet>;
  Municipality?: Maybe<BabyCommonBlockQuestionBaseFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostalCode?: Maybe<BabyCommonBlockQuestionBaseFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Residency?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Term?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BabyCommonBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonBlockFacetElectronicHealthDeclarationTimerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetResidencyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonBlockFacetTermArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BabyCommonBlockOrderByInput = {
  Adress?: InputMaybe<BabyCommonBlockQuestionBaseOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ElectronicHealthDeclarationTimer?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MotherFirstName?: InputMaybe<BabyCommonBlockQuestionBaseOrderByInput>;
  MotherLastName?: InputMaybe<BabyCommonBlockQuestionBaseOrderByInput>;
  Municipality?: InputMaybe<BabyCommonBlockQuestionBaseOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostalCode?: InputMaybe<BabyCommonBlockQuestionBaseOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  Residency?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Term?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BabyCommonBlockOutput = {
  __typename?: 'BabyCommonBlockOutput';
  autocomplete?: Maybe<BabyCommonBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BabyCommonBlockFacet>;
  item?: Maybe<BabyCommonBlock>;
  items?: Maybe<Array<Maybe<BabyCommonBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BabyCommonBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BabyCommonBlockQuestionBase = {
  __typename?: 'BabyCommonBlockQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<BabyCommonBlockQuestionBaseValidationMessageItem>>>;
};


export type BabyCommonBlockQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyCommonBlockQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyCommonBlockQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyCommonBlockQuestionBaseFacet = {
  __typename?: 'BabyCommonBlockQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<BabyCommonBlockQuestionBaseValidationMessageItemFacet>;
};


export type BabyCommonBlockQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyCommonBlockQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<BabyCommonBlockQuestionBaseValidationMessageItemOrderByInput>;
};

export type BabyCommonBlockQuestionBaseValidationMessageItem = {
  __typename?: 'BabyCommonBlockQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type BabyCommonBlockQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyCommonBlockQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyCommonBlockQuestionBaseValidationMessageItemFacet = {
  __typename?: 'BabyCommonBlockQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyCommonBlockQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonBlockQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyCommonBlockQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type BabyCommonBlockQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyCommonBlockQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<BabyCommonBlockQuestionBaseValidationMessageItemWhereInput>;
};

export type BabyCommonBlockWhereInput = {
  Adress?: InputMaybe<BabyCommonBlockQuestionBaseWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ElectronicHealthDeclarationTimer?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MotherFirstName?: InputMaybe<BabyCommonBlockQuestionBaseWhereInput>;
  MotherLastName?: InputMaybe<BabyCommonBlockQuestionBaseWhereInput>;
  Municipality?: InputMaybe<BabyCommonBlockQuestionBaseWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostalCode?: InputMaybe<BabyCommonBlockQuestionBaseWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Residency?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Term?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BabyCommonBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BabyCommonBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BabyCommonBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Baby Common */
export type BabyCommonPage = IContent & IData & {
  __typename?: 'BabyCommonPage';
  Adress?: Maybe<BabyCommonPageQuestionBase>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** This field is the for the Electronic Health Declaration Timer text. Add {{lastDate}} to show the last date to send in the EHD */
  ElectronicHealthDeclarationTimer?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MotherFirstName?: Maybe<BabyCommonPageQuestionBase>;
  MotherLastName?: Maybe<BabyCommonPageQuestionBase>;
  Municipality?: Maybe<BabyCommonPageQuestionBase>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PostalCode?: Maybe<BabyCommonPageQuestionBase>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  Residency?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Term?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Baby Common */
export type BabyCommonPageElectronicHealthDeclarationTimerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Baby Common */
export type BabyCommonPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Baby Common */
export type BabyCommonPageResidencyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Baby Common */
export type BabyCommonPageTermArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Baby Common */
export type BabyCommonPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Baby Common */
export type BabyCommonPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BabyCommonPageAutocomplete = {
  __typename?: 'BabyCommonPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BabyCommonPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyCommonPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BabyCommonPageFacet = {
  __typename?: 'BabyCommonPageFacet';
  Adress?: Maybe<BabyCommonPageQuestionBaseFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ElectronicHealthDeclarationTimer?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MotherFirstName?: Maybe<BabyCommonPageQuestionBaseFacet>;
  MotherLastName?: Maybe<BabyCommonPageQuestionBaseFacet>;
  Municipality?: Maybe<BabyCommonPageQuestionBaseFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostalCode?: Maybe<BabyCommonPageQuestionBaseFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  Residency?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Term?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BabyCommonPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonPageFacetElectronicHealthDeclarationTimerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetResidencyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyCommonPageFacetTermArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BabyCommonPageOrderByInput = {
  Adress?: InputMaybe<BabyCommonPageQuestionBaseOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ElectronicHealthDeclarationTimer?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MotherFirstName?: InputMaybe<BabyCommonPageQuestionBaseOrderByInput>;
  MotherLastName?: InputMaybe<BabyCommonPageQuestionBaseOrderByInput>;
  Municipality?: InputMaybe<BabyCommonPageQuestionBaseOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostalCode?: InputMaybe<BabyCommonPageQuestionBaseOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  Residency?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Term?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BabyCommonPageOutput = {
  __typename?: 'BabyCommonPageOutput';
  autocomplete?: Maybe<BabyCommonPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BabyCommonPageFacet>;
  item?: Maybe<BabyCommonPage>;
  items?: Maybe<Array<Maybe<BabyCommonPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BabyCommonPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BabyCommonPageQuestionBase = {
  __typename?: 'BabyCommonPageQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<BabyCommonPageQuestionBaseValidationMessageItem>>>;
};


export type BabyCommonPageQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyCommonPageQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyCommonPageQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyCommonPageQuestionBaseFacet = {
  __typename?: 'BabyCommonPageQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<BabyCommonPageQuestionBaseValidationMessageItemFacet>;
};


export type BabyCommonPageQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyCommonPageQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<BabyCommonPageQuestionBaseValidationMessageItemOrderByInput>;
};

export type BabyCommonPageQuestionBaseValidationMessageItem = {
  __typename?: 'BabyCommonPageQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type BabyCommonPageQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyCommonPageQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyCommonPageQuestionBaseValidationMessageItemFacet = {
  __typename?: 'BabyCommonPageQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyCommonPageQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyCommonPageQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyCommonPageQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type BabyCommonPageQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyCommonPageQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<BabyCommonPageQuestionBaseValidationMessageItemWhereInput>;
};

export type BabyCommonPageWhereInput = {
  Adress?: InputMaybe<BabyCommonPageQuestionBaseWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ElectronicHealthDeclarationTimer?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MotherFirstName?: InputMaybe<BabyCommonPageQuestionBaseWhereInput>;
  MotherLastName?: InputMaybe<BabyCommonPageQuestionBaseWhereInput>;
  Municipality?: InputMaybe<BabyCommonPageQuestionBaseWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostalCode?: InputMaybe<BabyCommonPageQuestionBaseWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  Residency?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Term?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BabyCommonPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BabyCommonPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BabyCommonPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A page containing the baby confirmation content. */
export type BabyConfirmationPage = IContent & IData & {
  __typename?: 'BabyConfirmationPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationPageCommon?: Maybe<BabyConfirmationPageConfirmationPageCommon>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NordeaDueDateDistantFuture?: Maybe<Scalars['String']['output']>;
  NordeaDueDateNearFuture?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WebshopDueDateDistantFuture?: Maybe<Scalars['String']['output']>;
  WebshopDueDateNearFuture?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A page containing the baby confirmation content. */
export type BabyConfirmationPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page containing the baby confirmation content. */
export type BabyConfirmationPageNordeaDueDateDistantFutureArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page containing the baby confirmation content. */
export type BabyConfirmationPageNordeaDueDateNearFutureArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page containing the baby confirmation content. */
export type BabyConfirmationPageWebshopDueDateDistantFutureArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page containing the baby confirmation content. */
export type BabyConfirmationPageWebshopDueDateNearFutureArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page containing the baby confirmation content. */
export type BabyConfirmationPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page containing the baby confirmation content. */
export type BabyConfirmationPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BabyConfirmationPageAutocomplete = {
  __typename?: 'BabyConfirmationPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BabyConfirmationPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyConfirmationPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BabyConfirmationPageConfirmationPageCommon = {
  __typename?: 'BabyConfirmationPageConfirmationPageCommon';
  AboutInsuranceSectionHeaderText?: Maybe<Scalars['String']['output']>;
  AddOnHeaderText?: Maybe<Scalars['String']['output']>;
  CancellationBlock?: Maybe<Scalars['String']['output']>;
  DiscountText?: Maybe<Scalars['String']['output']>;
  InvoicingInfoExistingCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingInfoNewCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingSectionHeader?: Maybe<Scalars['String']['output']>;
  LogoutLink?: Maybe<Scalars['String']['output']>;
  LogoutLinkText?: Maybe<Scalars['String']['output']>;
  LogoutText?: Maybe<Scalars['String']['output']>;
  MyPagesButtonText?: Maybe<Scalars['String']['output']>;
  MyPagesScaluText?: Maybe<Scalars['String']['output']>;
  MyPagesSectionHeader?: Maybe<Scalars['String']['output']>;
  MyPagesText?: Maybe<Scalars['String']['output']>;
  NordeaCampaignInfo?: Maybe<Scalars['String']['output']>;
  PageHeaderText?: Maybe<Scalars['String']['output']>;
  SecondaryHeader?: Maybe<Scalars['String']['output']>;
  TotalAmount?: Maybe<Scalars['String']['output']>;
};


export type BabyConfirmationPageConfirmationPageCommonAboutInsuranceSectionHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonAddOnHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonCancellationBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonDiscountTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonInvoicingInfoExistingCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonInvoicingInfoNewCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonInvoicingSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonLogoutLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonLogoutLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonLogoutTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonMyPagesButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonMyPagesScaluTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonMyPagesSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonMyPagesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonNordeaCampaignInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonPageHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonSecondaryHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyConfirmationPageConfirmationPageCommonTotalAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyConfirmationPageConfirmationPageCommonFacet = {
  __typename?: 'BabyConfirmationPageConfirmationPageCommonFacet';
  AboutInsuranceSectionHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  AddOnHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  CancellationBlock?: Maybe<Array<Maybe<StringFacet>>>;
  DiscountText?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoExistingCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoNewCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLink?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesScaluText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesText?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignInfo?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  SecondaryHeader?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmount?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetAboutInsuranceSectionHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetAddOnHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetCancellationBlockArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetDiscountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetInvoicingInfoExistingCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetInvoicingInfoNewCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetInvoicingSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetLogoutLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetLogoutLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetLogoutTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetMyPagesButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetMyPagesScaluTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetMyPagesSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetMyPagesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetNordeaCampaignInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetPageHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetSecondaryHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageConfirmationPageCommonFacetTotalAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyConfirmationPageConfirmationPageCommonOrderByInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<OrderBy>;
  AddOnHeaderText?: InputMaybe<OrderBy>;
  CancellationBlock?: InputMaybe<OrderBy>;
  DiscountText?: InputMaybe<OrderBy>;
  InvoicingInfoExistingCustomer?: InputMaybe<OrderBy>;
  InvoicingInfoNewCustomer?: InputMaybe<OrderBy>;
  InvoicingSectionHeader?: InputMaybe<OrderBy>;
  LogoutLink?: InputMaybe<OrderBy>;
  LogoutLinkText?: InputMaybe<OrderBy>;
  LogoutText?: InputMaybe<OrderBy>;
  MyPagesButtonText?: InputMaybe<OrderBy>;
  MyPagesScaluText?: InputMaybe<OrderBy>;
  MyPagesSectionHeader?: InputMaybe<OrderBy>;
  MyPagesText?: InputMaybe<OrderBy>;
  NordeaCampaignInfo?: InputMaybe<OrderBy>;
  PageHeaderText?: InputMaybe<OrderBy>;
  SecondaryHeader?: InputMaybe<OrderBy>;
  TotalAmount?: InputMaybe<OrderBy>;
};

export type BabyConfirmationPageConfirmationPageCommonWhereInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<SearchableStringFilterInput>;
  AddOnHeaderText?: InputMaybe<SearchableStringFilterInput>;
  CancellationBlock?: InputMaybe<SearchableStringFilterInput>;
  DiscountText?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoExistingCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoNewCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  LogoutLink?: InputMaybe<SearchableStringFilterInput>;
  LogoutLinkText?: InputMaybe<SearchableStringFilterInput>;
  LogoutText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesButtonText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesScaluText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  MyPagesText?: InputMaybe<SearchableStringFilterInput>;
  NordeaCampaignInfo?: InputMaybe<SearchableStringFilterInput>;
  PageHeaderText?: InputMaybe<SearchableStringFilterInput>;
  SecondaryHeader?: InputMaybe<SearchableStringFilterInput>;
  TotalAmount?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyConfirmationPageFacet = {
  __typename?: 'BabyConfirmationPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationPageCommon?: Maybe<BabyConfirmationPageConfirmationPageCommonFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaDueDateDistantFuture?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaDueDateNearFuture?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WebshopDueDateDistantFuture?: Maybe<Array<Maybe<StringFacet>>>;
  WebshopDueDateNearFuture?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BabyConfirmationPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyConfirmationPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyConfirmationPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetNordeaDueDateDistantFutureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetNordeaDueDateNearFutureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyConfirmationPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyConfirmationPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyConfirmationPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetWebshopDueDateDistantFutureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacetWebshopDueDateNearFutureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyConfirmationPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BabyConfirmationPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationPageCommon?: InputMaybe<BabyConfirmationPageConfirmationPageCommonOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NordeaDueDateDistantFuture?: InputMaybe<OrderBy>;
  NordeaDueDateNearFuture?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WebshopDueDateDistantFuture?: InputMaybe<OrderBy>;
  WebshopDueDateNearFuture?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BabyConfirmationPageOutput = {
  __typename?: 'BabyConfirmationPageOutput';
  autocomplete?: Maybe<BabyConfirmationPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BabyConfirmationPageFacet>;
  item?: Maybe<BabyConfirmationPage>;
  items?: Maybe<Array<Maybe<BabyConfirmationPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BabyConfirmationPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BabyConfirmationPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationPageCommon?: InputMaybe<BabyConfirmationPageConfirmationPageCommonWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NordeaDueDateDistantFuture?: InputMaybe<SearchableStringFilterInput>;
  NordeaDueDateNearFuture?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WebshopDueDateDistantFuture?: InputMaybe<SearchableStringFilterInput>;
  WebshopDueDateNearFuture?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BabyConfirmationPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BabyConfirmationPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BabyConfirmationPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Entry page for baby products */
export type BabyEntryPage = IContent & IData & {
  __typename?: 'BabyEntryPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BabyMotherSsn?: Maybe<BabyEntryPageQuestionBase>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EntryPageCommon?: Maybe<BabyEntryPageEntryPageCommon>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExpectedDateOfBirth?: Maybe<BabyEntryPageQuestionBase>;
  InsuredParty?: Maybe<BabyEntryPageQuestionBase>;
  InsuredPartyIsMother?: Maybe<Scalars['String']['output']>;
  InsuredPartyIsNotMother?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Entry page for baby products */
export type BabyEntryPageInsuredPartyIsMotherArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for baby products */
export type BabyEntryPageInsuredPartyIsNotMotherArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for baby products */
export type BabyEntryPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for baby products */
export type BabyEntryPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for baby products */
export type BabyEntryPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BabyEntryPageAutocomplete = {
  __typename?: 'BabyEntryPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BabyEntryPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyEntryPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BabyEntryPageEntryPageCommon = {
  __typename?: 'BabyEntryPageEntryPageCommon';
  Description?: Maybe<Scalars['String']['output']>;
  SsnQuestion?: Maybe<BabyEntryPageEntryPageCommonQuestionBase>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Terms?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type BabyEntryPageEntryPageCommonDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageEntryPageCommonSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageEntryPageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageEntryPageCommonTermsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageEntryPageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyEntryPageEntryPageCommonFacet = {
  __typename?: 'BabyEntryPageEntryPageCommonFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  SsnQuestion?: Maybe<BabyEntryPageEntryPageCommonQuestionBaseFacet>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Terms?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyEntryPageEntryPageCommonFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageEntryPageCommonFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageEntryPageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageEntryPageCommonFacetTermsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageEntryPageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyEntryPageEntryPageCommonOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  SsnQuestion?: InputMaybe<BabyEntryPageEntryPageCommonQuestionBaseOrderByInput>;
  SubTitle?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Terms?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type BabyEntryPageEntryPageCommonQuestionBase = {
  __typename?: 'BabyEntryPageEntryPageCommonQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItem>>>;
};


export type BabyEntryPageEntryPageCommonQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageEntryPageCommonQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageEntryPageCommonQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyEntryPageEntryPageCommonQuestionBaseFacet = {
  __typename?: 'BabyEntryPageEntryPageCommonQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet>;
};


export type BabyEntryPageEntryPageCommonQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageEntryPageCommonQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageEntryPageCommonQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyEntryPageEntryPageCommonQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemOrderByInput>;
};

export type BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItem = {
  __typename?: 'BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet = {
  __typename?: 'BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyEntryPageEntryPageCommonQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<BabyEntryPageEntryPageCommonQuestionBaseValidationMessageItemWhereInput>;
};

export type BabyEntryPageEntryPageCommonWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  SsnQuestion?: InputMaybe<BabyEntryPageEntryPageCommonQuestionBaseWhereInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Terms?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyEntryPageFacet = {
  __typename?: 'BabyEntryPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BabyMotherSsn?: Maybe<BabyEntryPageQuestionBaseFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EntryPageCommon?: Maybe<BabyEntryPageEntryPageCommonFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExpectedDateOfBirth?: Maybe<BabyEntryPageQuestionBaseFacet>;
  InsuredParty?: Maybe<BabyEntryPageQuestionBaseFacet>;
  InsuredPartyIsMother?: Maybe<Array<Maybe<StringFacet>>>;
  InsuredPartyIsNotMother?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BabyEntryPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyEntryPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyEntryPageFacetInsuredPartyIsMotherArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetInsuredPartyIsNotMotherArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyEntryPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyEntryPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyEntryPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BabyEntryPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BabyMotherSsn?: InputMaybe<BabyEntryPageQuestionBaseOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EntryPageCommon?: InputMaybe<BabyEntryPageEntryPageCommonOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExpectedDateOfBirth?: InputMaybe<BabyEntryPageQuestionBaseOrderByInput>;
  InsuredParty?: InputMaybe<BabyEntryPageQuestionBaseOrderByInput>;
  InsuredPartyIsMother?: InputMaybe<OrderBy>;
  InsuredPartyIsNotMother?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BabyEntryPageOutput = {
  __typename?: 'BabyEntryPageOutput';
  autocomplete?: Maybe<BabyEntryPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BabyEntryPageFacet>;
  item?: Maybe<BabyEntryPage>;
  items?: Maybe<Array<Maybe<BabyEntryPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BabyEntryPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BabyEntryPageQuestionBase = {
  __typename?: 'BabyEntryPageQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<BabyEntryPageQuestionBaseValidationMessageItem>>>;
};


export type BabyEntryPageQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyEntryPageQuestionBaseFacet = {
  __typename?: 'BabyEntryPageQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<BabyEntryPageQuestionBaseValidationMessageItemFacet>;
};


export type BabyEntryPageQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyEntryPageQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<BabyEntryPageQuestionBaseValidationMessageItemOrderByInput>;
};

export type BabyEntryPageQuestionBaseValidationMessageItem = {
  __typename?: 'BabyEntryPageQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type BabyEntryPageQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyEntryPageQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyEntryPageQuestionBaseValidationMessageItemFacet = {
  __typename?: 'BabyEntryPageQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyEntryPageQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyEntryPageQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyEntryPageQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type BabyEntryPageQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyEntryPageQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<BabyEntryPageQuestionBaseValidationMessageItemWhereInput>;
};

export type BabyEntryPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BabyMotherSsn?: InputMaybe<BabyEntryPageQuestionBaseWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EntryPageCommon?: InputMaybe<BabyEntryPageEntryPageCommonWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExpectedDateOfBirth?: InputMaybe<BabyEntryPageQuestionBaseWhereInput>;
  InsuredParty?: InputMaybe<BabyEntryPageQuestionBaseWhereInput>;
  InsuredPartyIsMother?: InputMaybe<SearchableStringFilterInput>;
  InsuredPartyIsNotMother?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BabyEntryPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BabyEntryPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BabyEntryPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** If BabyPricePage. */
export type BabyPricePage = IContent & IData & {
  __typename?: 'BabyPricePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CustomerBenefitInfoBox?: Maybe<BabyPricePageLabelBase>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** You need to add the following strings to get the formatting to work in the client, {{pregnancy}} for the Pregnancy Insurance amount and {{child}} for the Child Insurance amount */
  FirstYearInfoBox?: Maybe<BabyPricePageLabelBase>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PricePageCommon?: Maybe<BabyPricePagePricePageCommon>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopQuestionsTitle?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** If BabyPricePage. */
export type BabyPricePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** If BabyPricePage. */
export type BabyPricePageTopQuestionsTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** If BabyPricePage. */
export type BabyPricePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** If BabyPricePage. */
export type BabyPricePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BabyPricePageAutocomplete = {
  __typename?: 'BabyPricePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PricePageCommon?: Maybe<BabyPricePagePricePageCommonAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BabyPricePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BabyPricePageFacet = {
  __typename?: 'BabyPricePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CustomerBenefitInfoBox?: Maybe<BabyPricePageLabelBaseFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstYearInfoBox?: Maybe<BabyPricePageLabelBaseFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PricePageCommon?: Maybe<BabyPricePagePricePageCommonFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BabyPricePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyPricePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyPricePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyPricePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyPricePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyPricePageFacetTopQuestionsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BabyPricePageLabelBase = {
  __typename?: 'BabyPricePageLabelBase';
  Content?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
};


export type BabyPricePageLabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePageLabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePageLabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyPricePageLabelBaseFacet = {
  __typename?: 'BabyPricePageLabelBaseFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyPricePageLabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageLabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePageLabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyPricePageLabelBaseOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
};

export type BabyPricePageLabelBaseWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyPricePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CustomerBenefitInfoBox?: InputMaybe<BabyPricePageLabelBaseOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstYearInfoBox?: InputMaybe<BabyPricePageLabelBaseOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PricePageCommon?: InputMaybe<BabyPricePagePricePageCommonOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopQuestionsTitle?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BabyPricePageOutput = {
  __typename?: 'BabyPricePageOutput';
  autocomplete?: Maybe<BabyPricePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BabyPricePageFacet>;
  item?: Maybe<BabyPricePage>;
  items?: Maybe<Array<Maybe<BabyPricePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BabyPricePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BabyPricePagePricePageCommon = {
  __typename?: 'BabyPricePagePricePageCommon';
  AboutBonusesModal?: Maybe<BabyPricePagePricePageCommonLabelBase>;
  AddonNotSelectableText?: Maybe<Scalars['String']['output']>;
  BonusHeaderOptionOne?: Maybe<Scalars['String']['output']>;
  BonusHeaderOptionTwo?: Maybe<Scalars['String']['output']>;
  BonusItems?: Maybe<Array<Maybe<BabyPricePagePricePageCommonBonusItem>>>;
  BonusLabel?: Maybe<Scalars['String']['output']>;
  ContinuePurchaseLoaderText?: Maybe<Scalars['String']['output']>;
  DeductibleAmountSelector?: Maybe<BabyPricePagePricePageCommonLabelBase>;
  EditButtonText?: Maybe<Scalars['String']['output']>;
  ErrorMessageNoSelected?: Maybe<Scalars['String']['output']>;
  FixedPriceText?: Maybe<Scalars['String']['output']>;
  IncludedItemsHeader?: Maybe<Scalars['String']['output']>;
  InsuranceAmountSelector?: Maybe<BabyPricePagePricePageCommonLabelBase>;
  NoCoverageSelectedForAddons?: Maybe<Scalars['String']['output']>;
  NordeaCampaignSummary?: Maybe<BabyPricePagePricePageCommonLabelBase>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  RecalculatingLoaderText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageTitle?: Maybe<Scalars['String']['output']>;
  SelectAddonsHeader?: Maybe<Scalars['String']['output']>;
  SelectInsuranceAmountText?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TopQuestionsTitle?: Maybe<Scalars['String']['output']>;
};


export type BabyPricePagePricePageCommonAddonNotSelectableTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonBonusHeaderOptionOneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonBonusHeaderOptionTwoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonBonusLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonContinuePurchaseLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonEditButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonFixedPriceTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonIncludedItemsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonRecalculatingLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonRecommendedCoverageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonRecommendedCoverageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonSelectAddonsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyPricePagePricePageCommonAutocomplete = {
  __typename?: 'BabyPricePagePricePageCommonAutocomplete';
  ErrorMessageNoSelected?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BabyPricePagePricePageCommonAutocompleteErrorMessageNoSelectedArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePagePricePageCommonAutocompleteNoCoverageSelectedForAddonsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePagePricePageCommonAutocompleteSelectInsuranceAmountTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyPricePagePricePageCommonAutocompleteTopQuestionsTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BabyPricePagePricePageCommonBonusItem = {
  __typename?: 'BabyPricePagePricePageCommonBonusItem';
  Label?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type BabyPricePagePricePageCommonBonusItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonBonusItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyPricePagePricePageCommonBonusItemFacet = {
  __typename?: 'BabyPricePagePricePageCommonBonusItemFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyPricePagePricePageCommonBonusItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonBonusItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyPricePagePricePageCommonBonusItemOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type BabyPricePagePricePageCommonBonusItemWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyPricePagePricePageCommonFacet = {
  __typename?: 'BabyPricePagePricePageCommonFacet';
  AboutBonusesModal?: Maybe<BabyPricePagePricePageCommonLabelBaseFacet>;
  AddonNotSelectableText?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionOne?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionTwo?: Maybe<Array<Maybe<StringFacet>>>;
  BonusItems?: Maybe<BabyPricePagePricePageCommonBonusItemFacet>;
  BonusLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContinuePurchaseLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  DeductibleAmountSelector?: Maybe<BabyPricePagePricePageCommonLabelBaseFacet>;
  EditButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorMessageNoSelected?: Maybe<Array<Maybe<StringFacet>>>;
  FixedPriceText?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedItemsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  InsuranceAmountSelector?: Maybe<BabyPricePagePricePageCommonLabelBaseFacet>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignSummary?: Maybe<BabyPricePagePricePageCommonLabelBaseFacet>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RecalculatingLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SelectAddonsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyPricePagePricePageCommonFacetAddonNotSelectableTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetBonusHeaderOptionOneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetBonusHeaderOptionTwoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetBonusLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetContinuePurchaseLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetEditButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetErrorMessageNoSelectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetFixedPriceTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetIncludedItemsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetNoCoverageSelectedForAddonsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetRecalculatingLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetRecommendedCoverageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetRecommendedCoverageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetSelectAddonsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetSelectInsuranceAmountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonFacetTopQuestionsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyPricePagePricePageCommonLabelBase = {
  __typename?: 'BabyPricePagePricePageCommonLabelBase';
  Content?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
};


export type BabyPricePagePricePageCommonLabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonLabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyPricePagePricePageCommonLabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyPricePagePricePageCommonLabelBaseFacet = {
  __typename?: 'BabyPricePagePricePageCommonLabelBaseFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyPricePagePricePageCommonLabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonLabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyPricePagePricePageCommonLabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyPricePagePricePageCommonLabelBaseOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
};

export type BabyPricePagePricePageCommonLabelBaseWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyPricePagePricePageCommonOrderByInput = {
  AboutBonusesModal?: InputMaybe<BabyPricePagePricePageCommonLabelBaseOrderByInput>;
  AddonNotSelectableText?: InputMaybe<OrderBy>;
  BonusHeaderOptionOne?: InputMaybe<OrderBy>;
  BonusHeaderOptionTwo?: InputMaybe<OrderBy>;
  BonusItems?: InputMaybe<BabyPricePagePricePageCommonBonusItemOrderByInput>;
  BonusLabel?: InputMaybe<OrderBy>;
  ContinuePurchaseLoaderText?: InputMaybe<OrderBy>;
  DeductibleAmountSelector?: InputMaybe<BabyPricePagePricePageCommonLabelBaseOrderByInput>;
  EditButtonText?: InputMaybe<OrderBy>;
  ErrorMessageNoSelected?: InputMaybe<OrderBy>;
  FixedPriceText?: InputMaybe<OrderBy>;
  IncludedItemsHeader?: InputMaybe<OrderBy>;
  InsuranceAmountSelector?: InputMaybe<BabyPricePagePricePageCommonLabelBaseOrderByInput>;
  NoCoverageSelectedForAddons?: InputMaybe<OrderBy>;
  NordeaCampaignSummary?: InputMaybe<BabyPricePagePricePageCommonLabelBaseOrderByInput>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  RecalculatingLoaderText?: InputMaybe<OrderBy>;
  RecommendedCoverageText?: InputMaybe<OrderBy>;
  RecommendedCoverageTitle?: InputMaybe<OrderBy>;
  SelectAddonsHeader?: InputMaybe<OrderBy>;
  SelectInsuranceAmountText?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopQuestionsTitle?: InputMaybe<OrderBy>;
};

export type BabyPricePagePricePageCommonWhereInput = {
  AboutBonusesModal?: InputMaybe<BabyPricePagePricePageCommonLabelBaseWhereInput>;
  AddonNotSelectableText?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionOne?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionTwo?: InputMaybe<SearchableStringFilterInput>;
  BonusItems?: InputMaybe<BabyPricePagePricePageCommonBonusItemWhereInput>;
  BonusLabel?: InputMaybe<SearchableStringFilterInput>;
  ContinuePurchaseLoaderText?: InputMaybe<SearchableStringFilterInput>;
  DeductibleAmountSelector?: InputMaybe<BabyPricePagePricePageCommonLabelBaseWhereInput>;
  EditButtonText?: InputMaybe<SearchableStringFilterInput>;
  ErrorMessageNoSelected?: InputMaybe<StringFilterInput>;
  FixedPriceText?: InputMaybe<SearchableStringFilterInput>;
  IncludedItemsHeader?: InputMaybe<SearchableStringFilterInput>;
  InsuranceAmountSelector?: InputMaybe<BabyPricePagePricePageCommonLabelBaseWhereInput>;
  NoCoverageSelectedForAddons?: InputMaybe<StringFilterInput>;
  NordeaCampaignSummary?: InputMaybe<BabyPricePagePricePageCommonLabelBaseWhereInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  RecalculatingLoaderText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageTitle?: InputMaybe<SearchableStringFilterInput>;
  SelectAddonsHeader?: InputMaybe<SearchableStringFilterInput>;
  SelectInsuranceAmountText?: InputMaybe<StringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopQuestionsTitle?: InputMaybe<StringFilterInput>;
};

export type BabyPricePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CustomerBenefitInfoBox?: InputMaybe<BabyPricePageLabelBaseWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstYearInfoBox?: InputMaybe<BabyPricePageLabelBaseWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PricePageCommon?: InputMaybe<BabyPricePagePricePageCommonWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopQuestionsTitle?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BabyPricePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BabyPricePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BabyPricePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Top questions For baby products */
export type BabyTopQuestionsPage = IContent & IData & {
  __typename?: 'BabyTopQuestionsPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopQuestionsCommon?: Maybe<BabyTopQuestionsPageTopQuestionsCommon>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Top questions For baby products */
export type BabyTopQuestionsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For baby products */
export type BabyTopQuestionsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For baby products */
export type BabyTopQuestionsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BabyTopQuestionsPageAutocomplete = {
  __typename?: 'BabyTopQuestionsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BabyTopQuestionsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BabyTopQuestionsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BabyTopQuestionsPageFacet = {
  __typename?: 'BabyTopQuestionsPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopQuestionsCommon?: Maybe<BabyTopQuestionsPageTopQuestionsCommonFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BabyTopQuestionsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyTopQuestionsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyTopQuestionsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyTopQuestionsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyTopQuestionsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BabyTopQuestionsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BabyTopQuestionsPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopQuestionsCommon?: InputMaybe<BabyTopQuestionsPageTopQuestionsCommonOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BabyTopQuestionsPageOutput = {
  __typename?: 'BabyTopQuestionsPageOutput';
  autocomplete?: Maybe<BabyTopQuestionsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BabyTopQuestionsPageFacet>;
  item?: Maybe<BabyTopQuestionsPage>;
  items?: Maybe<Array<Maybe<BabyTopQuestionsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BabyTopQuestionsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BabyTopQuestionsPageTopQuestionsCommon = {
  __typename?: 'BabyTopQuestionsPageTopQuestionsCommon';
  FormTitle?: Maybe<Scalars['String']['output']>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type BabyTopQuestionsPageTopQuestionsCommonFormTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyTopQuestionsPageTopQuestionsCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyTopQuestionsPageTopQuestionsCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type BabyTopQuestionsPageTopQuestionsCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type BabyTopQuestionsPageTopQuestionsCommonFacet = {
  __typename?: 'BabyTopQuestionsPageTopQuestionsCommonFacet';
  FormTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BabyTopQuestionsPageTopQuestionsCommonFacetFormTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageTopQuestionsCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageTopQuestionsCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BabyTopQuestionsPageTopQuestionsCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BabyTopQuestionsPageTopQuestionsCommonOrderByInput = {
  FormTitle?: InputMaybe<OrderBy>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type BabyTopQuestionsPageTopQuestionsCommonWhereInput = {
  FormTitle?: InputMaybe<SearchableStringFilterInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type BabyTopQuestionsPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopQuestionsCommon?: InputMaybe<BabyTopQuestionsPageTopQuestionsCommonWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BabyTopQuestionsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BabyTopQuestionsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BabyTopQuestionsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A bonus item describing a specific bonus. */
export type BonusItem = IContent & IData & {
  __typename?: 'BonusItem';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** Bonus text */
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** The actual bonus value */
  Value?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A bonus item describing a specific bonus. */
export type BonusItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A bonus item describing a specific bonus. */
export type BonusItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A bonus item describing a specific bonus. */
export type BonusItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A bonus item describing a specific bonus. */
export type BonusItem_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A bonus item describing a specific bonus. */
export type BonusItem_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type BonusItemAutocomplete = {
  __typename?: 'BonusItemAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BonusItemAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BonusItemAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BonusItemFacet = {
  __typename?: 'BonusItemFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type BonusItemFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BonusItemFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BonusItemFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BonusItemFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BonusItemFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type BonusItemFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BonusItemFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type BonusItemOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type BonusItemOutput = {
  __typename?: 'BonusItemOutput';
  autocomplete?: Maybe<BonusItemAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<BonusItemFacet>;
  item?: Maybe<BonusItem>;
  items?: Maybe<Array<Maybe<BonusItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type BonusItemOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BonusItemWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<BonusItemWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<BonusItemWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<BonusItemWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type BoolFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A generic button */
export type ButtonBase = IContent & IData & {
  __typename?: 'ButtonBase';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A generic button */
export type ButtonBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic button */
export type ButtonBaseNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic button */
export type ButtonBase_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic button */
export type ButtonBase_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ButtonBaseAutocomplete = {
  __typename?: 'ButtonBaseAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ButtonBaseAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonBaseAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonBaseFacet = {
  __typename?: 'ButtonBaseFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ButtonBaseFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonBaseFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonBaseFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonBaseFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonBaseFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonBaseFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonBaseFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ButtonBaseOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ButtonBaseOutput = {
  __typename?: 'ButtonBaseOutput';
  autocomplete?: Maybe<ButtonBaseAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ButtonBaseFacet>;
  item?: Maybe<ButtonBase>;
  items?: Maybe<Array<Maybe<ButtonBase>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ButtonBaseOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonBaseWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ButtonBaseWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ButtonBaseWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ButtonBaseWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Campaign Card Content */
export type CampaignCardContent = IContent & IData & {
  __typename?: 'CampaignCardContent';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Content Text */
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Header Text */
  Header?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** Modal Content Text */
  ModalContent?: Maybe<Scalars['String']['output']>;
  /** Modal Label Text */
  ModalLabel?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Tag Text */
  Tag?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Campaign Card Content */
export type CampaignCardContentContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Campaign Card Content */
export type CampaignCardContentHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Campaign Card Content */
export type CampaignCardContentModalContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Campaign Card Content */
export type CampaignCardContentModalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Campaign Card Content */
export type CampaignCardContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Campaign Card Content */
export type CampaignCardContentTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Campaign Card Content */
export type CampaignCardContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Campaign Card Content */
export type CampaignCardContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CampaignCardContentAutocomplete = {
  __typename?: 'CampaignCardContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CampaignCardContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignCardContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CampaignCardContentFacet = {
  __typename?: 'CampaignCardContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Header?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  ModalContent?: Maybe<Array<Maybe<StringFacet>>>;
  ModalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CampaignCardContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignCardContentFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignCardContentFacetHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetModalContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetModalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignCardContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignCardContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignCardContentFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignCardContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CampaignCardContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Header?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  ModalContent?: InputMaybe<OrderBy>;
  ModalLabel?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Tag?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CampaignCardContentOutput = {
  __typename?: 'CampaignCardContentOutput';
  autocomplete?: Maybe<CampaignCardContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CampaignCardContentFacet>;
  item?: Maybe<CampaignCardContent>;
  items?: Maybe<Array<Maybe<CampaignCardContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CampaignCardContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignCardContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Header?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  ModalContent?: InputMaybe<SearchableStringFilterInput>;
  ModalLabel?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CampaignCardContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CampaignCardContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CampaignCardContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type CategoryModel = {
  __typename?: 'CategoryModel';
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type CategoryModelAutocomplete = {
  __typename?: 'CategoryModelAutocomplete';
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CategoryModelAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CategoryModelFacet = {
  __typename?: 'CategoryModelFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CategoryModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CategoryModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CategoryModelOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type CategoryModelWhereInput = {
  Description?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type ChannelTargetItem = {
  __typename?: 'ChannelTargetItem';
  ChannelName?: Maybe<Scalars['String']['output']>;
  ComponentType?: Maybe<Scalars['String']['output']>;
  MfeUrl?: Maybe<Scalars['String']['output']>;
};

export type ChannelTargetItemAutocomplete = {
  __typename?: 'ChannelTargetItemAutocomplete';
  ChannelName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ComponentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MfeUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ChannelTargetItemAutocompleteChannelNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChannelTargetItemAutocompleteComponentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChannelTargetItemAutocompleteMfeUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChannelTargetItemFacet = {
  __typename?: 'ChannelTargetItemFacet';
  ChannelName?: Maybe<Array<Maybe<StringFacet>>>;
  ComponentType?: Maybe<Array<Maybe<StringFacet>>>;
  MfeUrl?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ChannelTargetItemFacetChannelNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChannelTargetItemFacetComponentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChannelTargetItemFacetMfeUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChannelTargetItemOrderByInput = {
  ChannelName?: InputMaybe<OrderBy>;
  ComponentType?: InputMaybe<OrderBy>;
  MfeUrl?: InputMaybe<OrderBy>;
};

export type ChannelTargetItemWhereInput = {
  ChannelName?: InputMaybe<StringFilterInput>;
  ComponentType?: InputMaybe<StringFilterInput>;
  MfeUrl?: InputMaybe<StringFilterInput>;
};

/** Checkout page common */
export type CheckoutPageCommon = IContent & IData & {
  __typename?: 'CheckoutPageCommon';
  AcceptTermsAdditionalInfo?: Maybe<Scalars['String']['output']>;
  AcceptTermsAndConditionsQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BadCreditErrorMessage?: Maybe<Scalars['String']['output']>;
  BadCreditErrorTitle?: Maybe<Scalars['String']['output']>;
  BillingFrequencyQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  BillingHeader?: Maybe<Scalars['String']['output']>;
  BillingInfoAnnualTextMyPagesInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoAnnualTextPaperInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoMonthlyTextMyPagesInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoMonthlyTextPaperInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoQuarterSemiAnnualTextMyPagesInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoQuarterSemiAnnualTextPaperInvoice?: Maybe<Scalars['String']['output']>;
  BillingInformation?: Maybe<Scalars['String']['output']>;
  BillingMethodQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CityQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  CompletePurchaseLoadingText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EmailQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstNameQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  InvoicingExistingCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingFrequency12Months?: Maybe<Scalars['String']['output']>;
  InvoicingMethodMyPages?: Maybe<Scalars['String']['output']>;
  InvoicingMethodPaper?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastNameQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  MarketingConsentRequired?: Maybe<Scalars['String']['output']>;
  MarketingDescription?: Maybe<Scalars['String']['output']>;
  MarketingHeader?: Maybe<Scalars['String']['output']>;
  MarketingNoLabel?: Maybe<Scalars['String']['output']>;
  MarketingYesLabel?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MobilePhoneNumberQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  Name?: Maybe<Scalars['String']['output']>;
  NordeaUnderCtaText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PostalCodeQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  PricePageLinkText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SsnMismatchErrorMessage?: Maybe<Scalars['String']['output']>;
  SsnMismatchErrorTitle?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  StreetAddressQuestion?: Maybe<CheckoutPageCommonQuestionBase>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Checkout page common */
export type CheckoutPageCommonAcceptTermsAdditionalInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBadCreditErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBadCreditErrorTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBillingHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBillingInfoAnnualTextMyPagesInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBillingInfoAnnualTextPaperInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBillingInfoMonthlyTextMyPagesInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBillingInfoMonthlyTextPaperInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBillingInfoQuarterSemiAnnualTextMyPagesInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBillingInfoQuarterSemiAnnualTextPaperInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonBillingInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonCompletePurchaseLoadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonInvoicingExistingCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonInvoicingFrequency12MonthsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonInvoicingMethodMyPagesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonInvoicingMethodPaperArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonMarketingConsentRequiredArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonMarketingDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonMarketingHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonMarketingNoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonMarketingYesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonNordeaUnderCtaTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonPricePageLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonSsnMismatchErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonSsnMismatchErrorTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommon_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Checkout page common */
export type CheckoutPageCommon_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CheckoutPageCommonAutocomplete = {
  __typename?: 'CheckoutPageCommonAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CheckoutPageCommonAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CheckoutPageCommonAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CheckoutPageCommonFacet = {
  __typename?: 'CheckoutPageCommonFacet';
  AcceptTermsAdditionalInfo?: Maybe<Array<Maybe<StringFacet>>>;
  AcceptTermsAndConditionsQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BadCreditErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  BadCreditErrorTitle?: Maybe<Array<Maybe<StringFacet>>>;
  BillingFrequencyQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  BillingHeader?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoAnnualTextMyPagesInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoAnnualTextPaperInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoMonthlyTextMyPagesInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoMonthlyTextPaperInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoQuarterSemiAnnualTextMyPagesInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoQuarterSemiAnnualTextPaperInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInformation?: Maybe<Array<Maybe<StringFacet>>>;
  BillingMethodQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CityQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  CompletePurchaseLoadingText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmailQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstNameQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  InvoicingExistingCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingFrequency12Months?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingMethodMyPages?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingMethodPaper?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastNameQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  MarketingConsentRequired?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingNoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingYesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MobilePhoneNumberQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaUnderCtaText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostalCodeQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  PricePageLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SsnMismatchErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  SsnMismatchErrorTitle?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StreetAddressQuestion?: Maybe<CheckoutPageCommonQuestionBaseFacet>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CheckoutPageCommonFacetAcceptTermsAdditionalInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBadCreditErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBadCreditErrorTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBillingHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBillingInfoAnnualTextMyPagesInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBillingInfoAnnualTextPaperInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBillingInfoMonthlyTextMyPagesInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBillingInfoMonthlyTextPaperInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBillingInfoQuarterSemiAnnualTextMyPagesInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBillingInfoQuarterSemiAnnualTextPaperInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetBillingInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CheckoutPageCommonFacetCompletePurchaseLoadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CheckoutPageCommonFacetInvoicingExistingCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetInvoicingFrequency12MonthsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetInvoicingMethodMyPagesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetInvoicingMethodPaperArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetMarketingConsentRequiredArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetMarketingDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetMarketingHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetMarketingNoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetMarketingYesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetNordeaUnderCtaTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetPricePageLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CheckoutPageCommonFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetSsnMismatchErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetSsnMismatchErrorTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CheckoutPageCommonFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CheckoutPageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CheckoutPageCommonOrderByInput = {
  AcceptTermsAdditionalInfo?: InputMaybe<OrderBy>;
  AcceptTermsAndConditionsQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  BadCreditErrorMessage?: InputMaybe<OrderBy>;
  BadCreditErrorTitle?: InputMaybe<OrderBy>;
  BillingFrequencyQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  BillingHeader?: InputMaybe<OrderBy>;
  BillingInfoAnnualTextMyPagesInvoice?: InputMaybe<OrderBy>;
  BillingInfoAnnualTextPaperInvoice?: InputMaybe<OrderBy>;
  BillingInfoMonthlyTextMyPagesInvoice?: InputMaybe<OrderBy>;
  BillingInfoMonthlyTextPaperInvoice?: InputMaybe<OrderBy>;
  BillingInfoQuarterSemiAnnualTextMyPagesInvoice?: InputMaybe<OrderBy>;
  BillingInfoQuarterSemiAnnualTextPaperInvoice?: InputMaybe<OrderBy>;
  BillingInformation?: InputMaybe<OrderBy>;
  BillingMethodQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CityQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  CompletePurchaseLoadingText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EmailQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstNameQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  InvoicingExistingCustomer?: InputMaybe<OrderBy>;
  InvoicingFrequency12Months?: InputMaybe<OrderBy>;
  InvoicingMethodMyPages?: InputMaybe<OrderBy>;
  InvoicingMethodPaper?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastNameQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  MarketingConsentRequired?: InputMaybe<OrderBy>;
  MarketingDescription?: InputMaybe<OrderBy>;
  MarketingHeader?: InputMaybe<OrderBy>;
  MarketingNoLabel?: InputMaybe<OrderBy>;
  MarketingYesLabel?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MobilePhoneNumberQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NordeaUnderCtaText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostalCodeQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  PricePageLinkText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SsnMismatchErrorMessage?: InputMaybe<OrderBy>;
  SsnMismatchErrorTitle?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  StreetAddressQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseOrderByInput>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CheckoutPageCommonOutput = {
  __typename?: 'CheckoutPageCommonOutput';
  autocomplete?: Maybe<CheckoutPageCommonAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CheckoutPageCommonFacet>;
  item?: Maybe<CheckoutPageCommon>;
  items?: Maybe<Array<Maybe<CheckoutPageCommon>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CheckoutPageCommonOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckoutPageCommonQuestionBase = {
  __typename?: 'CheckoutPageCommonQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<CheckoutPageCommonQuestionBaseValidationMessageItem>>>;
};


export type CheckoutPageCommonQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CheckoutPageCommonQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CheckoutPageCommonQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CheckoutPageCommonQuestionBaseFacet = {
  __typename?: 'CheckoutPageCommonQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<CheckoutPageCommonQuestionBaseValidationMessageItemFacet>;
};


export type CheckoutPageCommonQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CheckoutPageCommonQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<CheckoutPageCommonQuestionBaseValidationMessageItemOrderByInput>;
};

export type CheckoutPageCommonQuestionBaseValidationMessageItem = {
  __typename?: 'CheckoutPageCommonQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type CheckoutPageCommonQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CheckoutPageCommonQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type CheckoutPageCommonQuestionBaseValidationMessageItemFacet = {
  __typename?: 'CheckoutPageCommonQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CheckoutPageCommonQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CheckoutPageCommonQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CheckoutPageCommonQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type CheckoutPageCommonQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type CheckoutPageCommonQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<CheckoutPageCommonQuestionBaseValidationMessageItemWhereInput>;
};

export type CheckoutPageCommonWhereInput = {
  AcceptTermsAdditionalInfo?: InputMaybe<SearchableStringFilterInput>;
  AcceptTermsAndConditionsQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BadCreditErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  BadCreditErrorTitle?: InputMaybe<SearchableStringFilterInput>;
  BillingFrequencyQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  BillingHeader?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoAnnualTextMyPagesInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoAnnualTextPaperInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoMonthlyTextMyPagesInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoMonthlyTextPaperInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoQuarterSemiAnnualTextMyPagesInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoQuarterSemiAnnualTextPaperInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInformation?: InputMaybe<SearchableStringFilterInput>;
  BillingMethodQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CityQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  CompletePurchaseLoadingText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmailQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstNameQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  InvoicingExistingCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingFrequency12Months?: InputMaybe<SearchableStringFilterInput>;
  InvoicingMethodMyPages?: InputMaybe<SearchableStringFilterInput>;
  InvoicingMethodPaper?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastNameQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  MarketingConsentRequired?: InputMaybe<SearchableStringFilterInput>;
  MarketingDescription?: InputMaybe<SearchableStringFilterInput>;
  MarketingHeader?: InputMaybe<SearchableStringFilterInput>;
  MarketingNoLabel?: InputMaybe<SearchableStringFilterInput>;
  MarketingYesLabel?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MobilePhoneNumberQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NordeaUnderCtaText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostalCodeQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  PricePageLinkText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SsnMismatchErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  SsnMismatchErrorTitle?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  StreetAddressQuestion?: InputMaybe<CheckoutPageCommonQuestionBaseWhereInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CheckoutPageCommonWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CheckoutPageCommonWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CheckoutPageCommonWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Confirmation page common */
export type ConfirmationPageCommon = IContent & IData & {
  __typename?: 'ConfirmationPageCommon';
  AboutInsuranceSectionHeaderText?: Maybe<Scalars['String']['output']>;
  AddOnHeaderText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CancellationBlock?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DiscountText?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  InvoicingInfoExistingCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingInfoNewCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingSectionHeader?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LogoutLink?: Maybe<Scalars['String']['output']>;
  LogoutLinkText?: Maybe<Scalars['String']['output']>;
  LogoutText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MyPagesButtonText?: Maybe<Scalars['String']['output']>;
  MyPagesScaluText?: Maybe<Scalars['String']['output']>;
  MyPagesSectionHeader?: Maybe<Scalars['String']['output']>;
  MyPagesText?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  /** Label for the Info about the Nordea Campaign */
  NordeaCampaignInfo?: Maybe<Scalars['String']['output']>;
  PageHeaderText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondaryHeader?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TotalAmount?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Confirmation page common */
export type ConfirmationPageCommonAboutInsuranceSectionHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonAddOnHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonCancellationBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonDiscountTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonInvoicingInfoExistingCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonInvoicingInfoNewCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonInvoicingSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonLogoutLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonLogoutLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonLogoutTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonMyPagesButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonMyPagesScaluTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonMyPagesSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonMyPagesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonNordeaCampaignInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonPageHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonSecondaryHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommonTotalAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommon_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Confirmation page common */
export type ConfirmationPageCommon_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ConfirmationPageCommonAutocomplete = {
  __typename?: 'ConfirmationPageCommonAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ConfirmationPageCommonAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConfirmationPageCommonAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConfirmationPageCommonFacet = {
  __typename?: 'ConfirmationPageCommonFacet';
  AboutInsuranceSectionHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  AddOnHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CancellationBlock?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DiscountText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  InvoicingInfoExistingCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoNewCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LogoutLink?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MyPagesButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesScaluText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesText?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignInfo?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SecondaryHeader?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalAmount?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ConfirmationPageCommonFacetAboutInsuranceSectionHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetAddOnHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetCancellationBlockArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationPageCommonFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationPageCommonFacetDiscountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetInvoicingInfoExistingCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetInvoicingInfoNewCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetInvoicingSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetLogoutLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetLogoutLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetLogoutTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetMyPagesButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetMyPagesScaluTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetMyPagesSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetMyPagesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetNordeaCampaignInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetPageHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationPageCommonFacetSecondaryHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationPageCommonFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationPageCommonFacetTotalAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConfirmationPageCommonFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ConfirmationPageCommonOrderByInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<OrderBy>;
  AddOnHeaderText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  CancellationBlock?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DiscountText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  InvoicingInfoExistingCustomer?: InputMaybe<OrderBy>;
  InvoicingInfoNewCustomer?: InputMaybe<OrderBy>;
  InvoicingSectionHeader?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LogoutLink?: InputMaybe<OrderBy>;
  LogoutLinkText?: InputMaybe<OrderBy>;
  LogoutText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MyPagesButtonText?: InputMaybe<OrderBy>;
  MyPagesScaluText?: InputMaybe<OrderBy>;
  MyPagesSectionHeader?: InputMaybe<OrderBy>;
  MyPagesText?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NordeaCampaignInfo?: InputMaybe<OrderBy>;
  PageHeaderText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SecondaryHeader?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalAmount?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ConfirmationPageCommonOutput = {
  __typename?: 'ConfirmationPageCommonOutput';
  autocomplete?: Maybe<ConfirmationPageCommonAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ConfirmationPageCommonFacet>;
  item?: Maybe<ConfirmationPageCommon>;
  items?: Maybe<Array<Maybe<ConfirmationPageCommon>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ConfirmationPageCommonOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfirmationPageCommonWhereInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<SearchableStringFilterInput>;
  AddOnHeaderText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  CancellationBlock?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DiscountText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  InvoicingInfoExistingCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoNewCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LogoutLink?: InputMaybe<SearchableStringFilterInput>;
  LogoutLinkText?: InputMaybe<SearchableStringFilterInput>;
  LogoutText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MyPagesButtonText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesScaluText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  MyPagesText?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NordeaCampaignInfo?: InputMaybe<SearchableStringFilterInput>;
  PageHeaderText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SecondaryHeader?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalAmount?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ConfirmationPageCommonWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ConfirmationPageCommonWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ConfirmationPageCommonWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Content = IContent & IData & {
  __typename?: 'Content';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Content_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Content_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentAreaItemModelSearch = {
  __typename?: 'ContentAreaItemModelSearch';
  ContentLink?: Maybe<ContentModelReferenceSearch>;
  DisplayOption?: Maybe<Scalars['String']['output']>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearch>;
  Tag?: Maybe<Scalars['String']['output']>;
};


export type ContentAreaItemModelSearchContentLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchDisplayOptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchInlineBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentAreaItemModelSearchFacet = {
  __typename?: 'ContentAreaItemModelSearchFacet';
  ContentLink?: Maybe<ContentModelReferenceSearchFacet>;
  DisplayOption?: Maybe<Array<Maybe<StringFacet>>>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearchFacet>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentAreaItemModelSearchFacetDisplayOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentAreaItemModelSearchFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentAreaItemModelSearchOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchOrderByInput>;
  DisplayOption?: InputMaybe<OrderBy>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchOrderByInput>;
  Tag?: InputMaybe<OrderBy>;
};

export type ContentAreaItemModelSearchWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchWhereInput>;
  DisplayOption?: InputMaybe<SearchableStringFilterInput>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchWhereInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentAutocomplete = {
  __typename?: 'ContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentFacet = {
  __typename?: 'ContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentLanguageModel = {
  __typename?: 'ContentLanguageModel';
  DisplayName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type ContentLanguageModelAutocomplete = {
  __typename?: 'ContentLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Link?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentLanguageModelAutocompleteLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentLanguageModelFacet = {
  __typename?: 'ContentLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearch = {
  __typename?: 'ContentLanguageModelSearch';
  DisplayName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};


export type ContentLanguageModelSearchDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentLanguageModelSearchLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentLanguageModelSearchNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentLanguageModelSearchFacet = {
  __typename?: 'ContentLanguageModelSearchFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentLanguageModelSearchFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelSearchFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelSearchFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelSearchOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearchWhereInput = {
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  Link?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type ContentModelReference = {
  __typename?: 'ContentModelReference';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  ProviderName?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WorkId?: Maybe<Scalars['Int']['output']>;
};

export type ContentModelReferenceAutocomplete = {
  __typename?: 'ContentModelReferenceAutocomplete';
  GuidValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  ProviderName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentModelReferenceAutocompleteGuidValueArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentModelReferenceAutocompleteProviderNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentModelReferenceAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentModelReferenceFacet = {
  __typename?: 'ContentModelReferenceFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentModelReferenceFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContentModelReferenceFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearch = {
  __typename?: 'ContentModelReferenceSearch';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModelSearch>;
  ProviderName?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WorkId?: Maybe<Scalars['Int']['output']>;
};


export type ContentModelReferenceSearchExpandedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchProviderNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentModelReferenceSearchFacet = {
  __typename?: 'ContentModelReferenceSearchFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelSearchFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentModelReferenceSearchFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContentModelReferenceSearchFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceSearchOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelSearchOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearchWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelSearchWhereInput>;
  ProviderName?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<SearchableStringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentModelReferenceWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  ProviderName?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ContentOutput = {
  __typename?: 'ContentOutput';
  autocomplete?: Maybe<ContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentFacet>;
  item?: Maybe<IContent>;
  items?: Maybe<Array<Maybe<IContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentRootsModel = {
  __typename?: 'ContentRootsModel';
  ContentAssetsRoot?: Maybe<ContentModelReference>;
  GlobalAssetsRoot?: Maybe<ContentModelReference>;
  RootPage?: Maybe<ContentModelReference>;
  SiteAssetsRoot?: Maybe<ContentModelReference>;
  StartPage?: Maybe<ContentModelReference>;
  WasteBasket?: Maybe<ContentModelReference>;
};

export type ContentRootsModelAutocomplete = {
  __typename?: 'ContentRootsModelAutocomplete';
  ContentAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  RootPage?: Maybe<ContentModelReferenceAutocomplete>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  StartPage?: Maybe<ContentModelReferenceAutocomplete>;
  WasteBasket?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ContentRootsModelFacet = {
  __typename?: 'ContentRootsModelFacet';
  ContentAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  RootPage?: Maybe<ContentModelReferenceFacet>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  StartPage?: Maybe<ContentModelReferenceFacet>;
  WasteBasket?: Maybe<ContentModelReferenceFacet>;
};

export type ContentRootsModelOrderByInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  RootPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type ContentRootsModelWhereInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  RootPage?: InputMaybe<ContentModelReferenceWhereInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPage?: InputMaybe<ContentModelReferenceWhereInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type ContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A Coverage That Is Unique Per Product */
export type Coverage = IContent & IData & {
  __typename?: 'Coverage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Core Name */
  CoreName?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Description visible in the price matrix */
  Description?: Maybe<Scalars['String']['output']>;
  /** Display Name */
  DisplayName?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Is this coverage a fixed price, paid once(travel fixed for example)? */
  FixedPrice?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Is this the recommended coverage? */
  Recommended?: Maybe<Scalars['Bool']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** Order relative to other coverages */
  SortOrder?: Maybe<Scalars['Int']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A Coverage That Is Unique Per Product */
export type CoverageCoreNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Coverage That Is Unique Per Product */
export type CoverageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Coverage That Is Unique Per Product */
export type CoverageDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Coverage That Is Unique Per Product */
export type CoverageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Coverage That Is Unique Per Product */
export type Coverage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A Coverage That Is Unique Per Product */
export type Coverage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CoverageAutocomplete = {
  __typename?: 'CoverageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CoverageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CoverageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CoverageFacet = {
  __typename?: 'CoverageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CoreName?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FixedPrice?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Recommended?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CoverageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CoverageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetCoreNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CoverageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetFixedPriceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetRecommendedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CoverageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetSortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CoverageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CoverageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CoverageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CoverageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CoverageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CoreName?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisplayName?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FixedPrice?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Recommended?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SortOrder?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CoverageOutput = {
  __typename?: 'CoverageOutput';
  autocomplete?: Maybe<CoverageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CoverageFacet>;
  item?: Maybe<Coverage>;
  items?: Maybe<Array<Maybe<Coverage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CoverageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CoverageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CoreName?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FixedPrice?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Recommended?: InputMaybe<BoolFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SortOrder?: InputMaybe<IntFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CoverageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CoverageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CoverageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Cube Discount Content */
export type CubeDiscountContent = IContent & IData & {
  __typename?: 'CubeDiscountContent';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** Modal Text */
  ModalText?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Title */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Cube Discount Content */
export type CubeDiscountContentModalTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Cube Discount Content */
export type CubeDiscountContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Cube Discount Content */
export type CubeDiscountContentTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Cube Discount Content */
export type CubeDiscountContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Cube Discount Content */
export type CubeDiscountContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CubeDiscountContentAutocomplete = {
  __typename?: 'CubeDiscountContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CubeDiscountContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CubeDiscountContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CubeDiscountContentFacet = {
  __typename?: 'CubeDiscountContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  ModalText?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CubeDiscountContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CubeDiscountContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CubeDiscountContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetModalTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CubeDiscountContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CubeDiscountContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CubeDiscountContentFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CubeDiscountContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CubeDiscountContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  ModalText?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CubeDiscountContentOutput = {
  __typename?: 'CubeDiscountContentOutput';
  autocomplete?: Maybe<CubeDiscountContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CubeDiscountContentFacet>;
  item?: Maybe<CubeDiscountContent>;
  items?: Maybe<Array<Maybe<CubeDiscountContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CubeDiscountContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CubeDiscountContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  ModalText?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CubeDiscountContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CubeDiscountContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CubeDiscountContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Suffix for Month and Year When Displaying A Currency With A Period */
export type CurrencyPeriodSuffix = IContent & IData & {
  __typename?: 'CurrencyPeriodSuffix';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  /** A Month Period */
  Month?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** A Year Period */
  Year?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Suffix for Month and Year When Displaying A Currency With A Period */
export type CurrencyPeriodSuffixMonthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Suffix for Month and Year When Displaying A Currency With A Period */
export type CurrencyPeriodSuffixNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Suffix for Month and Year When Displaying A Currency With A Period */
export type CurrencyPeriodSuffixYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Suffix for Month and Year When Displaying A Currency With A Period */
export type CurrencyPeriodSuffix_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Suffix for Month and Year When Displaying A Currency With A Period */
export type CurrencyPeriodSuffix_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CurrencyPeriodSuffixAutocomplete = {
  __typename?: 'CurrencyPeriodSuffixAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CurrencyPeriodSuffixAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CurrencyPeriodSuffixAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CurrencyPeriodSuffixFacet = {
  __typename?: 'CurrencyPeriodSuffixFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Month?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Year?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type CurrencyPeriodSuffixFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrencyPeriodSuffixFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrencyPeriodSuffixFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetMonthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrencyPeriodSuffixFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrencyPeriodSuffixFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrencyPeriodSuffixFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacetYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CurrencyPeriodSuffixFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type CurrencyPeriodSuffixOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Month?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Year?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type CurrencyPeriodSuffixOutput = {
  __typename?: 'CurrencyPeriodSuffixOutput';
  autocomplete?: Maybe<CurrencyPeriodSuffixAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CurrencyPeriodSuffixFacet>;
  item?: Maybe<CurrencyPeriodSuffix>;
  items?: Maybe<Array<Maybe<CurrencyPeriodSuffix>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CurrencyPeriodSuffixOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CurrencyPeriodSuffixWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Month?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Year?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CurrencyPeriodSuffixWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CurrencyPeriodSuffixWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CurrencyPeriodSuffixWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Data = IData & {
  __typename?: 'Data';
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type Data_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Data_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DataOrderByInput = {
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DataOutput = {
  __typename?: 'DataOutput';
  cursor?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IData>;
  items?: Maybe<Array<Maybe<IData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataWhereInput = {
  _and?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
};

export type DateFacet = {
  __typename?: 'DateFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum DateFacetUnit {
  /** Defined as 24 hours (86,400,000 milliseconds). All days begin at the earliest possible time, which is usually 00:00:00 (midnight). */
  Day = 'DAY',
  /** Defined as 60 minutes each (3,600,000 milliseconds). All hours begin at 00 minutes and 00 seconds. */
  Hour = 'HOUR',
  /** Defined as 1000 milliseconds each. */
  Minute = 'MINUTE'
}

export type DateFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `decay` influences the weight of the score with a decay function. For example, results that have a more recent datetime will be ranked higher. The `origin` will be `now()` in case not specified. The `scale` is by default 10. The `rate` must be in the range `[0..1]`. */
  decay?: InputMaybe<Decay>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

/** Decay influences the weight of the score based on field values with a decay function */
export type Decay = {
  origin?: InputMaybe<Scalars['Date']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Int']['input']>;
};

/** Electronic Health Declaration Content */
export type ElectronicHealthDeclerationContent = IContent & IData & {
  __typename?: 'ElectronicHealthDeclerationContent';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** content */
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Title */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Electronic Health Declaration Content */
export type ElectronicHealthDeclerationContentContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Electronic Health Declaration Content */
export type ElectronicHealthDeclerationContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Electronic Health Declaration Content */
export type ElectronicHealthDeclerationContentTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Electronic Health Declaration Content */
export type ElectronicHealthDeclerationContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Electronic Health Declaration Content */
export type ElectronicHealthDeclerationContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ElectronicHealthDeclerationContentAutocomplete = {
  __typename?: 'ElectronicHealthDeclerationContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ElectronicHealthDeclerationContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ElectronicHealthDeclerationContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ElectronicHealthDeclerationContentFacet = {
  __typename?: 'ElectronicHealthDeclerationContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ElectronicHealthDeclerationContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ElectronicHealthDeclerationContentFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ElectronicHealthDeclerationContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ElectronicHealthDeclerationContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ElectronicHealthDeclerationContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ElectronicHealthDeclerationContentFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ElectronicHealthDeclerationContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ElectronicHealthDeclerationContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ElectronicHealthDeclerationContentOutput = {
  __typename?: 'ElectronicHealthDeclerationContentOutput';
  autocomplete?: Maybe<ElectronicHealthDeclerationContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ElectronicHealthDeclerationContentFacet>;
  item?: Maybe<ElectronicHealthDeclerationContent>;
  items?: Maybe<Array<Maybe<ElectronicHealthDeclerationContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ElectronicHealthDeclerationContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ElectronicHealthDeclerationContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ElectronicHealthDeclerationContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ElectronicHealthDeclerationContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ElectronicHealthDeclerationContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Common entry questions */
export type EntryPageCommon = IContent & IData & {
  __typename?: 'EntryPageCommon';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SsnQuestion?: Maybe<EntryPageCommonQuestionBase>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Terms?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Common entry questions */
export type EntryPageCommonDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common entry questions */
export type EntryPageCommonNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common entry questions */
export type EntryPageCommonSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common entry questions */
export type EntryPageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common entry questions */
export type EntryPageCommonTermsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common entry questions */
export type EntryPageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common entry questions */
export type EntryPageCommon_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common entry questions */
export type EntryPageCommon_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EntryPageCommonAutocomplete = {
  __typename?: 'EntryPageCommonAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EntryPageCommonAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EntryPageCommonAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EntryPageCommonFacet = {
  __typename?: 'EntryPageCommonFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SsnQuestion?: Maybe<EntryPageCommonQuestionBaseFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Terms?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type EntryPageCommonFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EntryPageCommonFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EntryPageCommonFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EntryPageCommonFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EntryPageCommonFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EntryPageCommonFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetTermsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type EntryPageCommonOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SsnQuestion?: InputMaybe<EntryPageCommonQuestionBaseOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubTitle?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Terms?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type EntryPageCommonOutput = {
  __typename?: 'EntryPageCommonOutput';
  autocomplete?: Maybe<EntryPageCommonAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EntryPageCommonFacet>;
  item?: Maybe<EntryPageCommon>;
  items?: Maybe<Array<Maybe<EntryPageCommon>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EntryPageCommonOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntryPageCommonQuestionBase = {
  __typename?: 'EntryPageCommonQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<EntryPageCommonQuestionBaseValidationMessageItem>>>;
};


export type EntryPageCommonQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EntryPageCommonQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EntryPageCommonQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EntryPageCommonQuestionBaseFacet = {
  __typename?: 'EntryPageCommonQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<EntryPageCommonQuestionBaseValidationMessageItemFacet>;
};


export type EntryPageCommonQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EntryPageCommonQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<EntryPageCommonQuestionBaseValidationMessageItemOrderByInput>;
};

export type EntryPageCommonQuestionBaseValidationMessageItem = {
  __typename?: 'EntryPageCommonQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type EntryPageCommonQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EntryPageCommonQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type EntryPageCommonQuestionBaseValidationMessageItemFacet = {
  __typename?: 'EntryPageCommonQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EntryPageCommonQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EntryPageCommonQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EntryPageCommonQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type EntryPageCommonQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type EntryPageCommonQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<EntryPageCommonQuestionBaseValidationMessageItemWhereInput>;
};

export type EntryPageCommonWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SsnQuestion?: InputMaybe<EntryPageCommonQuestionBaseWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Terms?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EntryPageCommonWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EntryPageCommonWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EntryPageCommonWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum FactorModifier {
  /** Add 1 to the field value and take the natural logarithm */
  Log = 'LOG',
  /** Do not apply any multiplier to the field value */
  None = 'NONE',
  /** Reciprocate the field value, same as 1/x where x is the field's value */
  Reciprocal = 'RECIPROCAL',
  /** Take the square root of the field value */
  Sqrt = 'SQRT',
  /** Square the field value (multiply it by itself) */
  Square = 'SQUARE'
}

/** Footer content for the website */
export type FooterContent = IContent & IData & {
  __typename?: 'FooterContent';
  AccessibilityStatement?: Maybe<FooterContentLinkTextAndUrl>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Cookies?: Maybe<FooterContentLinkTextAndUrl>;
  Copyright?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  CustomerSupportInfoLabel?: Maybe<Scalars['String']['output']>;
  CustomerSupportInfoOpeningHoursText?: Maybe<Scalars['String']['output']>;
  CustomerSupportInfoPhoneNumberText?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HandlingPersonalData?: Maybe<FooterContentLinkTextAndUrl>;
  IfLogoUrl?: Maybe<Scalars['String']['output']>;
  InLanguage?: Maybe<FooterContentLinkTextAndUrl>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NordeaLogoUrl?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TermsAndCondition?: Maybe<FooterContentLinkTextAndUrl>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Footer content for the website */
export type FooterContentCopyrightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Footer content for the website */
export type FooterContentCustomerSupportInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Footer content for the website */
export type FooterContentCustomerSupportInfoOpeningHoursTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Footer content for the website */
export type FooterContentCustomerSupportInfoPhoneNumberTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Footer content for the website */
export type FooterContentIfLogoUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Footer content for the website */
export type FooterContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Footer content for the website */
export type FooterContentNordeaLogoUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Footer content for the website */
export type FooterContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Footer content for the website */
export type FooterContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FooterContentAutocomplete = {
  __typename?: 'FooterContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FooterContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FooterContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FooterContentFacet = {
  __typename?: 'FooterContentFacet';
  AccessibilityStatement?: Maybe<FooterContentLinkTextAndUrlFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Cookies?: Maybe<FooterContentLinkTextAndUrlFacet>;
  Copyright?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CustomerSupportInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CustomerSupportInfoOpeningHoursText?: Maybe<Array<Maybe<StringFacet>>>;
  CustomerSupportInfoPhoneNumberText?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HandlingPersonalData?: Maybe<FooterContentLinkTextAndUrlFacet>;
  IfLogoUrl?: Maybe<Array<Maybe<StringFacet>>>;
  InLanguage?: Maybe<FooterContentLinkTextAndUrlFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaLogoUrl?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TermsAndCondition?: Maybe<FooterContentLinkTextAndUrlFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type FooterContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetCopyrightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterContentFacetCustomerSupportInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetCustomerSupportInfoOpeningHoursTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetCustomerSupportInfoPhoneNumberTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetIfLogoUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetNordeaLogoUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type FooterContentLinkTextAndUrl = {
  __typename?: 'FooterContentLinkTextAndUrl';
  Text?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
};


export type FooterContentLinkTextAndUrlTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FooterContentLinkTextAndUrlUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type FooterContentLinkTextAndUrlFacet = {
  __typename?: 'FooterContentLinkTextAndUrlFacet';
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FooterContentLinkTextAndUrlFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FooterContentLinkTextAndUrlFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FooterContentLinkTextAndUrlOrderByInput = {
  Text?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
};

export type FooterContentLinkTextAndUrlWhereInput = {
  Text?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<SearchableStringFilterInput>;
};

export type FooterContentOrderByInput = {
  AccessibilityStatement?: InputMaybe<FooterContentLinkTextAndUrlOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Cookies?: InputMaybe<FooterContentLinkTextAndUrlOrderByInput>;
  Copyright?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CustomerSupportInfoLabel?: InputMaybe<OrderBy>;
  CustomerSupportInfoOpeningHoursText?: InputMaybe<OrderBy>;
  CustomerSupportInfoPhoneNumberText?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HandlingPersonalData?: InputMaybe<FooterContentLinkTextAndUrlOrderByInput>;
  IfLogoUrl?: InputMaybe<OrderBy>;
  InLanguage?: InputMaybe<FooterContentLinkTextAndUrlOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NordeaLogoUrl?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TermsAndCondition?: InputMaybe<FooterContentLinkTextAndUrlOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type FooterContentOutput = {
  __typename?: 'FooterContentOutput';
  autocomplete?: Maybe<FooterContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FooterContentFacet>;
  item?: Maybe<FooterContent>;
  items?: Maybe<Array<Maybe<FooterContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FooterContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FooterContentWhereInput = {
  AccessibilityStatement?: InputMaybe<FooterContentLinkTextAndUrlWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Cookies?: InputMaybe<FooterContentLinkTextAndUrlWhereInput>;
  Copyright?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CustomerSupportInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  CustomerSupportInfoOpeningHoursText?: InputMaybe<SearchableStringFilterInput>;
  CustomerSupportInfoPhoneNumberText?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HandlingPersonalData?: InputMaybe<FooterContentLinkTextAndUrlWhereInput>;
  IfLogoUrl?: InputMaybe<SearchableStringFilterInput>;
  InLanguage?: InputMaybe<FooterContentLinkTextAndUrlWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NordeaLogoUrl?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TermsAndCondition?: InputMaybe<FooterContentLinkTextAndUrlWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FooterContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FooterContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FooterContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A page cotaining global content for the webshop that is potentially shared across all pages. */
export type GlobalContentPage = IContent & IData & {
  __typename?: 'GlobalContentPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CloseButton?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CountrySelectPlaceholderText?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  CubeDiscount?: Maybe<GlobalContentPageCubeDiscountContent>;
  ElectronicHealthDecleration?: Maybe<GlobalContentPageElectronicHealthDeclerationContent>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PriceSummarySectionContent?: Maybe<GlobalContentPagePriceSummarySectionContent>;
  ReadMoreLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SuffixForMonthYear?: Maybe<GlobalContentPageCurrencyPeriodSuffix>;
  TermsLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  YesAndNoAnswer?: Maybe<GlobalContentPageYesAndNoAnswerContent>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A page cotaining global content for the webshop that is potentially shared across all pages. */
export type GlobalContentPageCloseButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page cotaining global content for the webshop that is potentially shared across all pages. */
export type GlobalContentPageCountrySelectPlaceholderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page cotaining global content for the webshop that is potentially shared across all pages. */
export type GlobalContentPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page cotaining global content for the webshop that is potentially shared across all pages. */
export type GlobalContentPageReadMoreLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page cotaining global content for the webshop that is potentially shared across all pages. */
export type GlobalContentPageTermsLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page cotaining global content for the webshop that is potentially shared across all pages. */
export type GlobalContentPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page cotaining global content for the webshop that is potentially shared across all pages. */
export type GlobalContentPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type GlobalContentPageAutocomplete = {
  __typename?: 'GlobalContentPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type GlobalContentPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type GlobalContentPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type GlobalContentPageCubeDiscountContent = {
  __typename?: 'GlobalContentPageCubeDiscountContent';
  ModalText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type GlobalContentPageCubeDiscountContentModalTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPageCubeDiscountContentTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalContentPageCubeDiscountContentFacet = {
  __typename?: 'GlobalContentPageCubeDiscountContentFacet';
  ModalText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GlobalContentPageCubeDiscountContentFacetModalTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageCubeDiscountContentFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalContentPageCubeDiscountContentOrderByInput = {
  ModalText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type GlobalContentPageCubeDiscountContentWhereInput = {
  ModalText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type GlobalContentPageCurrencyPeriodSuffix = {
  __typename?: 'GlobalContentPageCurrencyPeriodSuffix';
  Month?: Maybe<Scalars['String']['output']>;
  Year?: Maybe<Scalars['String']['output']>;
};


export type GlobalContentPageCurrencyPeriodSuffixMonthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPageCurrencyPeriodSuffixYearArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalContentPageCurrencyPeriodSuffixFacet = {
  __typename?: 'GlobalContentPageCurrencyPeriodSuffixFacet';
  Month?: Maybe<Array<Maybe<StringFacet>>>;
  Year?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GlobalContentPageCurrencyPeriodSuffixFacetMonthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageCurrencyPeriodSuffixFacetYearArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalContentPageCurrencyPeriodSuffixOrderByInput = {
  Month?: InputMaybe<OrderBy>;
  Year?: InputMaybe<OrderBy>;
};

export type GlobalContentPageCurrencyPeriodSuffixWhereInput = {
  Month?: InputMaybe<SearchableStringFilterInput>;
  Year?: InputMaybe<SearchableStringFilterInput>;
};

export type GlobalContentPageElectronicHealthDeclerationContent = {
  __typename?: 'GlobalContentPageElectronicHealthDeclerationContent';
  Content?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type GlobalContentPageElectronicHealthDeclerationContentContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPageElectronicHealthDeclerationContentTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalContentPageElectronicHealthDeclerationContentFacet = {
  __typename?: 'GlobalContentPageElectronicHealthDeclerationContentFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GlobalContentPageElectronicHealthDeclerationContentFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageElectronicHealthDeclerationContentFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalContentPageElectronicHealthDeclerationContentOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type GlobalContentPageElectronicHealthDeclerationContentWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type GlobalContentPageFacet = {
  __typename?: 'GlobalContentPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CloseButton?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CountrySelectPlaceholderText?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CubeDiscount?: Maybe<GlobalContentPageCubeDiscountContentFacet>;
  ElectronicHealthDecleration?: Maybe<GlobalContentPageElectronicHealthDeclerationContentFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PriceSummarySectionContent?: Maybe<GlobalContentPagePriceSummarySectionContentFacet>;
  ReadMoreLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SuffixForMonthYear?: Maybe<GlobalContentPageCurrencyPeriodSuffixFacet>;
  TermsLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  YesAndNoAnswer?: Maybe<GlobalContentPageYesAndNoAnswerContentFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type GlobalContentPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GlobalContentPageFacetCloseButtonArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetCountrySelectPlaceholderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GlobalContentPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetReadMoreLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GlobalContentPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GlobalContentPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type GlobalContentPageFacetTermsLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type GlobalContentPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CloseButton?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CountrySelectPlaceholderText?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CubeDiscount?: InputMaybe<GlobalContentPageCubeDiscountContentOrderByInput>;
  ElectronicHealthDecleration?: InputMaybe<GlobalContentPageElectronicHealthDeclerationContentOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PriceSummarySectionContent?: InputMaybe<GlobalContentPagePriceSummarySectionContentOrderByInput>;
  ReadMoreLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SuffixForMonthYear?: InputMaybe<GlobalContentPageCurrencyPeriodSuffixOrderByInput>;
  TermsLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  YesAndNoAnswer?: InputMaybe<GlobalContentPageYesAndNoAnswerContentOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type GlobalContentPageOutput = {
  __typename?: 'GlobalContentPageOutput';
  autocomplete?: Maybe<GlobalContentPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<GlobalContentPageFacet>;
  item?: Maybe<GlobalContentPage>;
  items?: Maybe<Array<Maybe<GlobalContentPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type GlobalContentPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GlobalContentPagePriceSummarySectionContent = {
  __typename?: 'GlobalContentPagePriceSummarySectionContent';
  AddonsInfoLabel?: Maybe<Scalars['String']['output']>;
  CheckOutButtonText?: Maybe<Scalars['String']['output']>;
  LoaderCalculationText?: Maybe<Scalars['String']['output']>;
  LoaderCheckoutText?: Maybe<Scalars['String']['output']>;
  PriceLabel?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type GlobalContentPagePriceSummarySectionContentAddonsInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPagePriceSummarySectionContentCheckOutButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPagePriceSummarySectionContentLoaderCalculationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPagePriceSummarySectionContentLoaderCheckoutTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPagePriceSummarySectionContentPriceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPagePriceSummarySectionContentTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalContentPagePriceSummarySectionContentFacet = {
  __typename?: 'GlobalContentPagePriceSummarySectionContentFacet';
  AddonsInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CheckOutButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  LoaderCalculationText?: Maybe<Array<Maybe<StringFacet>>>;
  LoaderCheckoutText?: Maybe<Array<Maybe<StringFacet>>>;
  PriceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GlobalContentPagePriceSummarySectionContentFacetAddonsInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPagePriceSummarySectionContentFacetCheckOutButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPagePriceSummarySectionContentFacetLoaderCalculationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPagePriceSummarySectionContentFacetLoaderCheckoutTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPagePriceSummarySectionContentFacetPriceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPagePriceSummarySectionContentFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalContentPagePriceSummarySectionContentOrderByInput = {
  AddonsInfoLabel?: InputMaybe<OrderBy>;
  CheckOutButtonText?: InputMaybe<OrderBy>;
  LoaderCalculationText?: InputMaybe<OrderBy>;
  LoaderCheckoutText?: InputMaybe<OrderBy>;
  PriceLabel?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type GlobalContentPagePriceSummarySectionContentWhereInput = {
  AddonsInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  CheckOutButtonText?: InputMaybe<SearchableStringFilterInput>;
  LoaderCalculationText?: InputMaybe<SearchableStringFilterInput>;
  LoaderCheckoutText?: InputMaybe<SearchableStringFilterInput>;
  PriceLabel?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type GlobalContentPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CloseButton?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CountrySelectPlaceholderText?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CubeDiscount?: InputMaybe<GlobalContentPageCubeDiscountContentWhereInput>;
  ElectronicHealthDecleration?: InputMaybe<GlobalContentPageElectronicHealthDeclerationContentWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PriceSummarySectionContent?: InputMaybe<GlobalContentPagePriceSummarySectionContentWhereInput>;
  ReadMoreLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SuffixForMonthYear?: InputMaybe<GlobalContentPageCurrencyPeriodSuffixWhereInput>;
  TermsLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  YesAndNoAnswer?: InputMaybe<GlobalContentPageYesAndNoAnswerContentWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<GlobalContentPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<GlobalContentPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<GlobalContentPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type GlobalContentPageYesAndNoAnswerContent = {
  __typename?: 'GlobalContentPageYesAndNoAnswerContent';
  No?: Maybe<Scalars['String']['output']>;
  Yes?: Maybe<Scalars['String']['output']>;
};


export type GlobalContentPageYesAndNoAnswerContentNoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type GlobalContentPageYesAndNoAnswerContentYesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type GlobalContentPageYesAndNoAnswerContentFacet = {
  __typename?: 'GlobalContentPageYesAndNoAnswerContentFacet';
  No?: Maybe<Array<Maybe<StringFacet>>>;
  Yes?: Maybe<Array<Maybe<StringFacet>>>;
};


export type GlobalContentPageYesAndNoAnswerContentFacetNoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type GlobalContentPageYesAndNoAnswerContentFacetYesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type GlobalContentPageYesAndNoAnswerContentOrderByInput = {
  No?: InputMaybe<OrderBy>;
  Yes?: InputMaybe<OrderBy>;
};

export type GlobalContentPageYesAndNoAnswerContentWhereInput = {
  No?: InputMaybe<SearchableStringFilterInput>;
  Yes?: InputMaybe<SearchableStringFilterInput>;
};

/** Options for highlighting */
export type HighlightOptions = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endToken?: InputMaybe<Scalars['String']['input']>;
  startToken?: InputMaybe<Scalars['String']['input']>;
};

export type HostDefinitionModel = {
  __typename?: 'HostDefinitionModel';
  Language?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type HostDefinitionModelAutocomplete = {
  __typename?: 'HostDefinitionModelAutocomplete';
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HostDefinitionModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HostDefinitionModelAutocompleteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HostDefinitionModelFacet = {
  __typename?: 'HostDefinitionModelFacet';
  Language?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Type?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HostDefinitionModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HostDefinitionModelFacetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HostDefinitionModelOrderByInput = {
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Type?: InputMaybe<OrderBy>;
};

export type HostDefinitionModelWhereInput = {
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
};

/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlock = IContent & IData & {
  __typename?: 'HouseholderCommonBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CampaignCard?: Maybe<HouseholderCommonBlockCampaignCardContent>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HouseholderInfoM2?: Maybe<Scalars['String']['output']>;
  HouseholderTypeApartmentLabel?: Maybe<Scalars['String']['output']>;
  HouseholderTypeLabel?: Maybe<Scalars['String']['output']>;
  HouseholderTypePairHouseLabel?: Maybe<Scalars['String']['output']>;
  HouseholderTypeRowHouseLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlockHouseholderInfoM2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlockHouseholderTypeApartmentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlockHouseholderTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlockHouseholderTypePairHouseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlockHouseholderTypeRowHouseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Householder common content. */
export type HouseholderCommonBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HouseholderCommonBlockAutocomplete = {
  __typename?: 'HouseholderCommonBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HouseholderCommonBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HouseholderCommonBlockCampaignCardContent = {
  __typename?: 'HouseholderCommonBlockCampaignCardContent';
  Content?: Maybe<Scalars['String']['output']>;
  Header?: Maybe<Scalars['String']['output']>;
  ModalContent?: Maybe<Scalars['String']['output']>;
  ModalLabel?: Maybe<Scalars['String']['output']>;
  Tag?: Maybe<Scalars['String']['output']>;
};


export type HouseholderCommonBlockCampaignCardContentContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderCommonBlockCampaignCardContentHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderCommonBlockCampaignCardContentModalContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderCommonBlockCampaignCardContentModalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderCommonBlockCampaignCardContentTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderCommonBlockCampaignCardContentFacet = {
  __typename?: 'HouseholderCommonBlockCampaignCardContentFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Header?: Maybe<Array<Maybe<StringFacet>>>;
  ModalContent?: Maybe<Array<Maybe<StringFacet>>>;
  ModalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderCommonBlockCampaignCardContentFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockCampaignCardContentFacetHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockCampaignCardContentFacetModalContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockCampaignCardContentFacetModalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockCampaignCardContentFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderCommonBlockCampaignCardContentOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Header?: InputMaybe<OrderBy>;
  ModalContent?: InputMaybe<OrderBy>;
  ModalLabel?: InputMaybe<OrderBy>;
  Tag?: InputMaybe<OrderBy>;
};

export type HouseholderCommonBlockCampaignCardContentWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Header?: InputMaybe<SearchableStringFilterInput>;
  ModalContent?: InputMaybe<SearchableStringFilterInput>;
  ModalLabel?: InputMaybe<SearchableStringFilterInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderCommonBlockFacet = {
  __typename?: 'HouseholderCommonBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CampaignCard?: Maybe<HouseholderCommonBlockCampaignCardContentFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HouseholderInfoM2?: Maybe<Array<Maybe<StringFacet>>>;
  HouseholderTypeApartmentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HouseholderTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HouseholderTypePairHouseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HouseholderTypeRowHouseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HouseholderCommonBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonBlockFacetHouseholderInfoM2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetHouseholderTypeApartmentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetHouseholderTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetHouseholderTypePairHouseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetHouseholderTypeRowHouseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HouseholderCommonBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CampaignCard?: InputMaybe<HouseholderCommonBlockCampaignCardContentOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HouseholderInfoM2?: InputMaybe<OrderBy>;
  HouseholderTypeApartmentLabel?: InputMaybe<OrderBy>;
  HouseholderTypeLabel?: InputMaybe<OrderBy>;
  HouseholderTypePairHouseLabel?: InputMaybe<OrderBy>;
  HouseholderTypeRowHouseLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HouseholderCommonBlockOutput = {
  __typename?: 'HouseholderCommonBlockOutput';
  autocomplete?: Maybe<HouseholderCommonBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HouseholderCommonBlockFacet>;
  item?: Maybe<HouseholderCommonBlock>;
  items?: Maybe<Array<Maybe<HouseholderCommonBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HouseholderCommonBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseholderCommonBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CampaignCard?: InputMaybe<HouseholderCommonBlockCampaignCardContentWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HouseholderInfoM2?: InputMaybe<SearchableStringFilterInput>;
  HouseholderTypeApartmentLabel?: InputMaybe<SearchableStringFilterInput>;
  HouseholderTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  HouseholderTypePairHouseLabel?: InputMaybe<SearchableStringFilterInput>;
  HouseholderTypeRowHouseLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HouseholderCommonBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HouseholderCommonBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HouseholderCommonBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Householder Common */
export type HouseholderCommonPage = IContent & IData & {
  __typename?: 'HouseholderCommonPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CampaignCard?: Maybe<HouseholderCommonPageCampaignCardContent>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HouseholderInfoM2?: Maybe<Scalars['String']['output']>;
  HouseholderTypeApartmentLabel?: Maybe<Scalars['String']['output']>;
  HouseholderTypeLabel?: Maybe<Scalars['String']['output']>;
  HouseholderTypePairHouseLabel?: Maybe<Scalars['String']['output']>;
  HouseholderTypeRowHouseLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Householder Common */
export type HouseholderCommonPageHouseholderInfoM2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Common */
export type HouseholderCommonPageHouseholderTypeApartmentLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Common */
export type HouseholderCommonPageHouseholderTypeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Common */
export type HouseholderCommonPageHouseholderTypePairHouseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Common */
export type HouseholderCommonPageHouseholderTypeRowHouseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Common */
export type HouseholderCommonPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Common */
export type HouseholderCommonPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Common */
export type HouseholderCommonPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HouseholderCommonPageAutocomplete = {
  __typename?: 'HouseholderCommonPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HouseholderCommonPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderCommonPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HouseholderCommonPageCampaignCardContent = {
  __typename?: 'HouseholderCommonPageCampaignCardContent';
  Content?: Maybe<Scalars['String']['output']>;
  Header?: Maybe<Scalars['String']['output']>;
  ModalContent?: Maybe<Scalars['String']['output']>;
  ModalLabel?: Maybe<Scalars['String']['output']>;
  Tag?: Maybe<Scalars['String']['output']>;
};


export type HouseholderCommonPageCampaignCardContentContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderCommonPageCampaignCardContentHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderCommonPageCampaignCardContentModalContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderCommonPageCampaignCardContentModalLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderCommonPageCampaignCardContentTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderCommonPageCampaignCardContentFacet = {
  __typename?: 'HouseholderCommonPageCampaignCardContentFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Header?: Maybe<Array<Maybe<StringFacet>>>;
  ModalContent?: Maybe<Array<Maybe<StringFacet>>>;
  ModalLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderCommonPageCampaignCardContentFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageCampaignCardContentFacetHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageCampaignCardContentFacetModalContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageCampaignCardContentFacetModalLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageCampaignCardContentFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderCommonPageCampaignCardContentOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Header?: InputMaybe<OrderBy>;
  ModalContent?: InputMaybe<OrderBy>;
  ModalLabel?: InputMaybe<OrderBy>;
  Tag?: InputMaybe<OrderBy>;
};

export type HouseholderCommonPageCampaignCardContentWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Header?: InputMaybe<SearchableStringFilterInput>;
  ModalContent?: InputMaybe<SearchableStringFilterInput>;
  ModalLabel?: InputMaybe<SearchableStringFilterInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderCommonPageFacet = {
  __typename?: 'HouseholderCommonPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CampaignCard?: Maybe<HouseholderCommonPageCampaignCardContentFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HouseholderInfoM2?: Maybe<Array<Maybe<StringFacet>>>;
  HouseholderTypeApartmentLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HouseholderTypeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HouseholderTypePairHouseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HouseholderTypeRowHouseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HouseholderCommonPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonPageFacetHouseholderInfoM2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetHouseholderTypeApartmentLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetHouseholderTypeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetHouseholderTypePairHouseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetHouseholderTypeRowHouseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderCommonPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderCommonPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HouseholderCommonPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CampaignCard?: InputMaybe<HouseholderCommonPageCampaignCardContentOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HouseholderInfoM2?: InputMaybe<OrderBy>;
  HouseholderTypeApartmentLabel?: InputMaybe<OrderBy>;
  HouseholderTypeLabel?: InputMaybe<OrderBy>;
  HouseholderTypePairHouseLabel?: InputMaybe<OrderBy>;
  HouseholderTypeRowHouseLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HouseholderCommonPageOutput = {
  __typename?: 'HouseholderCommonPageOutput';
  autocomplete?: Maybe<HouseholderCommonPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HouseholderCommonPageFacet>;
  item?: Maybe<HouseholderCommonPage>;
  items?: Maybe<Array<Maybe<HouseholderCommonPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HouseholderCommonPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseholderCommonPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CampaignCard?: InputMaybe<HouseholderCommonPageCampaignCardContentWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HouseholderInfoM2?: InputMaybe<SearchableStringFilterInput>;
  HouseholderTypeApartmentLabel?: InputMaybe<SearchableStringFilterInput>;
  HouseholderTypeLabel?: InputMaybe<SearchableStringFilterInput>;
  HouseholderTypePairHouseLabel?: InputMaybe<SearchableStringFilterInput>;
  HouseholderTypeRowHouseLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HouseholderCommonPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HouseholderCommonPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HouseholderCommonPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A page containing the householder confirmation content. */
export type HouseholderConfirmationPage = IContent & IData & {
  __typename?: 'HouseholderConfirmationPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationPageCommon?: Maybe<HouseholderConfirmationPageConfirmationPageCommon>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A page containing the householder confirmation content. */
export type HouseholderConfirmationPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page containing the householder confirmation content. */
export type HouseholderConfirmationPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page containing the householder confirmation content. */
export type HouseholderConfirmationPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HouseholderConfirmationPageAutocomplete = {
  __typename?: 'HouseholderConfirmationPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HouseholderConfirmationPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderConfirmationPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HouseholderConfirmationPageConfirmationPageCommon = {
  __typename?: 'HouseholderConfirmationPageConfirmationPageCommon';
  AboutInsuranceSectionHeaderText?: Maybe<Scalars['String']['output']>;
  AddOnHeaderText?: Maybe<Scalars['String']['output']>;
  CancellationBlock?: Maybe<Scalars['String']['output']>;
  DiscountText?: Maybe<Scalars['String']['output']>;
  InvoicingInfoExistingCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingInfoNewCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingSectionHeader?: Maybe<Scalars['String']['output']>;
  LogoutLink?: Maybe<Scalars['String']['output']>;
  LogoutLinkText?: Maybe<Scalars['String']['output']>;
  LogoutText?: Maybe<Scalars['String']['output']>;
  MyPagesButtonText?: Maybe<Scalars['String']['output']>;
  MyPagesScaluText?: Maybe<Scalars['String']['output']>;
  MyPagesSectionHeader?: Maybe<Scalars['String']['output']>;
  MyPagesText?: Maybe<Scalars['String']['output']>;
  NordeaCampaignInfo?: Maybe<Scalars['String']['output']>;
  PageHeaderText?: Maybe<Scalars['String']['output']>;
  SecondaryHeader?: Maybe<Scalars['String']['output']>;
  TotalAmount?: Maybe<Scalars['String']['output']>;
};


export type HouseholderConfirmationPageConfirmationPageCommonAboutInsuranceSectionHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonAddOnHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonCancellationBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonDiscountTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonInvoicingInfoExistingCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonInvoicingInfoNewCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonInvoicingSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonLogoutLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonLogoutLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonLogoutTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonMyPagesButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonMyPagesScaluTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonMyPagesSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonMyPagesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonNordeaCampaignInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonPageHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonSecondaryHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderConfirmationPageConfirmationPageCommonTotalAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderConfirmationPageConfirmationPageCommonFacet = {
  __typename?: 'HouseholderConfirmationPageConfirmationPageCommonFacet';
  AboutInsuranceSectionHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  AddOnHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  CancellationBlock?: Maybe<Array<Maybe<StringFacet>>>;
  DiscountText?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoExistingCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoNewCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLink?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesScaluText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesText?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignInfo?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  SecondaryHeader?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmount?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetAboutInsuranceSectionHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetAddOnHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetCancellationBlockArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetDiscountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetInvoicingInfoExistingCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetInvoicingInfoNewCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetInvoicingSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetLogoutLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetLogoutLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetLogoutTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetMyPagesButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetMyPagesScaluTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetMyPagesSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetMyPagesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetNordeaCampaignInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetPageHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetSecondaryHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageConfirmationPageCommonFacetTotalAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderConfirmationPageConfirmationPageCommonOrderByInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<OrderBy>;
  AddOnHeaderText?: InputMaybe<OrderBy>;
  CancellationBlock?: InputMaybe<OrderBy>;
  DiscountText?: InputMaybe<OrderBy>;
  InvoicingInfoExistingCustomer?: InputMaybe<OrderBy>;
  InvoicingInfoNewCustomer?: InputMaybe<OrderBy>;
  InvoicingSectionHeader?: InputMaybe<OrderBy>;
  LogoutLink?: InputMaybe<OrderBy>;
  LogoutLinkText?: InputMaybe<OrderBy>;
  LogoutText?: InputMaybe<OrderBy>;
  MyPagesButtonText?: InputMaybe<OrderBy>;
  MyPagesScaluText?: InputMaybe<OrderBy>;
  MyPagesSectionHeader?: InputMaybe<OrderBy>;
  MyPagesText?: InputMaybe<OrderBy>;
  NordeaCampaignInfo?: InputMaybe<OrderBy>;
  PageHeaderText?: InputMaybe<OrderBy>;
  SecondaryHeader?: InputMaybe<OrderBy>;
  TotalAmount?: InputMaybe<OrderBy>;
};

export type HouseholderConfirmationPageConfirmationPageCommonWhereInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<SearchableStringFilterInput>;
  AddOnHeaderText?: InputMaybe<SearchableStringFilterInput>;
  CancellationBlock?: InputMaybe<SearchableStringFilterInput>;
  DiscountText?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoExistingCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoNewCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  LogoutLink?: InputMaybe<SearchableStringFilterInput>;
  LogoutLinkText?: InputMaybe<SearchableStringFilterInput>;
  LogoutText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesButtonText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesScaluText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  MyPagesText?: InputMaybe<SearchableStringFilterInput>;
  NordeaCampaignInfo?: InputMaybe<SearchableStringFilterInput>;
  PageHeaderText?: InputMaybe<SearchableStringFilterInput>;
  SecondaryHeader?: InputMaybe<SearchableStringFilterInput>;
  TotalAmount?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderConfirmationPageFacet = {
  __typename?: 'HouseholderConfirmationPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationPageCommon?: Maybe<HouseholderConfirmationPageConfirmationPageCommonFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HouseholderConfirmationPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderConfirmationPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderConfirmationPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderConfirmationPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderConfirmationPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderConfirmationPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderConfirmationPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HouseholderConfirmationPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationPageCommon?: InputMaybe<HouseholderConfirmationPageConfirmationPageCommonOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HouseholderConfirmationPageOutput = {
  __typename?: 'HouseholderConfirmationPageOutput';
  autocomplete?: Maybe<HouseholderConfirmationPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HouseholderConfirmationPageFacet>;
  item?: Maybe<HouseholderConfirmationPage>;
  items?: Maybe<Array<Maybe<HouseholderConfirmationPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HouseholderConfirmationPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseholderConfirmationPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationPageCommon?: InputMaybe<HouseholderConfirmationPageConfirmationPageCommonWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HouseholderConfirmationPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HouseholderConfirmationPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HouseholderConfirmationPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Entry page for home products */
export type HouseholderEntryPage = IContent & IData & {
  __typename?: 'HouseholderEntryPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EntryPageCommon?: Maybe<HouseholderEntryPageEntryPageCommon>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  HouseholderTypeQuestion?: Maybe<HouseholderEntryPageQuestionBase>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  IsHousingCompanyQuestion?: Maybe<HouseholderEntryPageQuestionBase>;
  Language?: Maybe<ContentLanguageModel>;
  LivingSpaceQuestion?: Maybe<HouseholderEntryPageQuestionBase>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Entry page for home products */
export type HouseholderEntryPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for home products */
export type HouseholderEntryPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for home products */
export type HouseholderEntryPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HouseholderEntryPageAutocomplete = {
  __typename?: 'HouseholderEntryPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HouseholderEntryPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderEntryPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HouseholderEntryPageEntryPageCommon = {
  __typename?: 'HouseholderEntryPageEntryPageCommon';
  Description?: Maybe<Scalars['String']['output']>;
  SsnQuestion?: Maybe<HouseholderEntryPageEntryPageCommonQuestionBase>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Terms?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type HouseholderEntryPageEntryPageCommonDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageEntryPageCommonSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageEntryPageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageEntryPageCommonTermsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageEntryPageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderEntryPageEntryPageCommonFacet = {
  __typename?: 'HouseholderEntryPageEntryPageCommonFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  SsnQuestion?: Maybe<HouseholderEntryPageEntryPageCommonQuestionBaseFacet>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Terms?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderEntryPageEntryPageCommonFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageEntryPageCommonFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageEntryPageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageEntryPageCommonFacetTermsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageEntryPageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderEntryPageEntryPageCommonOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  SsnQuestion?: InputMaybe<HouseholderEntryPageEntryPageCommonQuestionBaseOrderByInput>;
  SubTitle?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Terms?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type HouseholderEntryPageEntryPageCommonQuestionBase = {
  __typename?: 'HouseholderEntryPageEntryPageCommonQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItem>>>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderEntryPageEntryPageCommonQuestionBaseFacet = {
  __typename?: 'HouseholderEntryPageEntryPageCommonQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderEntryPageEntryPageCommonQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemOrderByInput>;
};

export type HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItem = {
  __typename?: 'HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet = {
  __typename?: 'HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderEntryPageEntryPageCommonQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<HouseholderEntryPageEntryPageCommonQuestionBaseValidationMessageItemWhereInput>;
};

export type HouseholderEntryPageEntryPageCommonWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  SsnQuestion?: InputMaybe<HouseholderEntryPageEntryPageCommonQuestionBaseWhereInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Terms?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderEntryPageFacet = {
  __typename?: 'HouseholderEntryPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EntryPageCommon?: Maybe<HouseholderEntryPageEntryPageCommonFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  HouseholderTypeQuestion?: Maybe<HouseholderEntryPageQuestionBaseFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  IsHousingCompanyQuestion?: Maybe<HouseholderEntryPageQuestionBaseFacet>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LivingSpaceQuestion?: Maybe<HouseholderEntryPageQuestionBaseFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HouseholderEntryPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderEntryPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderEntryPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderEntryPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderEntryPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderEntryPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HouseholderEntryPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EntryPageCommon?: InputMaybe<HouseholderEntryPageEntryPageCommonOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  HouseholderTypeQuestion?: InputMaybe<HouseholderEntryPageQuestionBaseOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  IsHousingCompanyQuestion?: InputMaybe<HouseholderEntryPageQuestionBaseOrderByInput>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LivingSpaceQuestion?: InputMaybe<HouseholderEntryPageQuestionBaseOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HouseholderEntryPageOutput = {
  __typename?: 'HouseholderEntryPageOutput';
  autocomplete?: Maybe<HouseholderEntryPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HouseholderEntryPageFacet>;
  item?: Maybe<HouseholderEntryPage>;
  items?: Maybe<Array<Maybe<HouseholderEntryPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HouseholderEntryPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseholderEntryPageQuestionBase = {
  __typename?: 'HouseholderEntryPageQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<HouseholderEntryPageQuestionBaseValidationMessageItem>>>;
};


export type HouseholderEntryPageQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderEntryPageQuestionBaseFacet = {
  __typename?: 'HouseholderEntryPageQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<HouseholderEntryPageQuestionBaseValidationMessageItemFacet>;
};


export type HouseholderEntryPageQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderEntryPageQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<HouseholderEntryPageQuestionBaseValidationMessageItemOrderByInput>;
};

export type HouseholderEntryPageQuestionBaseValidationMessageItem = {
  __typename?: 'HouseholderEntryPageQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type HouseholderEntryPageQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderEntryPageQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderEntryPageQuestionBaseValidationMessageItemFacet = {
  __typename?: 'HouseholderEntryPageQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderEntryPageQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderEntryPageQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderEntryPageQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type HouseholderEntryPageQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderEntryPageQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<HouseholderEntryPageQuestionBaseValidationMessageItemWhereInput>;
};

export type HouseholderEntryPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EntryPageCommon?: InputMaybe<HouseholderEntryPageEntryPageCommonWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  HouseholderTypeQuestion?: InputMaybe<HouseholderEntryPageQuestionBaseWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  IsHousingCompanyQuestion?: InputMaybe<HouseholderEntryPageQuestionBaseWhereInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LivingSpaceQuestion?: InputMaybe<HouseholderEntryPageQuestionBaseWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HouseholderEntryPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HouseholderEntryPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HouseholderEntryPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Householder Price Page */
export type HouseholderPricePage = IContent & IData & {
  __typename?: 'HouseholderPricePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CityLabel?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FormTitle?: Maybe<Scalars['String']['output']>;
  HouseHolderInfoLabel?: Maybe<Scalars['String']['output']>;
  HouseInformationText?: Maybe<HouseholderPricePageLabelBase>;
  HouseholderLabel?: Maybe<Scalars['String']['output']>;
  InsuredWithIfInfoLabel?: Maybe<Scalars['String']['output']>;
  InsuredWithIfInfoText?: Maybe<Scalars['String']['output']>;
  InsuredWithIfLabel?: Maybe<HouseholderPricePageLabelBase>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NotInsuredWithIfInfoLabel?: Maybe<Scalars['String']['output']>;
  NotInsuredWithIfInfoText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PostalCodeLabel?: Maybe<Scalars['String']['output']>;
  PricePageCommon?: Maybe<HouseholderPricePagePricePageCommon>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  StreetAddressLabel?: Maybe<Scalars['String']['output']>;
  TermsStartDateLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Householder Price Page */
export type HouseholderPricePageCityLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageFormTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageHouseHolderInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageHouseholderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageInsuredWithIfInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageInsuredWithIfInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageNotInsuredWithIfInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageNotInsuredWithIfInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePagePostalCodeLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageStreetAddressLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePageTermsStartDateLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Householder Price Page */
export type HouseholderPricePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HouseholderPricePageAutocomplete = {
  __typename?: 'HouseholderPricePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PricePageCommon?: Maybe<HouseholderPricePagePricePageCommonAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HouseholderPricePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HouseholderPricePageFacet = {
  __typename?: 'HouseholderPricePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CityLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormTitle?: Maybe<Array<Maybe<StringFacet>>>;
  HouseHolderInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  HouseInformationText?: Maybe<HouseholderPricePageLabelBaseFacet>;
  HouseholderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  InsuredWithIfInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  InsuredWithIfInfoText?: Maybe<Array<Maybe<StringFacet>>>;
  InsuredWithIfLabel?: Maybe<HouseholderPricePageLabelBaseFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NotInsuredWithIfInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  NotInsuredWithIfInfoText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostalCodeLabel?: Maybe<Array<Maybe<StringFacet>>>;
  PricePageCommon?: Maybe<HouseholderPricePagePricePageCommonFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StreetAddressLabel?: Maybe<Array<Maybe<StringFacet>>>;
  TermsStartDateLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HouseholderPricePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderPricePageFacetCityLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderPricePageFacetFormTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetHouseHolderInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetHouseholderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetInsuredWithIfInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetInsuredWithIfInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetNotInsuredWithIfInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetNotInsuredWithIfInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetPostalCodeLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderPricePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderPricePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderPricePageFacetStreetAddressLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetTermsStartDateLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HouseholderPricePageLabelBase = {
  __typename?: 'HouseholderPricePageLabelBase';
  Content?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
};


export type HouseholderPricePageLabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePageLabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePageLabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderPricePageLabelBaseFacet = {
  __typename?: 'HouseholderPricePageLabelBaseFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderPricePageLabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageLabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePageLabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderPricePageLabelBaseOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
};

export type HouseholderPricePageLabelBaseWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderPricePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CityLabel?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormTitle?: InputMaybe<OrderBy>;
  HouseHolderInfoLabel?: InputMaybe<OrderBy>;
  HouseInformationText?: InputMaybe<HouseholderPricePageLabelBaseOrderByInput>;
  HouseholderLabel?: InputMaybe<OrderBy>;
  InsuredWithIfInfoLabel?: InputMaybe<OrderBy>;
  InsuredWithIfInfoText?: InputMaybe<OrderBy>;
  InsuredWithIfLabel?: InputMaybe<HouseholderPricePageLabelBaseOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NotInsuredWithIfInfoLabel?: InputMaybe<OrderBy>;
  NotInsuredWithIfInfoText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostalCodeLabel?: InputMaybe<OrderBy>;
  PricePageCommon?: InputMaybe<HouseholderPricePagePricePageCommonOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  StreetAddressLabel?: InputMaybe<OrderBy>;
  TermsStartDateLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HouseholderPricePageOutput = {
  __typename?: 'HouseholderPricePageOutput';
  autocomplete?: Maybe<HouseholderPricePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HouseholderPricePageFacet>;
  item?: Maybe<HouseholderPricePage>;
  items?: Maybe<Array<Maybe<HouseholderPricePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HouseholderPricePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseholderPricePagePricePageCommon = {
  __typename?: 'HouseholderPricePagePricePageCommon';
  AboutBonusesModal?: Maybe<HouseholderPricePagePricePageCommonLabelBase>;
  AddonNotSelectableText?: Maybe<Scalars['String']['output']>;
  BonusHeaderOptionOne?: Maybe<Scalars['String']['output']>;
  BonusHeaderOptionTwo?: Maybe<Scalars['String']['output']>;
  BonusItems?: Maybe<Array<Maybe<HouseholderPricePagePricePageCommonBonusItem>>>;
  BonusLabel?: Maybe<Scalars['String']['output']>;
  ContinuePurchaseLoaderText?: Maybe<Scalars['String']['output']>;
  DeductibleAmountSelector?: Maybe<HouseholderPricePagePricePageCommonLabelBase>;
  EditButtonText?: Maybe<Scalars['String']['output']>;
  ErrorMessageNoSelected?: Maybe<Scalars['String']['output']>;
  FixedPriceText?: Maybe<Scalars['String']['output']>;
  IncludedItemsHeader?: Maybe<Scalars['String']['output']>;
  InsuranceAmountSelector?: Maybe<HouseholderPricePagePricePageCommonLabelBase>;
  NoCoverageSelectedForAddons?: Maybe<Scalars['String']['output']>;
  NordeaCampaignSummary?: Maybe<HouseholderPricePagePricePageCommonLabelBase>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  RecalculatingLoaderText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageTitle?: Maybe<Scalars['String']['output']>;
  SelectAddonsHeader?: Maybe<Scalars['String']['output']>;
  SelectInsuranceAmountText?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TopQuestionsTitle?: Maybe<Scalars['String']['output']>;
};


export type HouseholderPricePagePricePageCommonAddonNotSelectableTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonBonusHeaderOptionOneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonBonusHeaderOptionTwoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonBonusLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonContinuePurchaseLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonEditButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonFixedPriceTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonIncludedItemsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonRecalculatingLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonRecommendedCoverageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonRecommendedCoverageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonSelectAddonsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderPricePagePricePageCommonAutocomplete = {
  __typename?: 'HouseholderPricePagePricePageCommonAutocomplete';
  ErrorMessageNoSelected?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HouseholderPricePagePricePageCommonAutocompleteErrorMessageNoSelectedArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePagePricePageCommonAutocompleteNoCoverageSelectedForAddonsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePagePricePageCommonAutocompleteSelectInsuranceAmountTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderPricePagePricePageCommonAutocompleteTopQuestionsTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HouseholderPricePagePricePageCommonBonusItem = {
  __typename?: 'HouseholderPricePagePricePageCommonBonusItem';
  Label?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type HouseholderPricePagePricePageCommonBonusItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonBonusItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderPricePagePricePageCommonBonusItemFacet = {
  __typename?: 'HouseholderPricePagePricePageCommonBonusItemFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderPricePagePricePageCommonBonusItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonBonusItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderPricePagePricePageCommonBonusItemOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type HouseholderPricePagePricePageCommonBonusItemWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderPricePagePricePageCommonFacet = {
  __typename?: 'HouseholderPricePagePricePageCommonFacet';
  AboutBonusesModal?: Maybe<HouseholderPricePagePricePageCommonLabelBaseFacet>;
  AddonNotSelectableText?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionOne?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionTwo?: Maybe<Array<Maybe<StringFacet>>>;
  BonusItems?: Maybe<HouseholderPricePagePricePageCommonBonusItemFacet>;
  BonusLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContinuePurchaseLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  DeductibleAmountSelector?: Maybe<HouseholderPricePagePricePageCommonLabelBaseFacet>;
  EditButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorMessageNoSelected?: Maybe<Array<Maybe<StringFacet>>>;
  FixedPriceText?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedItemsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  InsuranceAmountSelector?: Maybe<HouseholderPricePagePricePageCommonLabelBaseFacet>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignSummary?: Maybe<HouseholderPricePagePricePageCommonLabelBaseFacet>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RecalculatingLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SelectAddonsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderPricePagePricePageCommonFacetAddonNotSelectableTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetBonusHeaderOptionOneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetBonusHeaderOptionTwoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetBonusLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetContinuePurchaseLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetEditButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetErrorMessageNoSelectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetFixedPriceTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetIncludedItemsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetNoCoverageSelectedForAddonsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetRecalculatingLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetRecommendedCoverageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetRecommendedCoverageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetSelectAddonsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetSelectInsuranceAmountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonFacetTopQuestionsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderPricePagePricePageCommonLabelBase = {
  __typename?: 'HouseholderPricePagePricePageCommonLabelBase';
  Content?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
};


export type HouseholderPricePagePricePageCommonLabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonLabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderPricePagePricePageCommonLabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderPricePagePricePageCommonLabelBaseFacet = {
  __typename?: 'HouseholderPricePagePricePageCommonLabelBaseFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderPricePagePricePageCommonLabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonLabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderPricePagePricePageCommonLabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderPricePagePricePageCommonLabelBaseOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
};

export type HouseholderPricePagePricePageCommonLabelBaseWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderPricePagePricePageCommonOrderByInput = {
  AboutBonusesModal?: InputMaybe<HouseholderPricePagePricePageCommonLabelBaseOrderByInput>;
  AddonNotSelectableText?: InputMaybe<OrderBy>;
  BonusHeaderOptionOne?: InputMaybe<OrderBy>;
  BonusHeaderOptionTwo?: InputMaybe<OrderBy>;
  BonusItems?: InputMaybe<HouseholderPricePagePricePageCommonBonusItemOrderByInput>;
  BonusLabel?: InputMaybe<OrderBy>;
  ContinuePurchaseLoaderText?: InputMaybe<OrderBy>;
  DeductibleAmountSelector?: InputMaybe<HouseholderPricePagePricePageCommonLabelBaseOrderByInput>;
  EditButtonText?: InputMaybe<OrderBy>;
  ErrorMessageNoSelected?: InputMaybe<OrderBy>;
  FixedPriceText?: InputMaybe<OrderBy>;
  IncludedItemsHeader?: InputMaybe<OrderBy>;
  InsuranceAmountSelector?: InputMaybe<HouseholderPricePagePricePageCommonLabelBaseOrderByInput>;
  NoCoverageSelectedForAddons?: InputMaybe<OrderBy>;
  NordeaCampaignSummary?: InputMaybe<HouseholderPricePagePricePageCommonLabelBaseOrderByInput>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  RecalculatingLoaderText?: InputMaybe<OrderBy>;
  RecommendedCoverageText?: InputMaybe<OrderBy>;
  RecommendedCoverageTitle?: InputMaybe<OrderBy>;
  SelectAddonsHeader?: InputMaybe<OrderBy>;
  SelectInsuranceAmountText?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopQuestionsTitle?: InputMaybe<OrderBy>;
};

export type HouseholderPricePagePricePageCommonWhereInput = {
  AboutBonusesModal?: InputMaybe<HouseholderPricePagePricePageCommonLabelBaseWhereInput>;
  AddonNotSelectableText?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionOne?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionTwo?: InputMaybe<SearchableStringFilterInput>;
  BonusItems?: InputMaybe<HouseholderPricePagePricePageCommonBonusItemWhereInput>;
  BonusLabel?: InputMaybe<SearchableStringFilterInput>;
  ContinuePurchaseLoaderText?: InputMaybe<SearchableStringFilterInput>;
  DeductibleAmountSelector?: InputMaybe<HouseholderPricePagePricePageCommonLabelBaseWhereInput>;
  EditButtonText?: InputMaybe<SearchableStringFilterInput>;
  ErrorMessageNoSelected?: InputMaybe<StringFilterInput>;
  FixedPriceText?: InputMaybe<SearchableStringFilterInput>;
  IncludedItemsHeader?: InputMaybe<SearchableStringFilterInput>;
  InsuranceAmountSelector?: InputMaybe<HouseholderPricePagePricePageCommonLabelBaseWhereInput>;
  NoCoverageSelectedForAddons?: InputMaybe<StringFilterInput>;
  NordeaCampaignSummary?: InputMaybe<HouseholderPricePagePricePageCommonLabelBaseWhereInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  RecalculatingLoaderText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageTitle?: InputMaybe<SearchableStringFilterInput>;
  SelectAddonsHeader?: InputMaybe<SearchableStringFilterInput>;
  SelectInsuranceAmountText?: InputMaybe<StringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopQuestionsTitle?: InputMaybe<StringFilterInput>;
};

export type HouseholderPricePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CityLabel?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormTitle?: InputMaybe<SearchableStringFilterInput>;
  HouseHolderInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  HouseInformationText?: InputMaybe<HouseholderPricePageLabelBaseWhereInput>;
  HouseholderLabel?: InputMaybe<SearchableStringFilterInput>;
  InsuredWithIfInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  InsuredWithIfInfoText?: InputMaybe<SearchableStringFilterInput>;
  InsuredWithIfLabel?: InputMaybe<HouseholderPricePageLabelBaseWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NotInsuredWithIfInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  NotInsuredWithIfInfoText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostalCodeLabel?: InputMaybe<SearchableStringFilterInput>;
  PricePageCommon?: InputMaybe<HouseholderPricePagePricePageCommonWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  StreetAddressLabel?: InputMaybe<SearchableStringFilterInput>;
  TermsStartDateLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HouseholderPricePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HouseholderPricePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HouseholderPricePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Top questions For householder products */
export type HouseholderTopQuestionsPage = IContent & IData & {
  __typename?: 'HouseholderTopQuestionsPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CityQuestion?: Maybe<HouseholderTopQuestionsPageQuestionBase>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Deprecated move to start using the top TopQuestionsCommon.FormTitle */
  FormTitle?: Maybe<Scalars['String']['output']>;
  HasJustMovedInfoText?: Maybe<Scalars['String']['output']>;
  HomeInfoLabel?: Maybe<HouseholderTopQuestionsPageLabelBase>;
  HouseholderInsuredWithIfLabel?: Maybe<HouseholderTopQuestionsPageLabelBase>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PostalCodeQuestion?: Maybe<HouseholderTopQuestionsPageQuestionBase>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartDateQuestion?: Maybe<HouseholderTopQuestionsPageQuestionBase>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  StreetAddressQuestion?: Maybe<HouseholderTopQuestionsPageQuestionBase>;
  TopQuestionsCommon?: Maybe<HouseholderTopQuestionsPageTopQuestionsCommon>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Top questions For householder products */
export type HouseholderTopQuestionsPageFormTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For householder products */
export type HouseholderTopQuestionsPageHasJustMovedInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For householder products */
export type HouseholderTopQuestionsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For householder products */
export type HouseholderTopQuestionsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For householder products */
export type HouseholderTopQuestionsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HouseholderTopQuestionsPageAutocomplete = {
  __typename?: 'HouseholderTopQuestionsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HouseholderTopQuestionsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HouseholderTopQuestionsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HouseholderTopQuestionsPageFacet = {
  __typename?: 'HouseholderTopQuestionsPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CityQuestion?: Maybe<HouseholderTopQuestionsPageQuestionBaseFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormTitle?: Maybe<Array<Maybe<StringFacet>>>;
  HasJustMovedInfoText?: Maybe<Array<Maybe<StringFacet>>>;
  HomeInfoLabel?: Maybe<HouseholderTopQuestionsPageLabelBaseFacet>;
  HouseholderInsuredWithIfLabel?: Maybe<HouseholderTopQuestionsPageLabelBaseFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostalCodeQuestion?: Maybe<HouseholderTopQuestionsPageQuestionBaseFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartDateQuestion?: Maybe<HouseholderTopQuestionsPageQuestionBaseFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StreetAddressQuestion?: Maybe<HouseholderTopQuestionsPageQuestionBaseFacet>;
  TopQuestionsCommon?: Maybe<HouseholderTopQuestionsPageTopQuestionsCommonFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HouseholderTopQuestionsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderTopQuestionsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderTopQuestionsPageFacetFormTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetHasJustMovedInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderTopQuestionsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderTopQuestionsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HouseholderTopQuestionsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HouseholderTopQuestionsPageLabelBase = {
  __typename?: 'HouseholderTopQuestionsPageLabelBase';
  Content?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
};


export type HouseholderTopQuestionsPageLabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderTopQuestionsPageLabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderTopQuestionsPageLabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderTopQuestionsPageLabelBaseFacet = {
  __typename?: 'HouseholderTopQuestionsPageLabelBaseFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderTopQuestionsPageLabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageLabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageLabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderTopQuestionsPageLabelBaseOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
};

export type HouseholderTopQuestionsPageLabelBaseWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderTopQuestionsPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CityQuestion?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormTitle?: InputMaybe<OrderBy>;
  HasJustMovedInfoText?: InputMaybe<OrderBy>;
  HomeInfoLabel?: InputMaybe<HouseholderTopQuestionsPageLabelBaseOrderByInput>;
  HouseholderInsuredWithIfLabel?: InputMaybe<HouseholderTopQuestionsPageLabelBaseOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostalCodeQuestion?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartDateQuestion?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  StreetAddressQuestion?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseOrderByInput>;
  TopQuestionsCommon?: InputMaybe<HouseholderTopQuestionsPageTopQuestionsCommonOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HouseholderTopQuestionsPageOutput = {
  __typename?: 'HouseholderTopQuestionsPageOutput';
  autocomplete?: Maybe<HouseholderTopQuestionsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HouseholderTopQuestionsPageFacet>;
  item?: Maybe<HouseholderTopQuestionsPage>;
  items?: Maybe<Array<Maybe<HouseholderTopQuestionsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HouseholderTopQuestionsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HouseholderTopQuestionsPageQuestionBase = {
  __typename?: 'HouseholderTopQuestionsPageQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<HouseholderTopQuestionsPageQuestionBaseValidationMessageItem>>>;
};


export type HouseholderTopQuestionsPageQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderTopQuestionsPageQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderTopQuestionsPageQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderTopQuestionsPageQuestionBaseFacet = {
  __typename?: 'HouseholderTopQuestionsPageQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<HouseholderTopQuestionsPageQuestionBaseValidationMessageItemFacet>;
};


export type HouseholderTopQuestionsPageQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderTopQuestionsPageQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseValidationMessageItemOrderByInput>;
};

export type HouseholderTopQuestionsPageQuestionBaseValidationMessageItem = {
  __typename?: 'HouseholderTopQuestionsPageQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type HouseholderTopQuestionsPageQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderTopQuestionsPageQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderTopQuestionsPageQuestionBaseValidationMessageItemFacet = {
  __typename?: 'HouseholderTopQuestionsPageQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderTopQuestionsPageQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderTopQuestionsPageQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type HouseholderTopQuestionsPageQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderTopQuestionsPageQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseValidationMessageItemWhereInput>;
};

export type HouseholderTopQuestionsPageTopQuestionsCommon = {
  __typename?: 'HouseholderTopQuestionsPageTopQuestionsCommon';
  FormTitle?: Maybe<Scalars['String']['output']>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type HouseholderTopQuestionsPageTopQuestionsCommonFormTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderTopQuestionsPageTopQuestionsCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderTopQuestionsPageTopQuestionsCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HouseholderTopQuestionsPageTopQuestionsCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type HouseholderTopQuestionsPageTopQuestionsCommonFacet = {
  __typename?: 'HouseholderTopQuestionsPageTopQuestionsCommonFacet';
  FormTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HouseholderTopQuestionsPageTopQuestionsCommonFacetFormTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageTopQuestionsCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageTopQuestionsCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HouseholderTopQuestionsPageTopQuestionsCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HouseholderTopQuestionsPageTopQuestionsCommonOrderByInput = {
  FormTitle?: InputMaybe<OrderBy>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type HouseholderTopQuestionsPageTopQuestionsCommonWhereInput = {
  FormTitle?: InputMaybe<SearchableStringFilterInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type HouseholderTopQuestionsPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CityQuestion?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormTitle?: InputMaybe<SearchableStringFilterInput>;
  HasJustMovedInfoText?: InputMaybe<SearchableStringFilterInput>;
  HomeInfoLabel?: InputMaybe<HouseholderTopQuestionsPageLabelBaseWhereInput>;
  HouseholderInsuredWithIfLabel?: InputMaybe<HouseholderTopQuestionsPageLabelBaseWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostalCodeQuestion?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartDateQuestion?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  StreetAddressQuestion?: InputMaybe<HouseholderTopQuestionsPageQuestionBaseWhereInput>;
  TopQuestionsCommon?: InputMaybe<HouseholderTopQuestionsPageTopQuestionsCommonWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HouseholderTopQuestionsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HouseholderTopQuestionsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HouseholderTopQuestionsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A generic html element with inner html and attributes. */
export type HtmlElement = IContent & IData & {
  __typename?: 'HtmlElement';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** The CSS classes to apply to the element. */
  Classes?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The inner HTML content of the element. */
  InnerHtml?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** The HTML tag to use for the element. */
  Tag?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A generic html element with inner html and attributes. */
export type HtmlElementClassesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic html element with inner html and attributes. */
export type HtmlElementInnerHtmlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic html element with inner html and attributes. */
export type HtmlElementNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic html element with inner html and attributes. */
export type HtmlElementTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic html element with inner html and attributes. */
export type HtmlElement_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic html element with inner html and attributes. */
export type HtmlElement_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HtmlElementAutocomplete = {
  __typename?: 'HtmlElementAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HtmlElementAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HtmlElementAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HtmlElementFacet = {
  __typename?: 'HtmlElementFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Classes?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  InnerHtml?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type HtmlElementFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HtmlElementFacetClassesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HtmlElementFacetInnerHtmlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HtmlElementFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HtmlElementFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HtmlElementFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HtmlElementFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type HtmlElementOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Classes?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  InnerHtml?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Tag?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type HtmlElementOutput = {
  __typename?: 'HtmlElementOutput';
  autocomplete?: Maybe<HtmlElementAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HtmlElementFacet>;
  item?: Maybe<HtmlElement>;
  items?: Maybe<Array<Maybe<HtmlElement>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HtmlElementOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HtmlElementWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Classes?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  InnerHtml?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HtmlElementWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HtmlElementWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HtmlElementWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type IContent = {
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type IContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IData = {
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type IData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

/** An page containing the checkout process content. */
export type IfCheckoutPage = IContent & IData & {
  __typename?: 'IfCheckoutPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  CheckoutPageCommon?: Maybe<IfCheckoutPageCheckoutPageCommon>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An page containing the checkout process content. */
export type IfCheckoutPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the checkout process content. */
export type IfCheckoutPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the checkout process content. */
export type IfCheckoutPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfCheckoutPageAutocomplete = {
  __typename?: 'IfCheckoutPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfCheckoutPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCheckoutPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfCheckoutPageCheckoutPageCommon = {
  __typename?: 'IfCheckoutPageCheckoutPageCommon';
  AcceptTermsAdditionalInfo?: Maybe<Scalars['String']['output']>;
  AcceptTermsAndConditionsQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  BadCreditErrorMessage?: Maybe<Scalars['String']['output']>;
  BadCreditErrorTitle?: Maybe<Scalars['String']['output']>;
  BillingFrequencyQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  BillingHeader?: Maybe<Scalars['String']['output']>;
  BillingInfoAnnualTextMyPagesInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoAnnualTextPaperInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoMonthlyTextMyPagesInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoMonthlyTextPaperInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoQuarterSemiAnnualTextMyPagesInvoice?: Maybe<Scalars['String']['output']>;
  BillingInfoQuarterSemiAnnualTextPaperInvoice?: Maybe<Scalars['String']['output']>;
  BillingInformation?: Maybe<Scalars['String']['output']>;
  BillingMethodQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  CityQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  CompletePurchaseLoadingText?: Maybe<Scalars['String']['output']>;
  EmailQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  FirstNameQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  InvoicingExistingCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingFrequency12Months?: Maybe<Scalars['String']['output']>;
  InvoicingMethodMyPages?: Maybe<Scalars['String']['output']>;
  InvoicingMethodPaper?: Maybe<Scalars['String']['output']>;
  LastNameQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  MarketingConsentRequired?: Maybe<Scalars['String']['output']>;
  MarketingDescription?: Maybe<Scalars['String']['output']>;
  MarketingHeader?: Maybe<Scalars['String']['output']>;
  MarketingNoLabel?: Maybe<Scalars['String']['output']>;
  MarketingYesLabel?: Maybe<Scalars['String']['output']>;
  MobilePhoneNumberQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  NordeaUnderCtaText?: Maybe<Scalars['String']['output']>;
  PostalCodeQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  PricePageLinkText?: Maybe<Scalars['String']['output']>;
  SsnMismatchErrorMessage?: Maybe<Scalars['String']['output']>;
  SsnMismatchErrorTitle?: Maybe<Scalars['String']['output']>;
  StreetAddressQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBase>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type IfCheckoutPageCheckoutPageCommonAcceptTermsAdditionalInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBadCreditErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBadCreditErrorTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBillingHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBillingInfoAnnualTextMyPagesInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBillingInfoAnnualTextPaperInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBillingInfoMonthlyTextMyPagesInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBillingInfoMonthlyTextPaperInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBillingInfoQuarterSemiAnnualTextMyPagesInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBillingInfoQuarterSemiAnnualTextPaperInvoiceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonBillingInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonCompletePurchaseLoadingTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonInvoicingExistingCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonInvoicingFrequency12MonthsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonInvoicingMethodMyPagesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonInvoicingMethodPaperArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonMarketingConsentRequiredArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonMarketingDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonMarketingHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonMarketingNoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonMarketingYesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonNordeaUnderCtaTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonPricePageLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonSsnMismatchErrorMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonSsnMismatchErrorTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfCheckoutPageCheckoutPageCommonFacet = {
  __typename?: 'IfCheckoutPageCheckoutPageCommonFacet';
  AcceptTermsAdditionalInfo?: Maybe<Array<Maybe<StringFacet>>>;
  AcceptTermsAndConditionsQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  BadCreditErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  BadCreditErrorTitle?: Maybe<Array<Maybe<StringFacet>>>;
  BillingFrequencyQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  BillingHeader?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoAnnualTextMyPagesInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoAnnualTextPaperInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoMonthlyTextMyPagesInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoMonthlyTextPaperInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoQuarterSemiAnnualTextMyPagesInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInfoQuarterSemiAnnualTextPaperInvoice?: Maybe<Array<Maybe<StringFacet>>>;
  BillingInformation?: Maybe<Array<Maybe<StringFacet>>>;
  BillingMethodQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  CityQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  CompletePurchaseLoadingText?: Maybe<Array<Maybe<StringFacet>>>;
  EmailQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  FirstNameQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  InvoicingExistingCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingFrequency12Months?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingMethodMyPages?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingMethodPaper?: Maybe<Array<Maybe<StringFacet>>>;
  LastNameQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  MarketingConsentRequired?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingNoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MarketingYesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  MobilePhoneNumberQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  NordeaUnderCtaText?: Maybe<Array<Maybe<StringFacet>>>;
  PostalCodeQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  PricePageLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  SsnMismatchErrorMessage?: Maybe<Array<Maybe<StringFacet>>>;
  SsnMismatchErrorTitle?: Maybe<Array<Maybe<StringFacet>>>;
  StreetAddressQuestion?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseFacet>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfCheckoutPageCheckoutPageCommonFacetAcceptTermsAdditionalInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBadCreditErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBadCreditErrorTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBillingHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBillingInfoAnnualTextMyPagesInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBillingInfoAnnualTextPaperInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBillingInfoMonthlyTextMyPagesInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBillingInfoMonthlyTextPaperInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBillingInfoQuarterSemiAnnualTextMyPagesInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBillingInfoQuarterSemiAnnualTextPaperInvoiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetBillingInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetCompletePurchaseLoadingTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetInvoicingExistingCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetInvoicingFrequency12MonthsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetInvoicingMethodMyPagesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetInvoicingMethodPaperArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetMarketingConsentRequiredArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetMarketingDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetMarketingHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetMarketingNoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetMarketingYesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetNordeaUnderCtaTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetPricePageLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetSsnMismatchErrorMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetSsnMismatchErrorTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfCheckoutPageCheckoutPageCommonOrderByInput = {
  AcceptTermsAdditionalInfo?: InputMaybe<OrderBy>;
  AcceptTermsAndConditionsQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  BadCreditErrorMessage?: InputMaybe<OrderBy>;
  BadCreditErrorTitle?: InputMaybe<OrderBy>;
  BillingFrequencyQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  BillingHeader?: InputMaybe<OrderBy>;
  BillingInfoAnnualTextMyPagesInvoice?: InputMaybe<OrderBy>;
  BillingInfoAnnualTextPaperInvoice?: InputMaybe<OrderBy>;
  BillingInfoMonthlyTextMyPagesInvoice?: InputMaybe<OrderBy>;
  BillingInfoMonthlyTextPaperInvoice?: InputMaybe<OrderBy>;
  BillingInfoQuarterSemiAnnualTextMyPagesInvoice?: InputMaybe<OrderBy>;
  BillingInfoQuarterSemiAnnualTextPaperInvoice?: InputMaybe<OrderBy>;
  BillingInformation?: InputMaybe<OrderBy>;
  BillingMethodQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  CityQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  CompletePurchaseLoadingText?: InputMaybe<OrderBy>;
  EmailQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  FirstNameQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  InvoicingExistingCustomer?: InputMaybe<OrderBy>;
  InvoicingFrequency12Months?: InputMaybe<OrderBy>;
  InvoicingMethodMyPages?: InputMaybe<OrderBy>;
  InvoicingMethodPaper?: InputMaybe<OrderBy>;
  LastNameQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  MarketingConsentRequired?: InputMaybe<OrderBy>;
  MarketingDescription?: InputMaybe<OrderBy>;
  MarketingHeader?: InputMaybe<OrderBy>;
  MarketingNoLabel?: InputMaybe<OrderBy>;
  MarketingYesLabel?: InputMaybe<OrderBy>;
  MobilePhoneNumberQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  NordeaUnderCtaText?: InputMaybe<OrderBy>;
  PostalCodeQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  PricePageLinkText?: InputMaybe<OrderBy>;
  SsnMismatchErrorMessage?: InputMaybe<OrderBy>;
  SsnMismatchErrorTitle?: InputMaybe<OrderBy>;
  StreetAddressQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type IfCheckoutPageCheckoutPageCommonQuestionBase = {
  __typename?: 'IfCheckoutPageCheckoutPageCommonQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItem>>>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfCheckoutPageCheckoutPageCommonQuestionBaseFacet = {
  __typename?: 'IfCheckoutPageCheckoutPageCommonQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemFacet>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfCheckoutPageCheckoutPageCommonQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemOrderByInput>;
};

export type IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItem = {
  __typename?: 'IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemFacet = {
  __typename?: 'IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseValidationMessageItemWhereInput>;
};

export type IfCheckoutPageCheckoutPageCommonWhereInput = {
  AcceptTermsAdditionalInfo?: InputMaybe<SearchableStringFilterInput>;
  AcceptTermsAndConditionsQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  BadCreditErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  BadCreditErrorTitle?: InputMaybe<SearchableStringFilterInput>;
  BillingFrequencyQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  BillingHeader?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoAnnualTextMyPagesInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoAnnualTextPaperInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoMonthlyTextMyPagesInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoMonthlyTextPaperInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoQuarterSemiAnnualTextMyPagesInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInfoQuarterSemiAnnualTextPaperInvoice?: InputMaybe<SearchableStringFilterInput>;
  BillingInformation?: InputMaybe<SearchableStringFilterInput>;
  BillingMethodQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  CityQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  CompletePurchaseLoadingText?: InputMaybe<SearchableStringFilterInput>;
  EmailQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  FirstNameQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  InvoicingExistingCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingFrequency12Months?: InputMaybe<SearchableStringFilterInput>;
  InvoicingMethodMyPages?: InputMaybe<SearchableStringFilterInput>;
  InvoicingMethodPaper?: InputMaybe<SearchableStringFilterInput>;
  LastNameQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  MarketingConsentRequired?: InputMaybe<SearchableStringFilterInput>;
  MarketingDescription?: InputMaybe<SearchableStringFilterInput>;
  MarketingHeader?: InputMaybe<SearchableStringFilterInput>;
  MarketingNoLabel?: InputMaybe<SearchableStringFilterInput>;
  MarketingYesLabel?: InputMaybe<SearchableStringFilterInput>;
  MobilePhoneNumberQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  NordeaUnderCtaText?: InputMaybe<SearchableStringFilterInput>;
  PostalCodeQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  PricePageLinkText?: InputMaybe<SearchableStringFilterInput>;
  SsnMismatchErrorMessage?: InputMaybe<SearchableStringFilterInput>;
  SsnMismatchErrorTitle?: InputMaybe<SearchableStringFilterInput>;
  StreetAddressQuestion?: InputMaybe<IfCheckoutPageCheckoutPageCommonQuestionBaseWhereInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type IfCheckoutPageFacet = {
  __typename?: 'IfCheckoutPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CheckoutPageCommon?: Maybe<IfCheckoutPageCheckoutPageCommonFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfCheckoutPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCheckoutPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCheckoutPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCheckoutPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCheckoutPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCheckoutPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCheckoutPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfCheckoutPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CheckoutPageCommon?: InputMaybe<IfCheckoutPageCheckoutPageCommonOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfCheckoutPageOutput = {
  __typename?: 'IfCheckoutPageOutput';
  autocomplete?: Maybe<IfCheckoutPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfCheckoutPageFacet>;
  item?: Maybe<IfCheckoutPage>;
  items?: Maybe<Array<Maybe<IfCheckoutPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfCheckoutPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfCheckoutPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CheckoutPageCommon?: InputMaybe<IfCheckoutPageCheckoutPageCommonWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfCheckoutPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfCheckoutPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfCheckoutPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A page marking the common root */
export type IfCommonPage = IContent & IData & {
  __typename?: 'IfCommonPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A page marking the common root */
export type IfCommonPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page marking the common root */
export type IfCommonPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A page marking the common root */
export type IfCommonPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfCommonPageAutocomplete = {
  __typename?: 'IfCommonPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfCommonPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfCommonPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfCommonPageFacet = {
  __typename?: 'IfCommonPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfCommonPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCommonPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCommonPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCommonPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCommonPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfCommonPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfCommonPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfCommonPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfCommonPageOutput = {
  __typename?: 'IfCommonPageOutput';
  autocomplete?: Maybe<IfCommonPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfCommonPageFacet>;
  item?: Maybe<IfCommonPage>;
  items?: Maybe<Array<Maybe<IfCommonPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfCommonPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfCommonPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfCommonPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfCommonPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfCommonPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An page containing the confirmation content. */
export type IfConfirmationPage = IContent & IData & {
  __typename?: 'IfConfirmationPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationPageCommon?: Maybe<IfConfirmationPageConfirmationPageCommon>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An page containing the confirmation content. */
export type IfConfirmationPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the confirmation content. */
export type IfConfirmationPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the confirmation content. */
export type IfConfirmationPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfConfirmationPageAutocomplete = {
  __typename?: 'IfConfirmationPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfConfirmationPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfConfirmationPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfConfirmationPageConfirmationPageCommon = {
  __typename?: 'IfConfirmationPageConfirmationPageCommon';
  AboutInsuranceSectionHeaderText?: Maybe<Scalars['String']['output']>;
  AddOnHeaderText?: Maybe<Scalars['String']['output']>;
  CancellationBlock?: Maybe<Scalars['String']['output']>;
  DiscountText?: Maybe<Scalars['String']['output']>;
  InvoicingInfoExistingCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingInfoNewCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingSectionHeader?: Maybe<Scalars['String']['output']>;
  LogoutLink?: Maybe<Scalars['String']['output']>;
  LogoutLinkText?: Maybe<Scalars['String']['output']>;
  LogoutText?: Maybe<Scalars['String']['output']>;
  MyPagesButtonText?: Maybe<Scalars['String']['output']>;
  MyPagesScaluText?: Maybe<Scalars['String']['output']>;
  MyPagesSectionHeader?: Maybe<Scalars['String']['output']>;
  MyPagesText?: Maybe<Scalars['String']['output']>;
  NordeaCampaignInfo?: Maybe<Scalars['String']['output']>;
  PageHeaderText?: Maybe<Scalars['String']['output']>;
  SecondaryHeader?: Maybe<Scalars['String']['output']>;
  TotalAmount?: Maybe<Scalars['String']['output']>;
};


export type IfConfirmationPageConfirmationPageCommonAboutInsuranceSectionHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonAddOnHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonCancellationBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonDiscountTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonInvoicingInfoExistingCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonInvoicingInfoNewCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonInvoicingSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonLogoutLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonLogoutLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonLogoutTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonMyPagesButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonMyPagesScaluTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonMyPagesSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonMyPagesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonNordeaCampaignInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonPageHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonSecondaryHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfConfirmationPageConfirmationPageCommonTotalAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfConfirmationPageConfirmationPageCommonFacet = {
  __typename?: 'IfConfirmationPageConfirmationPageCommonFacet';
  AboutInsuranceSectionHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  AddOnHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  CancellationBlock?: Maybe<Array<Maybe<StringFacet>>>;
  DiscountText?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoExistingCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoNewCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLink?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesScaluText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesText?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignInfo?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  SecondaryHeader?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmount?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfConfirmationPageConfirmationPageCommonFacetAboutInsuranceSectionHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetAddOnHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetCancellationBlockArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetDiscountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetInvoicingInfoExistingCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetInvoicingInfoNewCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetInvoicingSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetLogoutLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetLogoutLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetLogoutTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetMyPagesButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetMyPagesScaluTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetMyPagesSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetMyPagesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetNordeaCampaignInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetPageHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetSecondaryHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageConfirmationPageCommonFacetTotalAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfConfirmationPageConfirmationPageCommonOrderByInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<OrderBy>;
  AddOnHeaderText?: InputMaybe<OrderBy>;
  CancellationBlock?: InputMaybe<OrderBy>;
  DiscountText?: InputMaybe<OrderBy>;
  InvoicingInfoExistingCustomer?: InputMaybe<OrderBy>;
  InvoicingInfoNewCustomer?: InputMaybe<OrderBy>;
  InvoicingSectionHeader?: InputMaybe<OrderBy>;
  LogoutLink?: InputMaybe<OrderBy>;
  LogoutLinkText?: InputMaybe<OrderBy>;
  LogoutText?: InputMaybe<OrderBy>;
  MyPagesButtonText?: InputMaybe<OrderBy>;
  MyPagesScaluText?: InputMaybe<OrderBy>;
  MyPagesSectionHeader?: InputMaybe<OrderBy>;
  MyPagesText?: InputMaybe<OrderBy>;
  NordeaCampaignInfo?: InputMaybe<OrderBy>;
  PageHeaderText?: InputMaybe<OrderBy>;
  SecondaryHeader?: InputMaybe<OrderBy>;
  TotalAmount?: InputMaybe<OrderBy>;
};

export type IfConfirmationPageConfirmationPageCommonWhereInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<SearchableStringFilterInput>;
  AddOnHeaderText?: InputMaybe<SearchableStringFilterInput>;
  CancellationBlock?: InputMaybe<SearchableStringFilterInput>;
  DiscountText?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoExistingCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoNewCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  LogoutLink?: InputMaybe<SearchableStringFilterInput>;
  LogoutLinkText?: InputMaybe<SearchableStringFilterInput>;
  LogoutText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesButtonText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesScaluText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  MyPagesText?: InputMaybe<SearchableStringFilterInput>;
  NordeaCampaignInfo?: InputMaybe<SearchableStringFilterInput>;
  PageHeaderText?: InputMaybe<SearchableStringFilterInput>;
  SecondaryHeader?: InputMaybe<SearchableStringFilterInput>;
  TotalAmount?: InputMaybe<SearchableStringFilterInput>;
};

export type IfConfirmationPageFacet = {
  __typename?: 'IfConfirmationPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationPageCommon?: Maybe<IfConfirmationPageConfirmationPageCommonFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfConfirmationPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfConfirmationPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfConfirmationPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfConfirmationPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfConfirmationPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfConfirmationPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfConfirmationPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfConfirmationPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationPageCommon?: InputMaybe<IfConfirmationPageConfirmationPageCommonOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfConfirmationPageOutput = {
  __typename?: 'IfConfirmationPageOutput';
  autocomplete?: Maybe<IfConfirmationPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfConfirmationPageFacet>;
  item?: Maybe<IfConfirmationPage>;
  items?: Maybe<Array<Maybe<IfConfirmationPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfConfirmationPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfConfirmationPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationPageCommon?: InputMaybe<IfConfirmationPageConfirmationPageCommonWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfConfirmationPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfConfirmationPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfConfirmationPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An page mainly containing content areas. */
export type IfContentPage = IContent & IData & {
  __typename?: 'IfContentPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SourcePageContentGuid?: Maybe<Scalars['String']['output']>;
  SourcePageName?: Maybe<Scalars['String']['output']>;
  SourcePageTypeName?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An page mainly containing content areas. */
export type IfContentPageMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page mainly containing content areas. */
export type IfContentPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page mainly containing content areas. */
export type IfContentPageSourcePageContentGuidArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page mainly containing content areas. */
export type IfContentPageSourcePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page mainly containing content areas. */
export type IfContentPageSourcePageTypeNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page mainly containing content areas. */
export type IfContentPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page mainly containing content areas. */
export type IfContentPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfContentPageAutocomplete = {
  __typename?: 'IfContentPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfContentPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfContentPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfContentPageFacet = {
  __typename?: 'IfContentPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SourcePageContentGuid?: Maybe<Array<Maybe<StringFacet>>>;
  SourcePageName?: Maybe<Array<Maybe<StringFacet>>>;
  SourcePageTypeName?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfContentPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfContentPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfContentPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfContentPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetSourcePageContentGuidArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetSourcePageNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetSourcePageTypeNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfContentPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfContentPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfContentPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfContentPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SourcePageContentGuid?: InputMaybe<OrderBy>;
  SourcePageName?: InputMaybe<OrderBy>;
  SourcePageTypeName?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfContentPageOutput = {
  __typename?: 'IfContentPageOutput';
  autocomplete?: Maybe<IfContentPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfContentPageFacet>;
  item?: Maybe<IfContentPage>;
  items?: Maybe<Array<Maybe<IfContentPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfContentPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfContentPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SourcePageContentGuid?: InputMaybe<SearchableStringFilterInput>;
  SourcePageName?: InputMaybe<SearchableStringFilterInput>;
  SourcePageTypeName?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfContentPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfContentPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfContentPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The root of an Domain hierarchy. */
export type IfDomainPage = IContent & IData & {
  __typename?: 'IfDomainPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** The root of an Domain hierarchy. */
export type IfDomainPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The root of an Domain hierarchy. */
export type IfDomainPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The root of an Domain hierarchy. */
export type IfDomainPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfDomainPageAutocomplete = {
  __typename?: 'IfDomainPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfDomainPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfDomainPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfDomainPageFacet = {
  __typename?: 'IfDomainPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfDomainPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfDomainPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfDomainPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfDomainPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfDomainPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfDomainPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfDomainPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfDomainPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfDomainPageOutput = {
  __typename?: 'IfDomainPageOutput';
  autocomplete?: Maybe<IfDomainPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfDomainPageFacet>;
  item?: Maybe<IfDomainPage>;
  items?: Maybe<Array<Maybe<IfDomainPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfDomainPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfDomainPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfDomainPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfDomainPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfDomainPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An entry page for an If product. */
export type IfEntryPage = IContent & IData & {
  __typename?: 'IfEntryPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EntryPageCommon?: Maybe<IfEntryPageEntryPageCommon>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An entry page for an If product. */
export type IfEntryPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An entry page for an If product. */
export type IfEntryPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An entry page for an If product. */
export type IfEntryPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfEntryPageAutocomplete = {
  __typename?: 'IfEntryPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfEntryPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfEntryPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfEntryPageEntryPageCommon = {
  __typename?: 'IfEntryPageEntryPageCommon';
  Description?: Maybe<Scalars['String']['output']>;
  SsnQuestion?: Maybe<IfEntryPageEntryPageCommonQuestionBase>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Terms?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type IfEntryPageEntryPageCommonDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfEntryPageEntryPageCommonSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfEntryPageEntryPageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfEntryPageEntryPageCommonTermsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfEntryPageEntryPageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfEntryPageEntryPageCommonFacet = {
  __typename?: 'IfEntryPageEntryPageCommonFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  SsnQuestion?: Maybe<IfEntryPageEntryPageCommonQuestionBaseFacet>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Terms?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfEntryPageEntryPageCommonFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageEntryPageCommonFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageEntryPageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageEntryPageCommonFacetTermsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageEntryPageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfEntryPageEntryPageCommonOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  SsnQuestion?: InputMaybe<IfEntryPageEntryPageCommonQuestionBaseOrderByInput>;
  SubTitle?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Terms?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type IfEntryPageEntryPageCommonQuestionBase = {
  __typename?: 'IfEntryPageEntryPageCommonQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<IfEntryPageEntryPageCommonQuestionBaseValidationMessageItem>>>;
};


export type IfEntryPageEntryPageCommonQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfEntryPageEntryPageCommonQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfEntryPageEntryPageCommonQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfEntryPageEntryPageCommonQuestionBaseFacet = {
  __typename?: 'IfEntryPageEntryPageCommonQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet>;
};


export type IfEntryPageEntryPageCommonQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageEntryPageCommonQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageEntryPageCommonQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfEntryPageEntryPageCommonQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemOrderByInput>;
};

export type IfEntryPageEntryPageCommonQuestionBaseValidationMessageItem = {
  __typename?: 'IfEntryPageEntryPageCommonQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet = {
  __typename?: 'IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type IfEntryPageEntryPageCommonQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<IfEntryPageEntryPageCommonQuestionBaseValidationMessageItemWhereInput>;
};

export type IfEntryPageEntryPageCommonWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  SsnQuestion?: InputMaybe<IfEntryPageEntryPageCommonQuestionBaseWhereInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Terms?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type IfEntryPageFacet = {
  __typename?: 'IfEntryPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EntryPageCommon?: Maybe<IfEntryPageEntryPageCommonFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfEntryPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfEntryPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfEntryPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfEntryPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfEntryPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfEntryPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfEntryPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfEntryPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EntryPageCommon?: InputMaybe<IfEntryPageEntryPageCommonOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfEntryPageOutput = {
  __typename?: 'IfEntryPageOutput';
  autocomplete?: Maybe<IfEntryPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfEntryPageFacet>;
  item?: Maybe<IfEntryPage>;
  items?: Maybe<Array<Maybe<IfEntryPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfEntryPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfEntryPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EntryPageCommon?: InputMaybe<IfEntryPageEntryPageCommonWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfEntryPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfEntryPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfEntryPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The root of an Experience hierarchy. */
export type IfExperiencePage = IContent & IData & {
  __typename?: 'IfExperiencePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** The root of an Experience hierarchy. */
export type IfExperiencePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The root of an Experience hierarchy. */
export type IfExperiencePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The root of an Experience hierarchy. */
export type IfExperiencePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfExperiencePageAutocomplete = {
  __typename?: 'IfExperiencePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfExperiencePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfExperiencePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfExperiencePageFacet = {
  __typename?: 'IfExperiencePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfExperiencePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfExperiencePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfExperiencePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfExperiencePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfExperiencePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfExperiencePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfExperiencePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfExperiencePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfExperiencePageOutput = {
  __typename?: 'IfExperiencePageOutput';
  autocomplete?: Maybe<IfExperiencePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfExperiencePageFacet>;
  item?: Maybe<IfExperiencePage>;
  items?: Maybe<Array<Maybe<IfExperiencePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfExperiencePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfExperiencePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfExperiencePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfExperiencePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfExperiencePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Container page for migrated If content pages. */
export type IfMigrationFolderPage = IContent & IData & {
  __typename?: 'IfMigrationFolderPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Container page for migrated If content pages. */
export type IfMigrationFolderPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container page for migrated If content pages. */
export type IfMigrationFolderPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Container page for migrated If content pages. */
export type IfMigrationFolderPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfMigrationFolderPageAutocomplete = {
  __typename?: 'IfMigrationFolderPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfMigrationFolderPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfMigrationFolderPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfMigrationFolderPageFacet = {
  __typename?: 'IfMigrationFolderPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfMigrationFolderPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfMigrationFolderPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfMigrationFolderPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfMigrationFolderPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfMigrationFolderPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfMigrationFolderPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfMigrationFolderPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfMigrationFolderPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfMigrationFolderPageOutput = {
  __typename?: 'IfMigrationFolderPageOutput';
  autocomplete?: Maybe<IfMigrationFolderPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfMigrationFolderPageFacet>;
  item?: Maybe<IfMigrationFolderPage>;
  items?: Maybe<Array<Maybe<IfMigrationFolderPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfMigrationFolderPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfMigrationFolderPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfMigrationFolderPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfMigrationFolderPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfMigrationFolderPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An price page for If domain. */
export type IfPricePage = IContent & IData & {
  __typename?: 'IfPricePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PricePageCommon?: Maybe<IfPricePagePricePageCommon>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An price page for If domain. */
export type IfPricePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An price page for If domain. */
export type IfPricePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An price page for If domain. */
export type IfPricePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfPricePageAutocomplete = {
  __typename?: 'IfPricePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PricePageCommon?: Maybe<IfPricePagePricePageCommonAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfPricePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfPricePageFacet = {
  __typename?: 'IfPricePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PricePageCommon?: Maybe<IfPricePagePricePageCommonFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfPricePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfPricePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfPricePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfPricePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfPricePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfPricePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfPricePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PricePageCommon?: InputMaybe<IfPricePagePricePageCommonOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfPricePageOutput = {
  __typename?: 'IfPricePageOutput';
  autocomplete?: Maybe<IfPricePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfPricePageFacet>;
  item?: Maybe<IfPricePage>;
  items?: Maybe<Array<Maybe<IfPricePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfPricePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfPricePagePricePageCommon = {
  __typename?: 'IfPricePagePricePageCommon';
  AboutBonusesModal?: Maybe<IfPricePagePricePageCommonLabelBase>;
  AddonNotSelectableText?: Maybe<Scalars['String']['output']>;
  BonusHeaderOptionOne?: Maybe<Scalars['String']['output']>;
  BonusHeaderOptionTwo?: Maybe<Scalars['String']['output']>;
  BonusItems?: Maybe<Array<Maybe<IfPricePagePricePageCommonBonusItem>>>;
  BonusLabel?: Maybe<Scalars['String']['output']>;
  ContinuePurchaseLoaderText?: Maybe<Scalars['String']['output']>;
  DeductibleAmountSelector?: Maybe<IfPricePagePricePageCommonLabelBase>;
  EditButtonText?: Maybe<Scalars['String']['output']>;
  ErrorMessageNoSelected?: Maybe<Scalars['String']['output']>;
  FixedPriceText?: Maybe<Scalars['String']['output']>;
  IncludedItemsHeader?: Maybe<Scalars['String']['output']>;
  InsuranceAmountSelector?: Maybe<IfPricePagePricePageCommonLabelBase>;
  NoCoverageSelectedForAddons?: Maybe<Scalars['String']['output']>;
  NordeaCampaignSummary?: Maybe<IfPricePagePricePageCommonLabelBase>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  RecalculatingLoaderText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageTitle?: Maybe<Scalars['String']['output']>;
  SelectAddonsHeader?: Maybe<Scalars['String']['output']>;
  SelectInsuranceAmountText?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TopQuestionsTitle?: Maybe<Scalars['String']['output']>;
};


export type IfPricePagePricePageCommonAddonNotSelectableTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonBonusHeaderOptionOneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonBonusHeaderOptionTwoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonBonusLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonContinuePurchaseLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonEditButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonFixedPriceTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonIncludedItemsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonRecalculatingLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonRecommendedCoverageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonRecommendedCoverageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonSelectAddonsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfPricePagePricePageCommonAutocomplete = {
  __typename?: 'IfPricePagePricePageCommonAutocomplete';
  ErrorMessageNoSelected?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfPricePagePricePageCommonAutocompleteErrorMessageNoSelectedArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePagePricePageCommonAutocompleteNoCoverageSelectedForAddonsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePagePricePageCommonAutocompleteSelectInsuranceAmountTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfPricePagePricePageCommonAutocompleteTopQuestionsTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfPricePagePricePageCommonBonusItem = {
  __typename?: 'IfPricePagePricePageCommonBonusItem';
  Label?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type IfPricePagePricePageCommonBonusItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonBonusItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfPricePagePricePageCommonBonusItemFacet = {
  __typename?: 'IfPricePagePricePageCommonBonusItemFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfPricePagePricePageCommonBonusItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonBonusItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfPricePagePricePageCommonBonusItemOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type IfPricePagePricePageCommonBonusItemWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type IfPricePagePricePageCommonFacet = {
  __typename?: 'IfPricePagePricePageCommonFacet';
  AboutBonusesModal?: Maybe<IfPricePagePricePageCommonLabelBaseFacet>;
  AddonNotSelectableText?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionOne?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionTwo?: Maybe<Array<Maybe<StringFacet>>>;
  BonusItems?: Maybe<IfPricePagePricePageCommonBonusItemFacet>;
  BonusLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContinuePurchaseLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  DeductibleAmountSelector?: Maybe<IfPricePagePricePageCommonLabelBaseFacet>;
  EditButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorMessageNoSelected?: Maybe<Array<Maybe<StringFacet>>>;
  FixedPriceText?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedItemsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  InsuranceAmountSelector?: Maybe<IfPricePagePricePageCommonLabelBaseFacet>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignSummary?: Maybe<IfPricePagePricePageCommonLabelBaseFacet>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RecalculatingLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SelectAddonsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfPricePagePricePageCommonFacetAddonNotSelectableTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetBonusHeaderOptionOneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetBonusHeaderOptionTwoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetBonusLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetContinuePurchaseLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetEditButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetErrorMessageNoSelectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetFixedPriceTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetIncludedItemsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetNoCoverageSelectedForAddonsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetRecalculatingLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetRecommendedCoverageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetRecommendedCoverageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetSelectAddonsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetSelectInsuranceAmountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonFacetTopQuestionsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfPricePagePricePageCommonLabelBase = {
  __typename?: 'IfPricePagePricePageCommonLabelBase';
  Content?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
};


export type IfPricePagePricePageCommonLabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonLabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfPricePagePricePageCommonLabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfPricePagePricePageCommonLabelBaseFacet = {
  __typename?: 'IfPricePagePricePageCommonLabelBaseFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfPricePagePricePageCommonLabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonLabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfPricePagePricePageCommonLabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfPricePagePricePageCommonLabelBaseOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
};

export type IfPricePagePricePageCommonLabelBaseWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
};

export type IfPricePagePricePageCommonOrderByInput = {
  AboutBonusesModal?: InputMaybe<IfPricePagePricePageCommonLabelBaseOrderByInput>;
  AddonNotSelectableText?: InputMaybe<OrderBy>;
  BonusHeaderOptionOne?: InputMaybe<OrderBy>;
  BonusHeaderOptionTwo?: InputMaybe<OrderBy>;
  BonusItems?: InputMaybe<IfPricePagePricePageCommonBonusItemOrderByInput>;
  BonusLabel?: InputMaybe<OrderBy>;
  ContinuePurchaseLoaderText?: InputMaybe<OrderBy>;
  DeductibleAmountSelector?: InputMaybe<IfPricePagePricePageCommonLabelBaseOrderByInput>;
  EditButtonText?: InputMaybe<OrderBy>;
  ErrorMessageNoSelected?: InputMaybe<OrderBy>;
  FixedPriceText?: InputMaybe<OrderBy>;
  IncludedItemsHeader?: InputMaybe<OrderBy>;
  InsuranceAmountSelector?: InputMaybe<IfPricePagePricePageCommonLabelBaseOrderByInput>;
  NoCoverageSelectedForAddons?: InputMaybe<OrderBy>;
  NordeaCampaignSummary?: InputMaybe<IfPricePagePricePageCommonLabelBaseOrderByInput>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  RecalculatingLoaderText?: InputMaybe<OrderBy>;
  RecommendedCoverageText?: InputMaybe<OrderBy>;
  RecommendedCoverageTitle?: InputMaybe<OrderBy>;
  SelectAddonsHeader?: InputMaybe<OrderBy>;
  SelectInsuranceAmountText?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopQuestionsTitle?: InputMaybe<OrderBy>;
};

export type IfPricePagePricePageCommonWhereInput = {
  AboutBonusesModal?: InputMaybe<IfPricePagePricePageCommonLabelBaseWhereInput>;
  AddonNotSelectableText?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionOne?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionTwo?: InputMaybe<SearchableStringFilterInput>;
  BonusItems?: InputMaybe<IfPricePagePricePageCommonBonusItemWhereInput>;
  BonusLabel?: InputMaybe<SearchableStringFilterInput>;
  ContinuePurchaseLoaderText?: InputMaybe<SearchableStringFilterInput>;
  DeductibleAmountSelector?: InputMaybe<IfPricePagePricePageCommonLabelBaseWhereInput>;
  EditButtonText?: InputMaybe<SearchableStringFilterInput>;
  ErrorMessageNoSelected?: InputMaybe<StringFilterInput>;
  FixedPriceText?: InputMaybe<SearchableStringFilterInput>;
  IncludedItemsHeader?: InputMaybe<SearchableStringFilterInput>;
  InsuranceAmountSelector?: InputMaybe<IfPricePagePricePageCommonLabelBaseWhereInput>;
  NoCoverageSelectedForAddons?: InputMaybe<StringFilterInput>;
  NordeaCampaignSummary?: InputMaybe<IfPricePagePricePageCommonLabelBaseWhereInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  RecalculatingLoaderText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageTitle?: InputMaybe<SearchableStringFilterInput>;
  SelectAddonsHeader?: InputMaybe<SearchableStringFilterInput>;
  SelectInsuranceAmountText?: InputMaybe<StringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopQuestionsTitle?: InputMaybe<StringFilterInput>;
};

export type IfPricePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PricePageCommon?: InputMaybe<IfPricePagePricePageCommonWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfPricePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfPricePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfPricePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A product definition. */
export type IfProduct = IContent & IData & {
  __typename?: 'IfProduct';
  Addons?: Maybe<Array<Maybe<IfProductAddon>>>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** for example: 'MATKA', 'KOTI', etc. */
  CoreName?: Maybe<Scalars['String']['output']>;
  Coverages?: Maybe<Array<Maybe<IfProductCoverage>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Coverage Included Items For The Different Coverages */
  IncludedItems?: Maybe<Array<Maybe<IfProductIncludedItem>>>;
  /** Can be used to identify the product internally or for tracking, for instance can be set to the product's AGP ID. */
  InternalId?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** for example: 'travel', 'householder', etc. */
  ProductType?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Terms And Condition Items For The Product */
  TermsAndConditions?: Maybe<Array<Maybe<IfProductTermsAndConditionItem>>>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A product definition. */
export type IfProductCoreNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A product definition. */
export type IfProductInternalIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A product definition. */
export type IfProductNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A product definition. */
export type IfProductProductTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A product definition. */
export type IfProduct_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A product definition. */
export type IfProduct_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfProductAddon = {
  __typename?: 'IfProductAddon';
  CoreName?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  FixedPrice?: Maybe<Scalars['Bool']['output']>;
  ModalDescription?: Maybe<Scalars['String']['output']>;
  Recommended?: Maybe<Scalars['Bool']['output']>;
  RecommendedLabel?: Maybe<Scalars['String']['output']>;
  SellingPoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SortOrder?: Maybe<Scalars['Int']['output']>;
};


export type IfProductAddonCoreNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductAddonDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductAddonDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductAddonModalDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductAddonRecommendedLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfProductAddonAutocomplete = {
  __typename?: 'IfProductAddonAutocomplete';
  SellingPoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfProductAddonAutocompleteSellingPointsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfProductAddonFacet = {
  __typename?: 'IfProductAddonFacet';
  CoreName?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  FixedPrice?: Maybe<Array<Maybe<StringFacet>>>;
  ModalDescription?: Maybe<Array<Maybe<StringFacet>>>;
  Recommended?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SellingPoints?: Maybe<Array<Maybe<StringFacet>>>;
  SortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfProductAddonFacetCoreNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductAddonFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductAddonFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductAddonFacetFixedPriceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductAddonFacetModalDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductAddonFacetRecommendedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductAddonFacetRecommendedLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductAddonFacetSellingPointsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductAddonFacetSortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfProductAddonOrderByInput = {
  CoreName?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisplayName?: InputMaybe<OrderBy>;
  FixedPrice?: InputMaybe<OrderBy>;
  ModalDescription?: InputMaybe<OrderBy>;
  Recommended?: InputMaybe<OrderBy>;
  RecommendedLabel?: InputMaybe<OrderBy>;
  SellingPoints?: InputMaybe<OrderBy>;
  SortOrder?: InputMaybe<OrderBy>;
};

export type IfProductAddonWhereInput = {
  CoreName?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  FixedPrice?: InputMaybe<BoolFilterInput>;
  ModalDescription?: InputMaybe<SearchableStringFilterInput>;
  Recommended?: InputMaybe<BoolFilterInput>;
  RecommendedLabel?: InputMaybe<SearchableStringFilterInput>;
  SellingPoints?: InputMaybe<StringFilterInput>;
  SortOrder?: InputMaybe<IntFilterInput>;
};

export type IfProductAutocomplete = {
  __typename?: 'IfProductAutocomplete';
  Addons?: Maybe<IfProductAddonAutocomplete>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfProductAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfProductAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfProductCoverage = {
  __typename?: 'IfProductCoverage';
  CoreName?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  FixedPrice?: Maybe<Scalars['Bool']['output']>;
  Recommended?: Maybe<Scalars['Bool']['output']>;
  SortOrder?: Maybe<Scalars['Int']['output']>;
};


export type IfProductCoverageCoreNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductCoverageDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductCoverageDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfProductCoverageFacet = {
  __typename?: 'IfProductCoverageFacet';
  CoreName?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  FixedPrice?: Maybe<Array<Maybe<StringFacet>>>;
  Recommended?: Maybe<Array<Maybe<StringFacet>>>;
  SortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfProductCoverageFacetCoreNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductCoverageFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductCoverageFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductCoverageFacetFixedPriceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductCoverageFacetRecommendedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductCoverageFacetSortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfProductCoverageOrderByInput = {
  CoreName?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  DisplayName?: InputMaybe<OrderBy>;
  FixedPrice?: InputMaybe<OrderBy>;
  Recommended?: InputMaybe<OrderBy>;
  SortOrder?: InputMaybe<OrderBy>;
};

export type IfProductCoverageWhereInput = {
  CoreName?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  FixedPrice?: InputMaybe<BoolFilterInput>;
  Recommended?: InputMaybe<BoolFilterInput>;
  SortOrder?: InputMaybe<IntFilterInput>;
};

export type IfProductFacet = {
  __typename?: 'IfProductFacet';
  Addons?: Maybe<IfProductAddonFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CoreName?: Maybe<Array<Maybe<StringFacet>>>;
  Coverages?: Maybe<IfProductCoverageFacet>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IncludedItems?: Maybe<IfProductIncludedItemFacet>;
  InternalId?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ProductType?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TermsAndConditions?: Maybe<IfProductTermsAndConditionItemFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfProductFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfProductFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetCoreNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfProductFacetInternalIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetProductTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfProductFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfProductFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfProductFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfProductIncludedItem = {
  __typename?: 'IfProductIncludedItem';
  Icon?: Maybe<Scalars['String']['output']>;
  IncludedWithCoverages?: Maybe<Scalars['String']['output']>;
  ItemName?: Maybe<Scalars['String']['output']>;
  PopoverText?: Maybe<Scalars['String']['output']>;
  RowExpandedText?: Maybe<Scalars['String']['output']>;
  SortOrder?: Maybe<Scalars['Int']['output']>;
};


export type IfProductIncludedItemIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductIncludedItemIncludedWithCoveragesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductIncludedItemItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductIncludedItemPopoverTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductIncludedItemRowExpandedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfProductIncludedItemFacet = {
  __typename?: 'IfProductIncludedItemFacet';
  Icon?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedWithCoverages?: Maybe<Array<Maybe<StringFacet>>>;
  ItemName?: Maybe<Array<Maybe<StringFacet>>>;
  PopoverText?: Maybe<Array<Maybe<StringFacet>>>;
  RowExpandedText?: Maybe<Array<Maybe<StringFacet>>>;
  SortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfProductIncludedItemFacetIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductIncludedItemFacetIncludedWithCoveragesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductIncludedItemFacetItemNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductIncludedItemFacetPopoverTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductIncludedItemFacetRowExpandedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductIncludedItemFacetSortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfProductIncludedItemOrderByInput = {
  Icon?: InputMaybe<OrderBy>;
  IncludedWithCoverages?: InputMaybe<OrderBy>;
  ItemName?: InputMaybe<OrderBy>;
  PopoverText?: InputMaybe<OrderBy>;
  RowExpandedText?: InputMaybe<OrderBy>;
  SortOrder?: InputMaybe<OrderBy>;
};

export type IfProductIncludedItemWhereInput = {
  Icon?: InputMaybe<SearchableStringFilterInput>;
  IncludedWithCoverages?: InputMaybe<SearchableStringFilterInput>;
  ItemName?: InputMaybe<SearchableStringFilterInput>;
  PopoverText?: InputMaybe<SearchableStringFilterInput>;
  RowExpandedText?: InputMaybe<SearchableStringFilterInput>;
  SortOrder?: InputMaybe<IntFilterInput>;
};

export type IfProductOrderByInput = {
  Addons?: InputMaybe<IfProductAddonOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CoreName?: InputMaybe<OrderBy>;
  Coverages?: InputMaybe<IfProductCoverageOrderByInput>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IncludedItems?: InputMaybe<IfProductIncludedItemOrderByInput>;
  InternalId?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ProductType?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TermsAndConditions?: InputMaybe<IfProductTermsAndConditionItemOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfProductOutput = {
  __typename?: 'IfProductOutput';
  autocomplete?: Maybe<IfProductAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfProductFacet>;
  item?: Maybe<IfProduct>;
  items?: Maybe<Array<Maybe<IfProduct>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfProductOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfProductTermsAndConditionItem = {
  __typename?: 'IfProductTermsAndConditionItem';
  Href?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
};


export type IfProductTermsAndConditionItemHrefArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfProductTermsAndConditionItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfProductTermsAndConditionItemFacet = {
  __typename?: 'IfProductTermsAndConditionItemFacet';
  Href?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfProductTermsAndConditionItemFacetHrefArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfProductTermsAndConditionItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfProductTermsAndConditionItemOrderByInput = {
  Href?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
};

export type IfProductTermsAndConditionItemWhereInput = {
  Href?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
};

export type IfProductWhereInput = {
  Addons?: InputMaybe<IfProductAddonWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CoreName?: InputMaybe<SearchableStringFilterInput>;
  Coverages?: InputMaybe<IfProductCoverageWhereInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IncludedItems?: InputMaybe<IfProductIncludedItemWhereInput>;
  InternalId?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ProductType?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TermsAndConditions?: InputMaybe<IfProductTermsAndConditionItemWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfProductWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfProductWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfProductWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The root of a If site. */
export type IfSitePage = IContent & IData & {
  __typename?: 'IfSitePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** The root of a If site. */
export type IfSitePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The root of a If site. */
export type IfSitePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The root of a If site. */
export type IfSitePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfSitePageAutocomplete = {
  __typename?: 'IfSitePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfSitePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfSitePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfSitePageFacet = {
  __typename?: 'IfSitePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfSitePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfSitePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfSitePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfSitePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfSitePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfSitePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfSitePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfSitePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfSitePageOutput = {
  __typename?: 'IfSitePageOutput';
  autocomplete?: Maybe<IfSitePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfSitePageFacet>;
  item?: Maybe<IfSitePage>;
  items?: Maybe<Array<Maybe<IfSitePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfSitePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfSitePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfSitePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfSitePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfSitePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An top questions page for If products */
export type IfTopQuestionsPage = IContent & IData & {
  __typename?: 'IfTopQuestionsPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopQuestionCommon?: Maybe<IfTopQuestionsPageTopQuestionsCommon>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An top questions page for If products */
export type IfTopQuestionsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An top questions page for If products */
export type IfTopQuestionsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An top questions page for If products */
export type IfTopQuestionsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfTopQuestionsPageAutocomplete = {
  __typename?: 'IfTopQuestionsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfTopQuestionsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfTopQuestionsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfTopQuestionsPageFacet = {
  __typename?: 'IfTopQuestionsPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopQuestionCommon?: Maybe<IfTopQuestionsPageTopQuestionsCommonFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfTopQuestionsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfTopQuestionsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfTopQuestionsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfTopQuestionsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfTopQuestionsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfTopQuestionsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfTopQuestionsPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopQuestionCommon?: InputMaybe<IfTopQuestionsPageTopQuestionsCommonOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfTopQuestionsPageOutput = {
  __typename?: 'IfTopQuestionsPageOutput';
  autocomplete?: Maybe<IfTopQuestionsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfTopQuestionsPageFacet>;
  item?: Maybe<IfTopQuestionsPage>;
  items?: Maybe<Array<Maybe<IfTopQuestionsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfTopQuestionsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfTopQuestionsPageTopQuestionsCommon = {
  __typename?: 'IfTopQuestionsPageTopQuestionsCommon';
  FormTitle?: Maybe<Scalars['String']['output']>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type IfTopQuestionsPageTopQuestionsCommonFormTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfTopQuestionsPageTopQuestionsCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfTopQuestionsPageTopQuestionsCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IfTopQuestionsPageTopQuestionsCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type IfTopQuestionsPageTopQuestionsCommonFacet = {
  __typename?: 'IfTopQuestionsPageTopQuestionsCommonFacet';
  FormTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IfTopQuestionsPageTopQuestionsCommonFacetFormTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageTopQuestionsCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageTopQuestionsCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfTopQuestionsPageTopQuestionsCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IfTopQuestionsPageTopQuestionsCommonOrderByInput = {
  FormTitle?: InputMaybe<OrderBy>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type IfTopQuestionsPageTopQuestionsCommonWhereInput = {
  FormTitle?: InputMaybe<SearchableStringFilterInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type IfTopQuestionsPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopQuestionCommon?: InputMaybe<IfTopQuestionsPageTopQuestionsCommonWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfTopQuestionsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfTopQuestionsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfTopQuestionsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** The root of an Webshop hierarchy. */
export type IfWebshopPage = IContent & IData & {
  __typename?: 'IfWebshopPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** The root of an Webshop hierarchy. */
export type IfWebshopPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The root of an Webshop hierarchy. */
export type IfWebshopPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** The root of an Webshop hierarchy. */
export type IfWebshopPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IfWebshopPageAutocomplete = {
  __typename?: 'IfWebshopPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IfWebshopPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IfWebshopPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IfWebshopPageFacet = {
  __typename?: 'IfWebshopPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IfWebshopPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfWebshopPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfWebshopPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfWebshopPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfWebshopPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IfWebshopPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IfWebshopPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IfWebshopPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IfWebshopPageOutput = {
  __typename?: 'IfWebshopPageOutput';
  autocomplete?: Maybe<IfWebshopPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IfWebshopPageFacet>;
  item?: Maybe<IfWebshopPage>;
  items?: Maybe<Array<Maybe<IfWebshopPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IfWebshopPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IfWebshopPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IfWebshopPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IfWebshopPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IfWebshopPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Describe an included item for 1 or more coverages. */
export type IncludedItem = IContent & IData & {
  __typename?: 'IncludedItem';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Display this icon for the included item row. */
  Icon?: Maybe<Scalars['String']['output']>;
  /** Which coverages should display this in it's list of coverage items. If add new coverages might need to refresh the page to see them here. */
  IncludedWithCoverages?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** Coverage item name */
  ItemName?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** When clicking the ? icon display this text. */
  PopoverText?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  /** When expanding the included item row, display this text. */
  RowExpandedText?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  /** Order relative to other coverage items */
  SortOrder?: Maybe<Scalars['Int']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Describe an included item for 1 or more coverages. */
export type IncludedItemIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Describe an included item for 1 or more coverages. */
export type IncludedItemIncludedWithCoveragesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Describe an included item for 1 or more coverages. */
export type IncludedItemItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Describe an included item for 1 or more coverages. */
export type IncludedItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Describe an included item for 1 or more coverages. */
export type IncludedItemPopoverTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Describe an included item for 1 or more coverages. */
export type IncludedItemRowExpandedTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Describe an included item for 1 or more coverages. */
export type IncludedItem_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Describe an included item for 1 or more coverages. */
export type IncludedItem_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IncludedItemAutocomplete = {
  __typename?: 'IncludedItemAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IncludedItemAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IncludedItemAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IncludedItemFacet = {
  __typename?: 'IncludedItemFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Icon?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedWithCoverages?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  ItemName?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PopoverText?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  RowExpandedText?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type IncludedItemFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IncludedItemFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IncludedItemFacetIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetIncludedWithCoveragesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetItemNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetPopoverTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetRowExpandedTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IncludedItemFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetSortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type IncludedItemFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IncludedItemFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IncludedItemFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IncludedItemFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type IncludedItemOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Icon?: InputMaybe<OrderBy>;
  IncludedWithCoverages?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  ItemName?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PopoverText?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  RowExpandedText?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SortOrder?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type IncludedItemOutput = {
  __typename?: 'IncludedItemOutput';
  autocomplete?: Maybe<IncludedItemAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IncludedItemFacet>;
  item?: Maybe<IncludedItem>;
  items?: Maybe<Array<Maybe<IncludedItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IncludedItemOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IncludedItemWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Icon?: InputMaybe<SearchableStringFilterInput>;
  IncludedWithCoverages?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  ItemName?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PopoverText?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  RowExpandedText?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SortOrder?: InputMaybe<IntFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IncludedItemWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IncludedItemWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IncludedItemWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A info box composed of a few different blocks. */
export type InfoBox = IContent & IData & {
  __typename?: 'InfoBox';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The optional call to action button for the info box. */
  CallToAction?: Maybe<InfoBoxButtonBase>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** The content of the info box. */
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The header of the info box. */
  Header?: Maybe<Scalars['String']['output']>;
  /** The icon, formatted like 'icon-group icon-name'. */
  Icon?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Optional popover content for additional information. */
  Popover?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** Controls the colors of the info box. */
  Variant?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A info box composed of a few different blocks. */
export type InfoBoxContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A info box composed of a few different blocks. */
export type InfoBoxHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A info box composed of a few different blocks. */
export type InfoBoxIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A info box composed of a few different blocks. */
export type InfoBoxNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A info box composed of a few different blocks. */
export type InfoBoxPopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A info box composed of a few different blocks. */
export type InfoBoxVariantArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A info box composed of a few different blocks. */
export type InfoBox_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A info box composed of a few different blocks. */
export type InfoBox_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type InfoBoxAutocomplete = {
  __typename?: 'InfoBoxAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type InfoBoxAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type InfoBoxAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type InfoBoxButtonBase = {
  __typename?: 'InfoBoxButtonBase';
  Label?: Maybe<Scalars['String']['output']>;
};


export type InfoBoxButtonBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type InfoBoxButtonBaseFacet = {
  __typename?: 'InfoBoxButtonBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
};


export type InfoBoxButtonBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InfoBoxButtonBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
};

export type InfoBoxButtonBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
};

export type InfoBoxFacet = {
  __typename?: 'InfoBoxFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  CallToAction?: Maybe<InfoBoxButtonBaseFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Header?: Maybe<Array<Maybe<StringFacet>>>;
  Icon?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Variant?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type InfoBoxFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxFacetHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type InfoBoxFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacetVariantArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type InfoBoxFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type InfoBoxOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  CallToAction?: InputMaybe<InfoBoxButtonBaseOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Header?: InputMaybe<OrderBy>;
  Icon?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Popover?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Variant?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type InfoBoxOutput = {
  __typename?: 'InfoBoxOutput';
  autocomplete?: Maybe<InfoBoxAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<InfoBoxFacet>;
  item?: Maybe<InfoBox>;
  items?: Maybe<Array<Maybe<InfoBox>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type InfoBoxOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InfoBoxWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  CallToAction?: InputMaybe<InfoBoxButtonBaseWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Header?: InputMaybe<SearchableStringFilterInput>;
  Icon?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Variant?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<InfoBoxWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<InfoBoxWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<InfoBoxWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type InlineBlockPropertyModelSearch = {
  __typename?: 'InlineBlockPropertyModelSearch';
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type InlineBlockPropertyModelSearchContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type InlineBlockPropertyModelSearchFacet = {
  __typename?: 'InlineBlockPropertyModelSearchFacet';
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type InlineBlockPropertyModelSearchFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InlineBlockPropertyModelSearchOrderByInput = {
  ContentType?: InputMaybe<OrderBy>;
};

export type InlineBlockPropertyModelSearchWhereInput = {
  ContentType?: InputMaybe<SearchableStringFilterInput>;
};

export type IntFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `Factor` allows you to use a number value in a field to influence the `_score` directly. If used on a multi-valued field, then only the lowest value of the field is used in calculations. Default for `value` is `1`. Default for `modifier` is `NONE`. */
  factor?: InputMaybe<NumberFactor>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Int']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** A generic label with a popover. */
export type LabelBase = IContent & IData & {
  __typename?: 'LabelBase';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Popover?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A generic label with a popover. */
export type LabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic label with a popover. */
export type LabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic label with a popover. */
export type LabelBaseNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic label with a popover. */
export type LabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic label with a popover. */
export type LabelBase_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic label with a popover. */
export type LabelBase_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LabelBaseAutocomplete = {
  __typename?: 'LabelBaseAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LabelBaseAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LabelBaseAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LabelBaseFacet = {
  __typename?: 'LabelBaseFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LabelBaseFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LabelBaseFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LabelBaseFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LabelBaseFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LabelBaseFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LabelBaseFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LabelBaseOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Popover?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LabelBaseOutput = {
  __typename?: 'LabelBaseOutput';
  autocomplete?: Maybe<LabelBaseAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LabelBaseFacet>;
  item?: Maybe<LabelBase>;
  items?: Maybe<Array<Maybe<LabelBase>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LabelBaseOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LabelBaseWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LabelBaseWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LabelBaseWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LabelBaseWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A link */
export type Link = IContent & IData & {
  __typename?: 'Link';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The URL */
  Href?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** The text displayed on the link */
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A link */
export type LinkHrefArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link */
export type LinkLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link */
export type LinkNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link */
export type Link_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link */
export type Link_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LinkAutocomplete = {
  __typename?: 'LinkAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LinkAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkConfig = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type LinkFacet = {
  __typename?: 'LinkFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Href?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LinkFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkFacetHrefArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LinkOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Href?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LinkOutput = {
  __typename?: 'LinkOutput';
  autocomplete?: Maybe<LinkAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LinkFacet>;
  item?: Maybe<Link>;
  items?: Maybe<Array<Maybe<Link>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LinkOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Link Text and Url */
export type LinkTextAndUrl = IContent & IData & {
  __typename?: 'LinkTextAndUrl';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Text */
  Text?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Link Text and Url */
export type LinkTextAndUrlNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Link Text and Url */
export type LinkTextAndUrlTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Link Text and Url */
export type LinkTextAndUrl_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Link Text and Url */
export type LinkTextAndUrl_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type LinkTextAndUrlAutocomplete = {
  __typename?: 'LinkTextAndUrlAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LinkTextAndUrlAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkTextAndUrlAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkTextAndUrlFacet = {
  __typename?: 'LinkTextAndUrlFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type LinkTextAndUrlFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTextAndUrlFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTextAndUrlFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTextAndUrlFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTextAndUrlFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkTextAndUrlFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkTextAndUrlFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type LinkTextAndUrlOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type LinkTextAndUrlOutput = {
  __typename?: 'LinkTextAndUrlOutput';
  autocomplete?: Maybe<LinkTextAndUrlAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<LinkTextAndUrlFacet>;
  item?: Maybe<LinkTextAndUrl>;
  items?: Maybe<Array<Maybe<LinkTextAndUrl>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type LinkTextAndUrlOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkTextAndUrlWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LinkTextAndUrlWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LinkTextAndUrlWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LinkTextAndUrlWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum LinkTypes {
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `Ancestors` |
   * | *to*        |        | `ContentLink.GuidValue`   |
   */
  Ancestors = 'ANCESTORS',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Children = 'CHILDREN',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Default = 'DEFAULT'
}

export type LinkWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Href?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<LinkWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<LinkWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<LinkWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL',
  En = 'en',
  Fi = 'fi',
  Sv = 'sv'
}

/** Content block for Multi Select Products */
export type MultiSelectProductCommon = IContent & IData & {
  __typename?: 'MultiSelectProductCommon';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Error message for when the customer hasn't chosen any coverages */
  ErrorMessageNoSelected?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  /** Label for when the customer hasn't chosen any coverages */
  NoCoverageSelectedForAddons?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Total Price Amount for all selected coverages */
  TotalPriceAmountLabel?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Content block for Multi Select Products */
export type MultiSelectProductCommonErrorMessageNoSelectedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block for Multi Select Products */
export type MultiSelectProductCommonNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block for Multi Select Products */
export type MultiSelectProductCommonNoCoverageSelectedForAddonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block for Multi Select Products */
export type MultiSelectProductCommonTotalPriceAmountLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block for Multi Select Products */
export type MultiSelectProductCommon_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Content block for Multi Select Products */
export type MultiSelectProductCommon_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MultiSelectProductCommonAutocomplete = {
  __typename?: 'MultiSelectProductCommonAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MultiSelectProductCommonAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MultiSelectProductCommonAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MultiSelectProductCommonFacet = {
  __typename?: 'MultiSelectProductCommonFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ErrorMessageNoSelected?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TotalPriceAmountLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type MultiSelectProductCommonFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiSelectProductCommonFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiSelectProductCommonFacetErrorMessageNoSelectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetNoCoverageSelectedForAddonsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiSelectProductCommonFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiSelectProductCommonFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiSelectProductCommonFacetTotalPriceAmountLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MultiSelectProductCommonFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type MultiSelectProductCommonOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ErrorMessageNoSelected?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NoCoverageSelectedForAddons?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TotalPriceAmountLabel?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type MultiSelectProductCommonOutput = {
  __typename?: 'MultiSelectProductCommonOutput';
  autocomplete?: Maybe<MultiSelectProductCommonAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MultiSelectProductCommonFacet>;
  item?: Maybe<MultiSelectProductCommon>;
  items?: Maybe<Array<Maybe<MultiSelectProductCommon>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MultiSelectProductCommonOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiSelectProductCommonWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ErrorMessageNoSelected?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoCoverageSelectedForAddons?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TotalPriceAmountLabel?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MultiSelectProductCommonWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MultiSelectProductCommonWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MultiSelectProductCommonWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type NumberFacet = {
  __typename?: 'NumberFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Factor influences the score based of number values with a factor function */
export type NumberFactor = {
  modifier?: InputMaybe<FactorModifier>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderByFacetType {
  Count = 'COUNT',
  Value = 'VALUE'
}

/** Block containing personal detail questions. */
export type PersonalDetailsBlock = IContent & IData & {
  __typename?: 'PersonalDetailsBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FirstName?: Maybe<PersonalDetailsBlockQuestionBase>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LastName?: Maybe<PersonalDetailsBlockQuestionBase>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PostOffice?: Maybe<PersonalDetailsBlockQuestionBase>;
  PostalCode?: Maybe<PersonalDetailsBlockQuestionBase>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SocialSecurityNumber?: Maybe<PersonalDetailsBlockQuestionBase>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  StreetAddress?: Maybe<PersonalDetailsBlockQuestionBase>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Block containing personal detail questions. */
export type PersonalDetailsBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block containing personal detail questions. */
export type PersonalDetailsBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Block containing personal detail questions. */
export type PersonalDetailsBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PersonalDetailsBlockAutocomplete = {
  __typename?: 'PersonalDetailsBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PersonalDetailsBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalDetailsBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonalDetailsBlockFacet = {
  __typename?: 'PersonalDetailsBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FirstName?: Maybe<PersonalDetailsBlockQuestionBaseFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LastName?: Maybe<PersonalDetailsBlockQuestionBaseFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PostOffice?: Maybe<PersonalDetailsBlockQuestionBaseFacet>;
  PostalCode?: Maybe<PersonalDetailsBlockQuestionBaseFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialSecurityNumber?: Maybe<PersonalDetailsBlockQuestionBaseFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  StreetAddress?: Maybe<PersonalDetailsBlockQuestionBaseFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PersonalDetailsBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalDetailsBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalDetailsBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalDetailsBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalDetailsBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalDetailsBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PersonalDetailsBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FirstName?: InputMaybe<PersonalDetailsBlockQuestionBaseOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LastName?: InputMaybe<PersonalDetailsBlockQuestionBaseOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PostOffice?: InputMaybe<PersonalDetailsBlockQuestionBaseOrderByInput>;
  PostalCode?: InputMaybe<PersonalDetailsBlockQuestionBaseOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialSecurityNumber?: InputMaybe<PersonalDetailsBlockQuestionBaseOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  StreetAddress?: InputMaybe<PersonalDetailsBlockQuestionBaseOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PersonalDetailsBlockOutput = {
  __typename?: 'PersonalDetailsBlockOutput';
  autocomplete?: Maybe<PersonalDetailsBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PersonalDetailsBlockFacet>;
  item?: Maybe<PersonalDetailsBlock>;
  items?: Maybe<Array<Maybe<PersonalDetailsBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PersonalDetailsBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonalDetailsBlockQuestionBase = {
  __typename?: 'PersonalDetailsBlockQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<PersonalDetailsBlockQuestionBaseValidationMessageItem>>>;
};


export type PersonalDetailsBlockQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonalDetailsBlockQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonalDetailsBlockQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonalDetailsBlockQuestionBaseFacet = {
  __typename?: 'PersonalDetailsBlockQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<PersonalDetailsBlockQuestionBaseValidationMessageItemFacet>;
};


export type PersonalDetailsBlockQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonalDetailsBlockQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<PersonalDetailsBlockQuestionBaseValidationMessageItemOrderByInput>;
};

export type PersonalDetailsBlockQuestionBaseValidationMessageItem = {
  __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type PersonalDetailsBlockQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PersonalDetailsBlockQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PersonalDetailsBlockQuestionBaseValidationMessageItemFacet = {
  __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PersonalDetailsBlockQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalDetailsBlockQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PersonalDetailsBlockQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type PersonalDetailsBlockQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type PersonalDetailsBlockQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<PersonalDetailsBlockQuestionBaseValidationMessageItemWhereInput>;
};

export type PersonalDetailsBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FirstName?: InputMaybe<PersonalDetailsBlockQuestionBaseWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LastName?: InputMaybe<PersonalDetailsBlockQuestionBaseWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PostOffice?: InputMaybe<PersonalDetailsBlockQuestionBaseWhereInput>;
  PostalCode?: InputMaybe<PersonalDetailsBlockQuestionBaseWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialSecurityNumber?: InputMaybe<PersonalDetailsBlockQuestionBaseWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  StreetAddress?: InputMaybe<PersonalDetailsBlockQuestionBaseWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PersonalDetailsBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PersonalDetailsBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PersonalDetailsBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Personalization registry page, use to register components for the Personalization engine */
export type PersonalizationRegistryPage = IContent & IData & {
  __typename?: 'PersonalizationRegistryPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** If this is set, personalization engine will choose only one content per category */
  PersonalizationCategory?: Maybe<Scalars['String']['output']>;
  /** Add target/supported channels */
  PersonalizationChannels?: Maybe<Array<Maybe<ChannelTargetItem>>>;
  /** Unique personalization engine reference name, used in CRM journeys. */
  PersonalizationContentName?: Maybe<Scalars['String']['output']>;
  /** Add target/supported placements */
  PersonalizationPlacements?: Maybe<Array<Maybe<PlacementTargetItem>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Personalization registry page, use to register components for the Personalization engine */
export type PersonalizationRegistryPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Personalization registry page, use to register components for the Personalization engine */
export type PersonalizationRegistryPagePersonalizationCategoryArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Personalization registry page, use to register components for the Personalization engine */
export type PersonalizationRegistryPagePersonalizationContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Personalization registry page, use to register components for the Personalization engine */
export type PersonalizationRegistryPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Personalization registry page, use to register components for the Personalization engine */
export type PersonalizationRegistryPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PersonalizationRegistryPageAutocomplete = {
  __typename?: 'PersonalizationRegistryPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PersonalizationChannels?: Maybe<ChannelTargetItemAutocomplete>;
  PersonalizationPlacements?: Maybe<PlacementTargetItemAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PersonalizationRegistryPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PersonalizationRegistryPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PersonalizationRegistryPageFacet = {
  __typename?: 'PersonalizationRegistryPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PersonalizationCategory?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalizationChannels?: Maybe<ChannelTargetItemFacet>;
  PersonalizationContentName?: Maybe<Array<Maybe<StringFacet>>>;
  PersonalizationPlacements?: Maybe<PlacementTargetItemFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PersonalizationRegistryPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalizationRegistryPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalizationRegistryPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetPersonalizationCategoryArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetPersonalizationContentNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalizationRegistryPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalizationRegistryPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonalizationRegistryPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PersonalizationRegistryPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PersonalizationRegistryPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PersonalizationCategory?: InputMaybe<OrderBy>;
  PersonalizationChannels?: InputMaybe<ChannelTargetItemOrderByInput>;
  PersonalizationContentName?: InputMaybe<OrderBy>;
  PersonalizationPlacements?: InputMaybe<PlacementTargetItemOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PersonalizationRegistryPageOutput = {
  __typename?: 'PersonalizationRegistryPageOutput';
  autocomplete?: Maybe<PersonalizationRegistryPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PersonalizationRegistryPageFacet>;
  item?: Maybe<PersonalizationRegistryPage>;
  items?: Maybe<Array<Maybe<PersonalizationRegistryPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PersonalizationRegistryPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonalizationRegistryPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PersonalizationCategory?: InputMaybe<SearchableStringFilterInput>;
  PersonalizationChannels?: InputMaybe<ChannelTargetItemWhereInput>;
  PersonalizationContentName?: InputMaybe<SearchableStringFilterInput>;
  PersonalizationPlacements?: InputMaybe<PlacementTargetItemWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PersonalizationRegistryPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PersonalizationRegistryPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PersonalizationRegistryPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type PinnedInput = {
  /** Pinned collection keys */
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phrase?: InputMaybe<Scalars['String']['input']>;
};

export type PlacementTargetItem = {
  __typename?: 'PlacementTargetItem';
  Context?: Maybe<Scalars['String']['output']>;
  Slot?: Maybe<Scalars['String']['output']>;
};

export type PlacementTargetItemAutocomplete = {
  __typename?: 'PlacementTargetItemAutocomplete';
  Context?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Slot?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PlacementTargetItemAutocompleteContextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PlacementTargetItemAutocompleteSlotArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PlacementTargetItemFacet = {
  __typename?: 'PlacementTargetItemFacet';
  Context?: Maybe<Array<Maybe<StringFacet>>>;
  Slot?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PlacementTargetItemFacetContextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PlacementTargetItemFacetSlotArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PlacementTargetItemOrderByInput = {
  Context?: InputMaybe<OrderBy>;
  Slot?: InputMaybe<OrderBy>;
};

export type PlacementTargetItemWhereInput = {
  Context?: InputMaybe<StringFilterInput>;
  Slot?: InputMaybe<StringFilterInput>;
};

/** Price page common */
export type PricePageCommon = IContent & IData & {
  __typename?: 'PricePageCommon';
  /** Content for the About Bonuses Modal */
  AboutBonusesModal?: Maybe<PricePageCommonLabelBase>;
  AddonNotSelectableText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Header choice based on bonus from core system */
  BonusHeaderOptionOne?: Maybe<Scalars['String']['output']>;
  /** Header choice based on bonus from core system */
  BonusHeaderOptionTwo?: Maybe<Scalars['String']['output']>;
  BonusItems?: Maybe<Array<Maybe<PricePageCommonBonusItem>>>;
  /** Label for the Bonus Card */
  BonusLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Loader text when clicking add to cart/checkout */
  ContinuePurchaseLoaderText?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Content for the Deductible Selector */
  DeductibleAmountSelector?: Maybe<PricePageCommonLabelBase>;
  EditButtonText?: Maybe<Scalars['String']['output']>;
  ErrorMessageNoSelected?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** Some products (travel, baby) have a fixed price. This text replaces the monthly price in those cases */
  FixedPriceText?: Maybe<Scalars['String']['output']>;
  IncludedItemsHeader?: Maybe<Scalars['String']['output']>;
  /** Content for the Insurance Selector */
  InsuranceAmountSelector?: Maybe<PricePageCommonLabelBase>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NoCoverageSelectedForAddons?: Maybe<Scalars['String']['output']>;
  /** Label for the Nordea Campaign for the Summary Section */
  NordeaCampaignSummary?: Maybe<PricePageCommonLabelBase>;
  ParentLink?: Maybe<ContentModelReference>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  /** Loader text when changing options that triggers recalculation */
  RecalculatingLoaderText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageTitle?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SelectAddonsHeader?: Maybe<Scalars['String']['output']>;
  SelectInsuranceAmountText?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TopQuestionsTitle?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Price page common */
export type PricePageCommonAddonNotSelectableTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonBonusHeaderOptionOneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonBonusHeaderOptionTwoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonBonusLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonContinuePurchaseLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonEditButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonFixedPriceTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonIncludedItemsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonRecalculatingLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonRecommendedCoverageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonRecommendedCoverageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonSelectAddonsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommon_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price page common */
export type PricePageCommon_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PricePageCommonAutocomplete = {
  __typename?: 'PricePageCommonAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ErrorMessageNoSelected?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PricePageCommonAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteErrorMessageNoSelectedArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteNoCoverageSelectedForAddonsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteSelectInsuranceAmountTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteTopQuestionsTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PricePageCommonAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PricePageCommonBonusItem = {
  __typename?: 'PricePageCommonBonusItem';
  Label?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type PricePageCommonBonusItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PricePageCommonBonusItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PricePageCommonBonusItemFacet = {
  __typename?: 'PricePageCommonBonusItemFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PricePageCommonBonusItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonBonusItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PricePageCommonBonusItemOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type PricePageCommonBonusItemWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type PricePageCommonFacet = {
  __typename?: 'PricePageCommonFacet';
  AboutBonusesModal?: Maybe<PricePageCommonLabelBaseFacet>;
  AddonNotSelectableText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionOne?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionTwo?: Maybe<Array<Maybe<StringFacet>>>;
  BonusItems?: Maybe<PricePageCommonBonusItemFacet>;
  BonusLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  ContinuePurchaseLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DeductibleAmountSelector?: Maybe<PricePageCommonLabelBaseFacet>;
  EditButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorMessageNoSelected?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FixedPriceText?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedItemsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  InsuranceAmountSelector?: Maybe<PricePageCommonLabelBaseFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignSummary?: Maybe<PricePageCommonLabelBaseFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RecalculatingLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SelectAddonsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PricePageCommonFacetAddonNotSelectableTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetBonusHeaderOptionOneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetBonusHeaderOptionTwoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetBonusLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PricePageCommonFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetContinuePurchaseLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PricePageCommonFacetEditButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetErrorMessageNoSelectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetFixedPriceTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetIncludedItemsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetNoCoverageSelectedForAddonsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetRecalculatingLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetRecommendedCoverageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetRecommendedCoverageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PricePageCommonFacetSelectAddonsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetSelectInsuranceAmountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PricePageCommonFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PricePageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetTopQuestionsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PricePageCommonLabelBase = {
  __typename?: 'PricePageCommonLabelBase';
  Content?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
};


export type PricePageCommonLabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PricePageCommonLabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PricePageCommonLabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PricePageCommonLabelBaseFacet = {
  __typename?: 'PricePageCommonLabelBaseFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PricePageCommonLabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonLabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PricePageCommonLabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PricePageCommonLabelBaseOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
};

export type PricePageCommonLabelBaseWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
};

export type PricePageCommonOrderByInput = {
  AboutBonusesModal?: InputMaybe<PricePageCommonLabelBaseOrderByInput>;
  AddonNotSelectableText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BonusHeaderOptionOne?: InputMaybe<OrderBy>;
  BonusHeaderOptionTwo?: InputMaybe<OrderBy>;
  BonusItems?: InputMaybe<PricePageCommonBonusItemOrderByInput>;
  BonusLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  ContinuePurchaseLoaderText?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DeductibleAmountSelector?: InputMaybe<PricePageCommonLabelBaseOrderByInput>;
  EditButtonText?: InputMaybe<OrderBy>;
  ErrorMessageNoSelected?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FixedPriceText?: InputMaybe<OrderBy>;
  IncludedItemsHeader?: InputMaybe<OrderBy>;
  InsuranceAmountSelector?: InputMaybe<PricePageCommonLabelBaseOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NoCoverageSelectedForAddons?: InputMaybe<OrderBy>;
  NordeaCampaignSummary?: InputMaybe<PricePageCommonLabelBaseOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  RecalculatingLoaderText?: InputMaybe<OrderBy>;
  RecommendedCoverageText?: InputMaybe<OrderBy>;
  RecommendedCoverageTitle?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SelectAddonsHeader?: InputMaybe<OrderBy>;
  SelectInsuranceAmountText?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopQuestionsTitle?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PricePageCommonOutput = {
  __typename?: 'PricePageCommonOutput';
  autocomplete?: Maybe<PricePageCommonAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PricePageCommonFacet>;
  item?: Maybe<PricePageCommon>;
  items?: Maybe<Array<Maybe<PricePageCommon>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PricePageCommonOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricePageCommonWhereInput = {
  AboutBonusesModal?: InputMaybe<PricePageCommonLabelBaseWhereInput>;
  AddonNotSelectableText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BonusHeaderOptionOne?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionTwo?: InputMaybe<SearchableStringFilterInput>;
  BonusItems?: InputMaybe<PricePageCommonBonusItemWhereInput>;
  BonusLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  ContinuePurchaseLoaderText?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DeductibleAmountSelector?: InputMaybe<PricePageCommonLabelBaseWhereInput>;
  EditButtonText?: InputMaybe<SearchableStringFilterInput>;
  ErrorMessageNoSelected?: InputMaybe<StringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FixedPriceText?: InputMaybe<SearchableStringFilterInput>;
  IncludedItemsHeader?: InputMaybe<SearchableStringFilterInput>;
  InsuranceAmountSelector?: InputMaybe<PricePageCommonLabelBaseWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NoCoverageSelectedForAddons?: InputMaybe<StringFilterInput>;
  NordeaCampaignSummary?: InputMaybe<PricePageCommonLabelBaseWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  RecalculatingLoaderText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageTitle?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SelectAddonsHeader?: InputMaybe<SearchableStringFilterInput>;
  SelectInsuranceAmountText?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopQuestionsTitle?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PricePageCommonWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PricePageCommonWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PricePageCommonWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Price Summary Section Content */
export type PriceSummarySectionContent = IContent & IData & {
  __typename?: 'PriceSummarySectionContent';
  /** Addons Info Label */
  AddonsInfoLabel?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  /** Check Out Button Text */
  CheckOutButtonText?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  /** Loader Calculation Text */
  LoaderCalculationText?: Maybe<Scalars['String']['output']>;
  /** Loader Checkout Text */
  LoaderCheckoutText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Price Label */
  PriceLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Title */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContentAddonsInfoLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContentCheckOutButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContentLoaderCalculationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContentLoaderCheckoutTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContentPriceLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContentTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Price Summary Section Content */
export type PriceSummarySectionContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PriceSummarySectionContentAutocomplete = {
  __typename?: 'PriceSummarySectionContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PriceSummarySectionContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PriceSummarySectionContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PriceSummarySectionContentFacet = {
  __typename?: 'PriceSummarySectionContentFacet';
  AddonsInfoLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  CheckOutButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LoaderCalculationText?: Maybe<Array<Maybe<StringFacet>>>;
  LoaderCheckoutText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PriceLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PriceSummarySectionContentFacetAddonsInfoLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceSummarySectionContentFacetCheckOutButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceSummarySectionContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetLoaderCalculationTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetLoaderCheckoutTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetPriceLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceSummarySectionContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceSummarySectionContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PriceSummarySectionContentFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PriceSummarySectionContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PriceSummarySectionContentOrderByInput = {
  AddonsInfoLabel?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  CheckOutButtonText?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LoaderCalculationText?: InputMaybe<OrderBy>;
  LoaderCheckoutText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PriceLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PriceSummarySectionContentOutput = {
  __typename?: 'PriceSummarySectionContentOutput';
  autocomplete?: Maybe<PriceSummarySectionContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PriceSummarySectionContentFacet>;
  item?: Maybe<PriceSummarySectionContent>;
  items?: Maybe<Array<Maybe<PriceSummarySectionContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PriceSummarySectionContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PriceSummarySectionContentWhereInput = {
  AddonsInfoLabel?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  CheckOutButtonText?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LoaderCalculationText?: InputMaybe<SearchableStringFilterInput>;
  LoaderCheckoutText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PriceLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PriceSummarySectionContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PriceSummarySectionContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PriceSummarySectionContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Promo card */
export type PromoCard = IContent & IData & {
  __typename?: 'PromoCard';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Button label */
  ButtonLabel?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Description */
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Main image to display. */
  PromoImageUrl?: Maybe<Scalars['String']['output']>;
  /** Redirect url */
  RedirectUrl?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Main title */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Promo card */
export type PromoCardButtonLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Promo card */
export type PromoCardDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Promo card */
export type PromoCardNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Promo card */
export type PromoCardTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Promo card */
export type PromoCard_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Promo card */
export type PromoCard_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PromoCardAutocomplete = {
  __typename?: 'PromoCardAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PromoImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RedirectUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PromoCardAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompletePromoImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteRedirectUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PromoCardAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PromoCardFacet = {
  __typename?: 'PromoCardFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PromoImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  RedirectUrl?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type PromoCardFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetButtonLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PromoCardFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PromoCardFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetPromoImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetRedirectUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PromoCardFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PromoCardFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PromoCardFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PromoCardFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type PromoCardOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ButtonLabel?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PromoImageUrl?: InputMaybe<OrderBy>;
  RedirectUrl?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type PromoCardOutput = {
  __typename?: 'PromoCardOutput';
  autocomplete?: Maybe<PromoCardAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PromoCardFacet>;
  item?: Maybe<PromoCard>;
  items?: Maybe<Array<Maybe<PromoCard>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PromoCardOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PromoCardWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ButtonLabel?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PromoImageUrl?: InputMaybe<StringFilterInput>;
  RedirectUrl?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PromoCardWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PromoCardWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PromoCardWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type Query = {
  __typename?: 'Query';
  Addon?: Maybe<AddonOutput>;
  BabyCommonBlock?: Maybe<BabyCommonBlockOutput>;
  BabyCommonPage?: Maybe<BabyCommonPageOutput>;
  BabyConfirmationPage?: Maybe<BabyConfirmationPageOutput>;
  BabyEntryPage?: Maybe<BabyEntryPageOutput>;
  BabyPricePage?: Maybe<BabyPricePageOutput>;
  BabyTopQuestionsPage?: Maybe<BabyTopQuestionsPageOutput>;
  BonusItem?: Maybe<BonusItemOutput>;
  ButtonBase?: Maybe<ButtonBaseOutput>;
  CampaignCardContent?: Maybe<CampaignCardContentOutput>;
  CheckoutPageCommon?: Maybe<CheckoutPageCommonOutput>;
  ConfirmationPageCommon?: Maybe<ConfirmationPageCommonOutput>;
  Content?: Maybe<ContentOutput>;
  Coverage?: Maybe<CoverageOutput>;
  CubeDiscountContent?: Maybe<CubeDiscountContentOutput>;
  CurrencyPeriodSuffix?: Maybe<CurrencyPeriodSuffixOutput>;
  Data?: Maybe<DataOutput>;
  ElectronicHealthDeclerationContent?: Maybe<ElectronicHealthDeclerationContentOutput>;
  EntryPageCommon?: Maybe<EntryPageCommonOutput>;
  FooterContent?: Maybe<FooterContentOutput>;
  GlobalContentPage?: Maybe<GlobalContentPageOutput>;
  HouseholderCommonBlock?: Maybe<HouseholderCommonBlockOutput>;
  HouseholderCommonPage?: Maybe<HouseholderCommonPageOutput>;
  HouseholderConfirmationPage?: Maybe<HouseholderConfirmationPageOutput>;
  HouseholderEntryPage?: Maybe<HouseholderEntryPageOutput>;
  HouseholderPricePage?: Maybe<HouseholderPricePageOutput>;
  HouseholderTopQuestionsPage?: Maybe<HouseholderTopQuestionsPageOutput>;
  HtmlElement?: Maybe<HtmlElementOutput>;
  IfCheckoutPage?: Maybe<IfCheckoutPageOutput>;
  IfCommonPage?: Maybe<IfCommonPageOutput>;
  IfConfirmationPage?: Maybe<IfConfirmationPageOutput>;
  IfContentPage?: Maybe<IfContentPageOutput>;
  IfDomainPage?: Maybe<IfDomainPageOutput>;
  IfEntryPage?: Maybe<IfEntryPageOutput>;
  IfExperiencePage?: Maybe<IfExperiencePageOutput>;
  IfMigrationFolderPage?: Maybe<IfMigrationFolderPageOutput>;
  IfPricePage?: Maybe<IfPricePageOutput>;
  IfProduct?: Maybe<IfProductOutput>;
  IfSitePage?: Maybe<IfSitePageOutput>;
  IfTopQuestionsPage?: Maybe<IfTopQuestionsPageOutput>;
  IfWebshopPage?: Maybe<IfWebshopPageOutput>;
  IncludedItem?: Maybe<IncludedItemOutput>;
  InfoBox?: Maybe<InfoBoxOutput>;
  LabelBase?: Maybe<LabelBaseOutput>;
  Link?: Maybe<LinkOutput>;
  LinkTextAndUrl?: Maybe<LinkTextAndUrlOutput>;
  MultiSelectProductCommon?: Maybe<MultiSelectProductCommonOutput>;
  PersonalDetailsBlock?: Maybe<PersonalDetailsBlockOutput>;
  PersonalizationRegistryPage?: Maybe<PersonalizationRegistryPageOutput>;
  PricePageCommon?: Maybe<PricePageCommonOutput>;
  PriceSummarySectionContent?: Maybe<PriceSummarySectionContentOutput>;
  PromoCard?: Maybe<PromoCardOutput>;
  QuestionBase?: Maybe<QuestionBaseOutput>;
  RadioButtonInput?: Maybe<RadioButtonInputOutput>;
  RadioButtonValueItem?: Maybe<RadioButtonValueItemOutput>;
  RecommendationTagCard?: Maybe<RecommendationTagCardOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  TermsAndConditionItem?: Maybe<TermsAndConditionItemOutput>;
  TopMenuContent?: Maybe<TopMenuContentOutput>;
  TopQuestionsCommon?: Maybe<TopQuestionsCommonOutput>;
  TravelCommonBlock?: Maybe<TravelCommonBlockOutput>;
  TravelCommonPage?: Maybe<TravelCommonPageOutput>;
  TravelConfirmationPage?: Maybe<TravelConfirmationPageOutput>;
  TravelEntryPage?: Maybe<TravelEntryPageOutput>;
  TravelPricePage?: Maybe<TravelPricePageOutput>;
  TravelTopQuestionsPage?: Maybe<TravelTopQuestionsPageOutput>;
  ValidationMessageItem?: Maybe<ValidationMessageItemOutput>;
  YesAndNoAnswerContent?: Maybe<YesAndNoAnswerContentOutput>;
};


export type QueryAddonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AddonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AddonWhereInput>;
};


export type QueryBabyCommonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyCommonBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyCommonBlockWhereInput>;
};


export type QueryBabyCommonPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyCommonPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyCommonPageWhereInput>;
};


export type QueryBabyConfirmationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyConfirmationPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyConfirmationPageWhereInput>;
};


export type QueryBabyEntryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyEntryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyEntryPageWhereInput>;
};


export type QueryBabyPricePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyPricePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyPricePageWhereInput>;
};


export type QueryBabyTopQuestionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyTopQuestionsPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyTopQuestionsPageWhereInput>;
};


export type QueryBonusItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BonusItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BonusItemWhereInput>;
};


export type QueryButtonBaseArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ButtonBaseOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ButtonBaseWhereInput>;
};


export type QueryCampaignCardContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CampaignCardContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CampaignCardContentWhereInput>;
};


export type QueryCheckoutPageCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CheckoutPageCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CheckoutPageCommonWhereInput>;
};


export type QueryConfirmationPageCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConfirmationPageCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ConfirmationPageCommonWhereInput>;
};


export type QueryContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryCoverageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CoverageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CoverageWhereInput>;
};


export type QueryCubeDiscountContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CubeDiscountContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CubeDiscountContentWhereInput>;
};


export type QueryCurrencyPeriodSuffixArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CurrencyPeriodSuffixOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CurrencyPeriodSuffixWhereInput>;
};


export type QueryDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DataWhereInput>;
};


export type QueryElectronicHealthDeclerationContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ElectronicHealthDeclerationContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ElectronicHealthDeclerationContentWhereInput>;
};


export type QueryEntryPageCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EntryPageCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<EntryPageCommonWhereInput>;
};


export type QueryFooterContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FooterContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FooterContentWhereInput>;
};


export type QueryGlobalContentPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GlobalContentPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<GlobalContentPageWhereInput>;
};


export type QueryHouseholderCommonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderCommonBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderCommonBlockWhereInput>;
};


export type QueryHouseholderCommonPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderCommonPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderCommonPageWhereInput>;
};


export type QueryHouseholderConfirmationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderConfirmationPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderConfirmationPageWhereInput>;
};


export type QueryHouseholderEntryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderEntryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderEntryPageWhereInput>;
};


export type QueryHouseholderPricePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderPricePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderPricePageWhereInput>;
};


export type QueryHouseholderTopQuestionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderTopQuestionsPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderTopQuestionsPageWhereInput>;
};


export type QueryHtmlElementArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HtmlElementOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HtmlElementWhereInput>;
};


export type QueryIfCheckoutPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfCheckoutPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfCheckoutPageWhereInput>;
};


export type QueryIfCommonPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfCommonPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfCommonPageWhereInput>;
};


export type QueryIfConfirmationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfConfirmationPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfConfirmationPageWhereInput>;
};


export type QueryIfContentPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfContentPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfContentPageWhereInput>;
};


export type QueryIfDomainPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfDomainPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfDomainPageWhereInput>;
};


export type QueryIfEntryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfEntryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfEntryPageWhereInput>;
};


export type QueryIfExperiencePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfExperiencePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfExperiencePageWhereInput>;
};


export type QueryIfMigrationFolderPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfMigrationFolderPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfMigrationFolderPageWhereInput>;
};


export type QueryIfPricePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfPricePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfPricePageWhereInput>;
};


export type QueryIfProductArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfProductOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfProductWhereInput>;
};


export type QueryIfSitePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfSitePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfSitePageWhereInput>;
};


export type QueryIfTopQuestionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfTopQuestionsPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfTopQuestionsPageWhereInput>;
};


export type QueryIfWebshopPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfWebshopPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfWebshopPageWhereInput>;
};


export type QueryIncludedItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IncludedItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IncludedItemWhereInput>;
};


export type QueryInfoBoxArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<InfoBoxOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<InfoBoxWhereInput>;
};


export type QueryLabelBaseArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LabelBaseOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LabelBaseWhereInput>;
};


export type QueryLinkArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryLinkTextAndUrlArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkTextAndUrlOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LinkTextAndUrlWhereInput>;
};


export type QueryMultiSelectProductCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MultiSelectProductCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MultiSelectProductCommonWhereInput>;
};


export type QueryPersonalDetailsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonalDetailsBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PersonalDetailsBlockWhereInput>;
};


export type QueryPersonalizationRegistryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonalizationRegistryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PersonalizationRegistryPageWhereInput>;
};


export type QueryPricePageCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PricePageCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PricePageCommonWhereInput>;
};


export type QueryPriceSummarySectionContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PriceSummarySectionContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PriceSummarySectionContentWhereInput>;
};


export type QueryPromoCardArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoCardOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PromoCardWhereInput>;
};


export type QueryQuestionBaseArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuestionBaseOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<QuestionBaseWhereInput>;
};


export type QueryRadioButtonInputArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RadioButtonInputOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RadioButtonInputWhereInput>;
};


export type QueryRadioButtonValueItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RadioButtonValueItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RadioButtonValueItemWhereInput>;
};


export type QueryRecommendationTagCardArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RecommendationTagCardOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RecommendationTagCardWhereInput>;
};


export type QuerySiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteDefinitionWhereInput>;
};


export type QueryTermsAndConditionItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TermsAndConditionItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TermsAndConditionItemWhereInput>;
};


export type QueryTopMenuContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TopMenuContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TopMenuContentWhereInput>;
};


export type QueryTopQuestionsCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TopQuestionsCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TopQuestionsCommonWhereInput>;
};


export type QueryTravelCommonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelCommonBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelCommonBlockWhereInput>;
};


export type QueryTravelCommonPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelCommonPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelCommonPageWhereInput>;
};


export type QueryTravelConfirmationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelConfirmationPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelConfirmationPageWhereInput>;
};


export type QueryTravelEntryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelEntryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelEntryPageWhereInput>;
};


export type QueryTravelPricePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelPricePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelPricePageWhereInput>;
};


export type QueryTravelTopQuestionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelTopQuestionsPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelTopQuestionsPageWhereInput>;
};


export type QueryValidationMessageItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ValidationMessageItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ValidationMessageItemWhereInput>;
};


export type QueryYesAndNoAnswerContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<YesAndNoAnswerContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<YesAndNoAnswerContentWhereInput>;
};

export type QueryRef = {
  __typename?: 'QueryRef';
  Addon?: Maybe<AddonOutput>;
  BabyCommonBlock?: Maybe<BabyCommonBlockOutput>;
  BabyCommonPage?: Maybe<BabyCommonPageOutput>;
  BabyConfirmationPage?: Maybe<BabyConfirmationPageOutput>;
  BabyEntryPage?: Maybe<BabyEntryPageOutput>;
  BabyPricePage?: Maybe<BabyPricePageOutput>;
  BabyTopQuestionsPage?: Maybe<BabyTopQuestionsPageOutput>;
  BonusItem?: Maybe<BonusItemOutput>;
  ButtonBase?: Maybe<ButtonBaseOutput>;
  CampaignCardContent?: Maybe<CampaignCardContentOutput>;
  CheckoutPageCommon?: Maybe<CheckoutPageCommonOutput>;
  ConfirmationPageCommon?: Maybe<ConfirmationPageCommonOutput>;
  Content?: Maybe<ContentOutput>;
  Coverage?: Maybe<CoverageOutput>;
  CubeDiscountContent?: Maybe<CubeDiscountContentOutput>;
  CurrencyPeriodSuffix?: Maybe<CurrencyPeriodSuffixOutput>;
  Data?: Maybe<DataOutput>;
  ElectronicHealthDeclerationContent?: Maybe<ElectronicHealthDeclerationContentOutput>;
  EntryPageCommon?: Maybe<EntryPageCommonOutput>;
  FooterContent?: Maybe<FooterContentOutput>;
  GlobalContentPage?: Maybe<GlobalContentPageOutput>;
  HouseholderCommonBlock?: Maybe<HouseholderCommonBlockOutput>;
  HouseholderCommonPage?: Maybe<HouseholderCommonPageOutput>;
  HouseholderConfirmationPage?: Maybe<HouseholderConfirmationPageOutput>;
  HouseholderEntryPage?: Maybe<HouseholderEntryPageOutput>;
  HouseholderPricePage?: Maybe<HouseholderPricePageOutput>;
  HouseholderTopQuestionsPage?: Maybe<HouseholderTopQuestionsPageOutput>;
  HtmlElement?: Maybe<HtmlElementOutput>;
  IfCheckoutPage?: Maybe<IfCheckoutPageOutput>;
  IfCommonPage?: Maybe<IfCommonPageOutput>;
  IfConfirmationPage?: Maybe<IfConfirmationPageOutput>;
  IfContentPage?: Maybe<IfContentPageOutput>;
  IfDomainPage?: Maybe<IfDomainPageOutput>;
  IfEntryPage?: Maybe<IfEntryPageOutput>;
  IfExperiencePage?: Maybe<IfExperiencePageOutput>;
  IfMigrationFolderPage?: Maybe<IfMigrationFolderPageOutput>;
  IfPricePage?: Maybe<IfPricePageOutput>;
  IfProduct?: Maybe<IfProductOutput>;
  IfSitePage?: Maybe<IfSitePageOutput>;
  IfTopQuestionsPage?: Maybe<IfTopQuestionsPageOutput>;
  IfWebshopPage?: Maybe<IfWebshopPageOutput>;
  IncludedItem?: Maybe<IncludedItemOutput>;
  InfoBox?: Maybe<InfoBoxOutput>;
  LabelBase?: Maybe<LabelBaseOutput>;
  Link?: Maybe<LinkOutput>;
  LinkTextAndUrl?: Maybe<LinkTextAndUrlOutput>;
  MultiSelectProductCommon?: Maybe<MultiSelectProductCommonOutput>;
  PersonalDetailsBlock?: Maybe<PersonalDetailsBlockOutput>;
  PersonalizationRegistryPage?: Maybe<PersonalizationRegistryPageOutput>;
  PricePageCommon?: Maybe<PricePageCommonOutput>;
  PriceSummarySectionContent?: Maybe<PriceSummarySectionContentOutput>;
  PromoCard?: Maybe<PromoCardOutput>;
  QuestionBase?: Maybe<QuestionBaseOutput>;
  RadioButtonInput?: Maybe<RadioButtonInputOutput>;
  RadioButtonValueItem?: Maybe<RadioButtonValueItemOutput>;
  RecommendationTagCard?: Maybe<RecommendationTagCardOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  TermsAndConditionItem?: Maybe<TermsAndConditionItemOutput>;
  TopMenuContent?: Maybe<TopMenuContentOutput>;
  TopQuestionsCommon?: Maybe<TopQuestionsCommonOutput>;
  TravelCommonBlock?: Maybe<TravelCommonBlockOutput>;
  TravelCommonPage?: Maybe<TravelCommonPageOutput>;
  TravelConfirmationPage?: Maybe<TravelConfirmationPageOutput>;
  TravelEntryPage?: Maybe<TravelEntryPageOutput>;
  TravelPricePage?: Maybe<TravelPricePageOutput>;
  TravelTopQuestionsPage?: Maybe<TravelTopQuestionsPageOutput>;
  ValidationMessageItem?: Maybe<ValidationMessageItemOutput>;
  YesAndNoAnswerContent?: Maybe<YesAndNoAnswerContentOutput>;
};


export type QueryRefAddonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AddonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AddonWhereInput>;
};


export type QueryRefBabyCommonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyCommonBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyCommonBlockWhereInput>;
};


export type QueryRefBabyCommonPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyCommonPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyCommonPageWhereInput>;
};


export type QueryRefBabyConfirmationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyConfirmationPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyConfirmationPageWhereInput>;
};


export type QueryRefBabyEntryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyEntryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyEntryPageWhereInput>;
};


export type QueryRefBabyPricePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyPricePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyPricePageWhereInput>;
};


export type QueryRefBabyTopQuestionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BabyTopQuestionsPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BabyTopQuestionsPageWhereInput>;
};


export type QueryRefBonusItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<BonusItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<BonusItemWhereInput>;
};


export type QueryRefButtonBaseArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ButtonBaseOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ButtonBaseWhereInput>;
};


export type QueryRefCampaignCardContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CampaignCardContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CampaignCardContentWhereInput>;
};


export type QueryRefCheckoutPageCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CheckoutPageCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CheckoutPageCommonWhereInput>;
};


export type QueryRefConfirmationPageCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConfirmationPageCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ConfirmationPageCommonWhereInput>;
};


export type QueryRefContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryRefCoverageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CoverageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CoverageWhereInput>;
};


export type QueryRefCubeDiscountContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CubeDiscountContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CubeDiscountContentWhereInput>;
};


export type QueryRefCurrencyPeriodSuffixArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CurrencyPeriodSuffixOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CurrencyPeriodSuffixWhereInput>;
};


export type QueryRefDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DataWhereInput>;
};


export type QueryRefElectronicHealthDeclerationContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ElectronicHealthDeclerationContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ElectronicHealthDeclerationContentWhereInput>;
};


export type QueryRefEntryPageCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EntryPageCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<EntryPageCommonWhereInput>;
};


export type QueryRefFooterContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FooterContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FooterContentWhereInput>;
};


export type QueryRefGlobalContentPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<GlobalContentPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<GlobalContentPageWhereInput>;
};


export type QueryRefHouseholderCommonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderCommonBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderCommonBlockWhereInput>;
};


export type QueryRefHouseholderCommonPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderCommonPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderCommonPageWhereInput>;
};


export type QueryRefHouseholderConfirmationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderConfirmationPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderConfirmationPageWhereInput>;
};


export type QueryRefHouseholderEntryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderEntryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderEntryPageWhereInput>;
};


export type QueryRefHouseholderPricePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderPricePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderPricePageWhereInput>;
};


export type QueryRefHouseholderTopQuestionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HouseholderTopQuestionsPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HouseholderTopQuestionsPageWhereInput>;
};


export type QueryRefHtmlElementArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HtmlElementOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HtmlElementWhereInput>;
};


export type QueryRefIfCheckoutPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfCheckoutPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfCheckoutPageWhereInput>;
};


export type QueryRefIfCommonPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfCommonPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfCommonPageWhereInput>;
};


export type QueryRefIfConfirmationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfConfirmationPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfConfirmationPageWhereInput>;
};


export type QueryRefIfContentPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfContentPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfContentPageWhereInput>;
};


export type QueryRefIfDomainPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfDomainPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfDomainPageWhereInput>;
};


export type QueryRefIfEntryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfEntryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfEntryPageWhereInput>;
};


export type QueryRefIfExperiencePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfExperiencePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfExperiencePageWhereInput>;
};


export type QueryRefIfMigrationFolderPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfMigrationFolderPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfMigrationFolderPageWhereInput>;
};


export type QueryRefIfPricePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfPricePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfPricePageWhereInput>;
};


export type QueryRefIfProductArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfProductOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfProductWhereInput>;
};


export type QueryRefIfSitePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfSitePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfSitePageWhereInput>;
};


export type QueryRefIfTopQuestionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfTopQuestionsPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfTopQuestionsPageWhereInput>;
};


export type QueryRefIfWebshopPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IfWebshopPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IfWebshopPageWhereInput>;
};


export type QueryRefIncludedItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IncludedItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IncludedItemWhereInput>;
};


export type QueryRefInfoBoxArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<InfoBoxOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<InfoBoxWhereInput>;
};


export type QueryRefLabelBaseArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LabelBaseOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LabelBaseWhereInput>;
};


export type QueryRefLinkArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryRefLinkTextAndUrlArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<LinkTextAndUrlOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<LinkTextAndUrlWhereInput>;
};


export type QueryRefMultiSelectProductCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MultiSelectProductCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MultiSelectProductCommonWhereInput>;
};


export type QueryRefPersonalDetailsBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonalDetailsBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PersonalDetailsBlockWhereInput>;
};


export type QueryRefPersonalizationRegistryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PersonalizationRegistryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PersonalizationRegistryPageWhereInput>;
};


export type QueryRefPricePageCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PricePageCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PricePageCommonWhereInput>;
};


export type QueryRefPriceSummarySectionContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PriceSummarySectionContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PriceSummarySectionContentWhereInput>;
};


export type QueryRefPromoCardArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PromoCardOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PromoCardWhereInput>;
};


export type QueryRefQuestionBaseArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<QuestionBaseOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<QuestionBaseWhereInput>;
};


export type QueryRefRadioButtonInputArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RadioButtonInputOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RadioButtonInputWhereInput>;
};


export type QueryRefRadioButtonValueItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RadioButtonValueItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RadioButtonValueItemWhereInput>;
};


export type QueryRefRecommendationTagCardArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RecommendationTagCardOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RecommendationTagCardWhereInput>;
};


export type QueryRefSiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteDefinitionWhereInput>;
};


export type QueryRefTermsAndConditionItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TermsAndConditionItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TermsAndConditionItemWhereInput>;
};


export type QueryRefTopMenuContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TopMenuContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TopMenuContentWhereInput>;
};


export type QueryRefTopQuestionsCommonArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TopQuestionsCommonOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TopQuestionsCommonWhereInput>;
};


export type QueryRefTravelCommonBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelCommonBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelCommonBlockWhereInput>;
};


export type QueryRefTravelCommonPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelCommonPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelCommonPageWhereInput>;
};


export type QueryRefTravelConfirmationPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelConfirmationPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelConfirmationPageWhereInput>;
};


export type QueryRefTravelEntryPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelEntryPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelEntryPageWhereInput>;
};


export type QueryRefTravelPricePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelPricePageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelPricePageWhereInput>;
};


export type QueryRefTravelTopQuestionsPageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TravelTopQuestionsPageOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TravelTopQuestionsPageWhereInput>;
};


export type QueryRefValidationMessageItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ValidationMessageItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ValidationMessageItemWhereInput>;
};


export type QueryRefYesAndNoAnswerContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<YesAndNoAnswerContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<YesAndNoAnswerContentWhereInput>;
};

/** A generic question. */
export type QuestionBase = IContent & IData & {
  __typename?: 'QuestionBase';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<QuestionBaseValidationMessageItem>>>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A generic question. */
export type QuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic question. */
export type QuestionBaseNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic question. */
export type QuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic question. */
export type QuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic question. */
export type QuestionBase_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A generic question. */
export type QuestionBase_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type QuestionBaseAutocomplete = {
  __typename?: 'QuestionBaseAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QuestionBaseAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type QuestionBaseAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type QuestionBaseFacet = {
  __typename?: 'QuestionBaseFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<QuestionBaseValidationMessageItemFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type QuestionBaseFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionBaseFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionBaseFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionBaseFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionBaseFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionBaseFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type QuestionBaseOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<QuestionBaseValidationMessageItemOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type QuestionBaseOutput = {
  __typename?: 'QuestionBaseOutput';
  autocomplete?: Maybe<QuestionBaseAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<QuestionBaseFacet>;
  item?: Maybe<QuestionBase>;
  items?: Maybe<Array<Maybe<QuestionBase>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type QuestionBaseOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionBaseValidationMessageItem = {
  __typename?: 'QuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type QuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type QuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type QuestionBaseValidationMessageItemFacet = {
  __typename?: 'QuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type QuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type QuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type QuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type QuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type QuestionBaseWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ValidationMessages?: InputMaybe<QuestionBaseValidationMessageItemWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<QuestionBaseWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<QuestionBaseWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<QuestionBaseWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A radio button input. */
export type RadioButtonInput = IContent & IData & {
  __typename?: 'RadioButtonInput';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  RadionButtonValues?: Maybe<Array<Maybe<RadioButtonInputRadioButtonValueItem>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<RadioButtonInputValidationMessageItem>>>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A radio button input. */
export type RadioButtonInputLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A radio button input. */
export type RadioButtonInputNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A radio button input. */
export type RadioButtonInputPlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A radio button input. */
export type RadioButtonInputPopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A radio button input. */
export type RadioButtonInput_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A radio button input. */
export type RadioButtonInput_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RadioButtonInputAutocomplete = {
  __typename?: 'RadioButtonInputAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RadioButtonInputAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonInputAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RadioButtonInputFacet = {
  __typename?: 'RadioButtonInputFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  RadionButtonValues?: Maybe<RadioButtonInputRadioButtonValueItemFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<RadioButtonInputValidationMessageItemFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type RadioButtonInputFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonInputFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonInputFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonInputFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonInputFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonInputFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RadioButtonInputOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  RadionButtonValues?: InputMaybe<RadioButtonInputRadioButtonValueItemOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<RadioButtonInputValidationMessageItemOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RadioButtonInputOutput = {
  __typename?: 'RadioButtonInputOutput';
  autocomplete?: Maybe<RadioButtonInputAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RadioButtonInputFacet>;
  item?: Maybe<RadioButtonInput>;
  items?: Maybe<Array<Maybe<RadioButtonInput>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RadioButtonInputOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RadioButtonInputRadioButtonValueItem = {
  __typename?: 'RadioButtonInputRadioButtonValueItem';
  DefaultChecked?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type RadioButtonInputRadioButtonValueItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RadioButtonInputRadioButtonValueItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RadioButtonInputRadioButtonValueItemFacet = {
  __typename?: 'RadioButtonInputRadioButtonValueItemFacet';
  DefaultChecked?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type RadioButtonInputRadioButtonValueItemFacetDefaultCheckedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputRadioButtonValueItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputRadioButtonValueItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RadioButtonInputRadioButtonValueItemOrderByInput = {
  DefaultChecked?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type RadioButtonInputRadioButtonValueItemWhereInput = {
  DefaultChecked?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type RadioButtonInputValidationMessageItem = {
  __typename?: 'RadioButtonInputValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type RadioButtonInputValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RadioButtonInputValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type RadioButtonInputValidationMessageItemFacet = {
  __typename?: 'RadioButtonInputValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type RadioButtonInputValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonInputValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RadioButtonInputValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type RadioButtonInputValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type RadioButtonInputWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  RadionButtonValues?: InputMaybe<RadioButtonInputRadioButtonValueItemWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  ValidationMessages?: InputMaybe<RadioButtonInputValidationMessageItemWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<RadioButtonInputWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RadioButtonInputWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RadioButtonInputWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An selectable option for the radio button input. */
export type RadioButtonValueItem = IContent & IData & {
  __typename?: 'RadioButtonValueItem';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Indicates if this option should be selected by default */
  DefaultChecked?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** The label visisble to the user */
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** The backing value of the input */
  Value?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An selectable option for the radio button input. */
export type RadioButtonValueItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An selectable option for the radio button input. */
export type RadioButtonValueItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An selectable option for the radio button input. */
export type RadioButtonValueItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An selectable option for the radio button input. */
export type RadioButtonValueItem_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An selectable option for the radio button input. */
export type RadioButtonValueItem_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RadioButtonValueItemAutocomplete = {
  __typename?: 'RadioButtonValueItemAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RadioButtonValueItemAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RadioButtonValueItemAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RadioButtonValueItemFacet = {
  __typename?: 'RadioButtonValueItemFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DefaultChecked?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type RadioButtonValueItemFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonValueItemFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonValueItemFacetDefaultCheckedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonValueItemFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonValueItemFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RadioButtonValueItemFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RadioButtonValueItemFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RadioButtonValueItemOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DefaultChecked?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RadioButtonValueItemOutput = {
  __typename?: 'RadioButtonValueItemOutput';
  autocomplete?: Maybe<RadioButtonValueItemAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RadioButtonValueItemFacet>;
  item?: Maybe<RadioButtonValueItem>;
  items?: Maybe<Array<Maybe<RadioButtonValueItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RadioButtonValueItemOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RadioButtonValueItemWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DefaultChecked?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RadioButtonValueItemWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RadioButtonValueItemWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RadioButtonValueItemWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type RangeFacetsInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export enum Ranking {
  BoostOnly = 'BOOST_ONLY',
  Doc = 'DOC',
  Relevance = 'RELEVANCE',
  Semantic = 'SEMANTIC'
}

/** Recommendation tag card */
export type RecommendationTagCard = IContent & IData & {
  __typename?: 'RecommendationTagCard';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Background image. */
  BackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  /** Description */
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  /** Redirect url */
  RedirectUrl?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  /** Tag label */
  TagLabel?: Maybe<Scalars['String']['output']>;
  /** Main title */
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Recommendation tag card */
export type RecommendationTagCardDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Recommendation tag card */
export type RecommendationTagCardNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Recommendation tag card */
export type RecommendationTagCardTagLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Recommendation tag card */
export type RecommendationTagCardTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Recommendation tag card */
export type RecommendationTagCard_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Recommendation tag card */
export type RecommendationTagCard_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RecommendationTagCardAutocomplete = {
  __typename?: 'RecommendationTagCardAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImageUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RedirectUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RecommendationTagCardAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteBackgroundImageUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteRedirectUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecommendationTagCardAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RecommendationTagCardFacet = {
  __typename?: 'RecommendationTagCardFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundImageUrl?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RedirectUrl?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TagLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type RecommendationTagCardFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetBackgroundImageUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecommendationTagCardFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecommendationTagCardFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetRedirectUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecommendationTagCardFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecommendationTagCardFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecommendationTagCardFacetTagLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecommendationTagCardFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type RecommendationTagCardOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundImageUrl?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RedirectUrl?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TagLabel?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type RecommendationTagCardOutput = {
  __typename?: 'RecommendationTagCardOutput';
  autocomplete?: Maybe<RecommendationTagCardAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RecommendationTagCardFacet>;
  item?: Maybe<RecommendationTagCard>;
  items?: Maybe<Array<Maybe<RecommendationTagCard>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RecommendationTagCardOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecommendationTagCardWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundImageUrl?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RedirectUrl?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TagLabel?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RecommendationTagCardWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RecommendationTagCardWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RecommendationTagCardWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export type SearchableStringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `contains` performs full-text search on a word or phrase. */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']['input']>;
  /** `match` performs full-text search on a word or phrase where less relevant items are also returned. The `match` operator is only supported for `searchable` fields. It will improve fulltext search by making it easier to match on words. More exact matches will be ranked higher, less exact matches will be ranked lower. The `match` operator is supported with synonyms and fuzzy search. */
  match?: InputMaybe<Scalars['String']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export type SiteDefinition = IData & {
  __typename?: 'SiteDefinition';
  ContentLink?: Maybe<ContentModelReference>;
  ContentRoots?: Maybe<ContentRootsModel>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EditLocation?: Maybe<Scalars['String']['output']>;
  Hosts?: Maybe<Array<Maybe<HostDefinitionModel>>>;
  Id?: Maybe<Scalars['String']['output']>;
  Languages?: Maybe<Array<Maybe<SiteDefinitionLanguageModel>>>;
  Name?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SiteDefinitionNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDefinition_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDefinition_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteDefinitionAutocomplete = {
  __typename?: 'SiteDefinitionAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentRoots?: Maybe<ContentRootsModelAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EditLocation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Hosts?: Maybe<HostDefinitionModelAutocomplete>;
  Id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteDefinitionAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteEditLocationArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionFacet = {
  __typename?: 'SiteDefinitionFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentRoots?: Maybe<ContentRootsModelFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  EditLocation?: Maybe<Array<Maybe<StringFacet>>>;
  Hosts?: Maybe<HostDefinitionModelFacet>;
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDefinitionFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetEditLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModel = {
  __typename?: 'SiteDefinitionLanguageModel';
  DisplayName?: Maybe<Scalars['String']['output']>;
  IsMasterLanguage?: Maybe<Scalars['Bool']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UrlSegment?: Maybe<Scalars['String']['output']>;
};

export type SiteDefinitionLanguageModelAutocomplete = {
  __typename?: 'SiteDefinitionLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  UrlSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteDefinitionLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteUrlSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionLanguageModelFacet = {
  __typename?: 'SiteDefinitionLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  IsMasterLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UrlSegment?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDefinitionLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetIsMasterLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetUrlSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  IsMasterLanguage?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UrlSegment?: InputMaybe<OrderBy>;
};

export type SiteDefinitionLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  IsMasterLanguage?: InputMaybe<BoolFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UrlSegment?: InputMaybe<StringFilterInput>;
};

export type SiteDefinitionOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentRoots?: InputMaybe<ContentRootsModelOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  EditLocation?: InputMaybe<OrderBy>;
  Hosts?: InputMaybe<HostDefinitionModelOrderByInput>;
  Id?: InputMaybe<OrderBy>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteDefinitionOutput = {
  __typename?: 'SiteDefinitionOutput';
  autocomplete?: Maybe<SiteDefinitionAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteDefinitionFacet>;
  item?: Maybe<SiteDefinition>;
  items?: Maybe<Array<Maybe<SiteDefinition>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteDefinitionOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteDefinitionWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentRoots?: InputMaybe<ContentRootsModelWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  EditLocation?: InputMaybe<StringFilterInput>;
  Hosts?: InputMaybe<HostDefinitionModelWhereInput>;
  Id?: InputMaybe<StringFilterInput>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
};

export type StringFacet = {
  __typename?: 'StringFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `ends_with` retrieves matches that end with a certain value (suffix). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export enum SynonymSlot {
  /** synonym slot 1 */
  One = 'ONE',
  /** synonym slot 2 */
  Two = 'TWO'
}

/** A link to a terms and conditions page or document. */
export type TermsAndConditionItem = IContent & IData & {
  __typename?: 'TermsAndConditionItem';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  /** The url */
  Href?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** Label */
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A link to a terms and conditions page or document. */
export type TermsAndConditionItemHrefArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link to a terms and conditions page or document. */
export type TermsAndConditionItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link to a terms and conditions page or document. */
export type TermsAndConditionItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link to a terms and conditions page or document. */
export type TermsAndConditionItem_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A link to a terms and conditions page or document. */
export type TermsAndConditionItem_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TermsAndConditionItemAutocomplete = {
  __typename?: 'TermsAndConditionItemAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TermsAndConditionItemAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TermsAndConditionItemAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TermsAndConditionItemFacet = {
  __typename?: 'TermsAndConditionItemFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Href?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TermsAndConditionItemFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionItemFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionItemFacetHrefArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionItemFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionItemFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionItemFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TermsAndConditionItemFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TermsAndConditionItemOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Href?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TermsAndConditionItemOutput = {
  __typename?: 'TermsAndConditionItemOutput';
  autocomplete?: Maybe<TermsAndConditionItemAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TermsAndConditionItemFacet>;
  item?: Maybe<TermsAndConditionItem>;
  items?: Maybe<Array<Maybe<TermsAndConditionItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TermsAndConditionItemOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TermsAndConditionItemWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Href?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TermsAndConditionItemWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TermsAndConditionItemWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TermsAndConditionItemWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Top menu content for the website */
export type TopMenuContent = IContent & IData & {
  __typename?: 'TopMenuContent';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ClaimsMenuOption?: Maybe<TopMenuContentLinkTextAndUrl>;
  CompanyMenuOption?: Maybe<TopMenuContentLinkTextAndUrl>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CustomerServiceMenuOption?: Maybe<TopMenuContentLinkTextAndUrl>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  InsurancesMenuOption?: Maybe<TopMenuContentLinkTextAndUrl>;
  InsurancesMenuOptionNordeaUrl?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LargeEnterprisesMenuOption?: Maybe<TopMenuContentLinkTextAndUrl>;
  LogInMenuText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MobileMenuText?: Maybe<Scalars['String']['output']>;
  MyPageMenuOption?: Maybe<TopMenuContentLinkTextAndUrl>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PrivateMenuOption?: Maybe<TopMenuContentLinkTextAndUrl>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ShoppingBasket?: Maybe<TopMenuContentLinkTextAndUrl>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Top menu content for the website */
export type TopMenuContentInsurancesMenuOptionNordeaUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top menu content for the website */
export type TopMenuContentLogInMenuTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top menu content for the website */
export type TopMenuContentMobileMenuTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top menu content for the website */
export type TopMenuContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top menu content for the website */
export type TopMenuContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top menu content for the website */
export type TopMenuContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TopMenuContentAutocomplete = {
  __typename?: 'TopMenuContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TopMenuContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopMenuContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TopMenuContentFacet = {
  __typename?: 'TopMenuContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ClaimsMenuOption?: Maybe<TopMenuContentLinkTextAndUrlFacet>;
  CompanyMenuOption?: Maybe<TopMenuContentLinkTextAndUrlFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CustomerServiceMenuOption?: Maybe<TopMenuContentLinkTextAndUrlFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  InsurancesMenuOption?: Maybe<TopMenuContentLinkTextAndUrlFacet>;
  InsurancesMenuOptionNordeaUrl?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LargeEnterprisesMenuOption?: Maybe<TopMenuContentLinkTextAndUrlFacet>;
  LogInMenuText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MobileMenuText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPageMenuOption?: Maybe<TopMenuContentLinkTextAndUrlFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PrivateMenuOption?: Maybe<TopMenuContentLinkTextAndUrlFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShoppingBasket?: Maybe<TopMenuContentLinkTextAndUrlFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TopMenuContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopMenuContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopMenuContentFacetInsurancesMenuOptionNordeaUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetLogInMenuTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetMobileMenuTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopMenuContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopMenuContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopMenuContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TopMenuContentLinkTextAndUrl = {
  __typename?: 'TopMenuContentLinkTextAndUrl';
  Text?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
};


export type TopMenuContentLinkTextAndUrlTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TopMenuContentLinkTextAndUrlUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TopMenuContentLinkTextAndUrlFacet = {
  __typename?: 'TopMenuContentLinkTextAndUrlFacet';
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TopMenuContentLinkTextAndUrlFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopMenuContentLinkTextAndUrlFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TopMenuContentLinkTextAndUrlOrderByInput = {
  Text?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
};

export type TopMenuContentLinkTextAndUrlWhereInput = {
  Text?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<SearchableStringFilterInput>;
};

export type TopMenuContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ClaimsMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlOrderByInput>;
  CompanyMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CustomerServiceMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  InsurancesMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlOrderByInput>;
  InsurancesMenuOptionNordeaUrl?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LargeEnterprisesMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlOrderByInput>;
  LogInMenuText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MobileMenuText?: InputMaybe<OrderBy>;
  MyPageMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrivateMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShoppingBasket?: InputMaybe<TopMenuContentLinkTextAndUrlOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TopMenuContentOutput = {
  __typename?: 'TopMenuContentOutput';
  autocomplete?: Maybe<TopMenuContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TopMenuContentFacet>;
  item?: Maybe<TopMenuContent>;
  items?: Maybe<Array<Maybe<TopMenuContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TopMenuContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TopMenuContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ClaimsMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlWhereInput>;
  CompanyMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CustomerServiceMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  InsurancesMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlWhereInput>;
  InsurancesMenuOptionNordeaUrl?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LargeEnterprisesMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlWhereInput>;
  LogInMenuText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MobileMenuText?: InputMaybe<SearchableStringFilterInput>;
  MyPageMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PrivateMenuOption?: InputMaybe<TopMenuContentLinkTextAndUrlWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShoppingBasket?: InputMaybe<TopMenuContentLinkTextAndUrlWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TopMenuContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TopMenuContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TopMenuContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Common top questions */
export type TopQuestionsCommon = IContent & IData & {
  __typename?: 'TopQuestionsCommon';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FormTitle?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Common top questions */
export type TopQuestionsCommonFormTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common top questions */
export type TopQuestionsCommonNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common top questions */
export type TopQuestionsCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common top questions */
export type TopQuestionsCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common top questions */
export type TopQuestionsCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common top questions */
export type TopQuestionsCommon_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Common top questions */
export type TopQuestionsCommon_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TopQuestionsCommonAutocomplete = {
  __typename?: 'TopQuestionsCommonAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TopQuestionsCommonAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TopQuestionsCommonAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TopQuestionsCommonFacet = {
  __typename?: 'TopQuestionsCommonFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormTitle?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TopQuestionsCommonFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopQuestionsCommonFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopQuestionsCommonFacetFormTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopQuestionsCommonFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopQuestionsCommonFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TopQuestionsCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TopQuestionsCommonFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TopQuestionsCommonOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormTitle?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TopQuestionsCommonOutput = {
  __typename?: 'TopQuestionsCommonOutput';
  autocomplete?: Maybe<TopQuestionsCommonAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TopQuestionsCommonFacet>;
  item?: Maybe<TopQuestionsCommon>;
  items?: Maybe<Array<Maybe<TopQuestionsCommon>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TopQuestionsCommonOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TopQuestionsCommonWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormTitle?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TopQuestionsCommonWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TopQuestionsCommonWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TopQuestionsCommonWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Reusable migrated block for Travel common content. */
export type TravelCommonBlock = IContent & IData & {
  __typename?: 'TravelCommonBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DestinationCountryQuestion?: Maybe<TravelCommonBlockQuestionBase>;
  EndDateQuestion?: Maybe<TravelCommonBlockQuestionBase>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FillTheFormLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PermanentResidentOfFinlandQuestion?: Maybe<TravelCommonBlockQuestionBase>;
  PostalCodeQuestion?: Maybe<TravelCommonBlockQuestionBase>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartDateQuestion?: Maybe<TravelCommonBlockQuestionBase>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TravelInsuranceTypeContinuous?: Maybe<Scalars['String']['output']>;
  TravelInsuranceTypeFixed?: Maybe<Scalars['String']['output']>;
  TravelInsuranceTypeQuestion?: Maybe<TravelCommonBlockQuestionBase>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Reusable migrated block for Travel common content. */
export type TravelCommonBlockFillTheFormLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Travel common content. */
export type TravelCommonBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Travel common content. */
export type TravelCommonBlockTravelInsuranceTypeContinuousArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Travel common content. */
export type TravelCommonBlockTravelInsuranceTypeFixedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Travel common content. */
export type TravelCommonBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Reusable migrated block for Travel common content. */
export type TravelCommonBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TravelCommonBlockAutocomplete = {
  __typename?: 'TravelCommonBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TravelCommonBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TravelCommonBlockFacet = {
  __typename?: 'TravelCommonBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DestinationCountryQuestion?: Maybe<TravelCommonBlockQuestionBaseFacet>;
  EndDateQuestion?: Maybe<TravelCommonBlockQuestionBaseFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FillTheFormLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PermanentResidentOfFinlandQuestion?: Maybe<TravelCommonBlockQuestionBaseFacet>;
  PostalCodeQuestion?: Maybe<TravelCommonBlockQuestionBaseFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartDateQuestion?: Maybe<TravelCommonBlockQuestionBaseFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TravelInsuranceTypeContinuous?: Maybe<Array<Maybe<StringFacet>>>;
  TravelInsuranceTypeFixed?: Maybe<Array<Maybe<StringFacet>>>;
  TravelInsuranceTypeQuestion?: Maybe<TravelCommonBlockQuestionBaseFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TravelCommonBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonBlockFacetFillTheFormLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonBlockFacetTravelInsuranceTypeContinuousArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetTravelInsuranceTypeFixedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TravelCommonBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DestinationCountryQuestion?: InputMaybe<TravelCommonBlockQuestionBaseOrderByInput>;
  EndDateQuestion?: InputMaybe<TravelCommonBlockQuestionBaseOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FillTheFormLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PermanentResidentOfFinlandQuestion?: InputMaybe<TravelCommonBlockQuestionBaseOrderByInput>;
  PostalCodeQuestion?: InputMaybe<TravelCommonBlockQuestionBaseOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartDateQuestion?: InputMaybe<TravelCommonBlockQuestionBaseOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TravelInsuranceTypeContinuous?: InputMaybe<OrderBy>;
  TravelInsuranceTypeFixed?: InputMaybe<OrderBy>;
  TravelInsuranceTypeQuestion?: InputMaybe<TravelCommonBlockQuestionBaseOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TravelCommonBlockOutput = {
  __typename?: 'TravelCommonBlockOutput';
  autocomplete?: Maybe<TravelCommonBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TravelCommonBlockFacet>;
  item?: Maybe<TravelCommonBlock>;
  items?: Maybe<Array<Maybe<TravelCommonBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TravelCommonBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TravelCommonBlockQuestionBase = {
  __typename?: 'TravelCommonBlockQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<TravelCommonBlockQuestionBaseValidationMessageItem>>>;
};


export type TravelCommonBlockQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelCommonBlockQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelCommonBlockQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelCommonBlockQuestionBaseFacet = {
  __typename?: 'TravelCommonBlockQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<TravelCommonBlockQuestionBaseValidationMessageItemFacet>;
};


export type TravelCommonBlockQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelCommonBlockQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<TravelCommonBlockQuestionBaseValidationMessageItemOrderByInput>;
};

export type TravelCommonBlockQuestionBaseValidationMessageItem = {
  __typename?: 'TravelCommonBlockQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type TravelCommonBlockQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelCommonBlockQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelCommonBlockQuestionBaseValidationMessageItemFacet = {
  __typename?: 'TravelCommonBlockQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelCommonBlockQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonBlockQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelCommonBlockQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type TravelCommonBlockQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelCommonBlockQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<TravelCommonBlockQuestionBaseValidationMessageItemWhereInput>;
};

export type TravelCommonBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DestinationCountryQuestion?: InputMaybe<TravelCommonBlockQuestionBaseWhereInput>;
  EndDateQuestion?: InputMaybe<TravelCommonBlockQuestionBaseWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FillTheFormLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PermanentResidentOfFinlandQuestion?: InputMaybe<TravelCommonBlockQuestionBaseWhereInput>;
  PostalCodeQuestion?: InputMaybe<TravelCommonBlockQuestionBaseWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartDateQuestion?: InputMaybe<TravelCommonBlockQuestionBaseWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TravelInsuranceTypeContinuous?: InputMaybe<SearchableStringFilterInput>;
  TravelInsuranceTypeFixed?: InputMaybe<SearchableStringFilterInput>;
  TravelInsuranceTypeQuestion?: InputMaybe<TravelCommonBlockQuestionBaseWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TravelCommonBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TravelCommonBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TravelCommonBlockWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Travel Common */
export type TravelCommonPage = IContent & IData & {
  __typename?: 'TravelCommonPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DestinationCountryQuestion?: Maybe<TravelCommonPageQuestionBase>;
  EndDateQuestion?: Maybe<TravelCommonPageQuestionBase>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FillTheFormLabel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PermanentResidentOfFinlandQuestion?: Maybe<TravelCommonPageQuestionBase>;
  PostalCodeQuestion?: Maybe<TravelCommonPageQuestionBase>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartDateQuestion?: Maybe<TravelCommonPageQuestionBase>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TravelInsuranceTypeContinuous?: Maybe<Scalars['String']['output']>;
  TravelInsuranceTypeFixed?: Maybe<Scalars['String']['output']>;
  TravelInsuranceTypeQuestion?: Maybe<TravelCommonPageQuestionBase>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Travel Common */
export type TravelCommonPageFillTheFormLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Travel Common */
export type TravelCommonPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Travel Common */
export type TravelCommonPageTravelInsuranceTypeContinuousArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Travel Common */
export type TravelCommonPageTravelInsuranceTypeFixedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Travel Common */
export type TravelCommonPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Travel Common */
export type TravelCommonPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TravelCommonPageAutocomplete = {
  __typename?: 'TravelCommonPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TravelCommonPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelCommonPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TravelCommonPageFacet = {
  __typename?: 'TravelCommonPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DestinationCountryQuestion?: Maybe<TravelCommonPageQuestionBaseFacet>;
  EndDateQuestion?: Maybe<TravelCommonPageQuestionBaseFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FillTheFormLabel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PermanentResidentOfFinlandQuestion?: Maybe<TravelCommonPageQuestionBaseFacet>;
  PostalCodeQuestion?: Maybe<TravelCommonPageQuestionBaseFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartDateQuestion?: Maybe<TravelCommonPageQuestionBaseFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TravelInsuranceTypeContinuous?: Maybe<Array<Maybe<StringFacet>>>;
  TravelInsuranceTypeFixed?: Maybe<Array<Maybe<StringFacet>>>;
  TravelInsuranceTypeQuestion?: Maybe<TravelCommonPageQuestionBaseFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TravelCommonPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonPageFacetFillTheFormLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelCommonPageFacetTravelInsuranceTypeContinuousArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetTravelInsuranceTypeFixedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TravelCommonPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DestinationCountryQuestion?: InputMaybe<TravelCommonPageQuestionBaseOrderByInput>;
  EndDateQuestion?: InputMaybe<TravelCommonPageQuestionBaseOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FillTheFormLabel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PermanentResidentOfFinlandQuestion?: InputMaybe<TravelCommonPageQuestionBaseOrderByInput>;
  PostalCodeQuestion?: InputMaybe<TravelCommonPageQuestionBaseOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartDateQuestion?: InputMaybe<TravelCommonPageQuestionBaseOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TravelInsuranceTypeContinuous?: InputMaybe<OrderBy>;
  TravelInsuranceTypeFixed?: InputMaybe<OrderBy>;
  TravelInsuranceTypeQuestion?: InputMaybe<TravelCommonPageQuestionBaseOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TravelCommonPageOutput = {
  __typename?: 'TravelCommonPageOutput';
  autocomplete?: Maybe<TravelCommonPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TravelCommonPageFacet>;
  item?: Maybe<TravelCommonPage>;
  items?: Maybe<Array<Maybe<TravelCommonPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TravelCommonPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TravelCommonPageQuestionBase = {
  __typename?: 'TravelCommonPageQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<TravelCommonPageQuestionBaseValidationMessageItem>>>;
};


export type TravelCommonPageQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelCommonPageQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelCommonPageQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelCommonPageQuestionBaseFacet = {
  __typename?: 'TravelCommonPageQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<TravelCommonPageQuestionBaseValidationMessageItemFacet>;
};


export type TravelCommonPageQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelCommonPageQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<TravelCommonPageQuestionBaseValidationMessageItemOrderByInput>;
};

export type TravelCommonPageQuestionBaseValidationMessageItem = {
  __typename?: 'TravelCommonPageQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type TravelCommonPageQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelCommonPageQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelCommonPageQuestionBaseValidationMessageItemFacet = {
  __typename?: 'TravelCommonPageQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelCommonPageQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelCommonPageQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelCommonPageQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type TravelCommonPageQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelCommonPageQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<TravelCommonPageQuestionBaseValidationMessageItemWhereInput>;
};

export type TravelCommonPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DestinationCountryQuestion?: InputMaybe<TravelCommonPageQuestionBaseWhereInput>;
  EndDateQuestion?: InputMaybe<TravelCommonPageQuestionBaseWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FillTheFormLabel?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PermanentResidentOfFinlandQuestion?: InputMaybe<TravelCommonPageQuestionBaseWhereInput>;
  PostalCodeQuestion?: InputMaybe<TravelCommonPageQuestionBaseWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartDateQuestion?: InputMaybe<TravelCommonPageQuestionBaseWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TravelInsuranceTypeContinuous?: InputMaybe<SearchableStringFilterInput>;
  TravelInsuranceTypeFixed?: InputMaybe<SearchableStringFilterInput>;
  TravelInsuranceTypeQuestion?: InputMaybe<TravelCommonPageQuestionBaseWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TravelCommonPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TravelCommonPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TravelCommonPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** An page containing the travel confirmation content. */
export type TravelConfirmationPage = IContent & IData & {
  __typename?: 'TravelConfirmationPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationPageCommon?: Maybe<TravelConfirmationPageConfirmationPageCommon>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NextStepEhdHeader?: Maybe<Scalars['String']['output']>;
  NextStepEhdInfo?: Maybe<Scalars['String']['output']>;
  NextStepMypagesButtonText?: Maybe<Scalars['String']['output']>;
  NextStepMypagesInfoText?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** An page containing the travel confirmation content. */
export type TravelConfirmationPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the travel confirmation content. */
export type TravelConfirmationPageNextStepEhdHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the travel confirmation content. */
export type TravelConfirmationPageNextStepEhdInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the travel confirmation content. */
export type TravelConfirmationPageNextStepMypagesButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the travel confirmation content. */
export type TravelConfirmationPageNextStepMypagesInfoTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the travel confirmation content. */
export type TravelConfirmationPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** An page containing the travel confirmation content. */
export type TravelConfirmationPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TravelConfirmationPageAutocomplete = {
  __typename?: 'TravelConfirmationPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TravelConfirmationPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelConfirmationPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TravelConfirmationPageConfirmationPageCommon = {
  __typename?: 'TravelConfirmationPageConfirmationPageCommon';
  AboutInsuranceSectionHeaderText?: Maybe<Scalars['String']['output']>;
  AddOnHeaderText?: Maybe<Scalars['String']['output']>;
  CancellationBlock?: Maybe<Scalars['String']['output']>;
  DiscountText?: Maybe<Scalars['String']['output']>;
  InvoicingInfoExistingCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingInfoNewCustomer?: Maybe<Scalars['String']['output']>;
  InvoicingSectionHeader?: Maybe<Scalars['String']['output']>;
  LogoutLink?: Maybe<Scalars['String']['output']>;
  LogoutLinkText?: Maybe<Scalars['String']['output']>;
  LogoutText?: Maybe<Scalars['String']['output']>;
  MyPagesButtonText?: Maybe<Scalars['String']['output']>;
  MyPagesScaluText?: Maybe<Scalars['String']['output']>;
  MyPagesSectionHeader?: Maybe<Scalars['String']['output']>;
  MyPagesText?: Maybe<Scalars['String']['output']>;
  NordeaCampaignInfo?: Maybe<Scalars['String']['output']>;
  PageHeaderText?: Maybe<Scalars['String']['output']>;
  SecondaryHeader?: Maybe<Scalars['String']['output']>;
  TotalAmount?: Maybe<Scalars['String']['output']>;
};


export type TravelConfirmationPageConfirmationPageCommonAboutInsuranceSectionHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonAddOnHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonCancellationBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonDiscountTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonInvoicingInfoExistingCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonInvoicingInfoNewCustomerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonInvoicingSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonLogoutLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonLogoutLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonLogoutTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonMyPagesButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonMyPagesScaluTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonMyPagesSectionHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonMyPagesTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonNordeaCampaignInfoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonPageHeaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonSecondaryHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelConfirmationPageConfirmationPageCommonTotalAmountArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelConfirmationPageConfirmationPageCommonFacet = {
  __typename?: 'TravelConfirmationPageConfirmationPageCommonFacet';
  AboutInsuranceSectionHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  AddOnHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  CancellationBlock?: Maybe<Array<Maybe<StringFacet>>>;
  DiscountText?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoExistingCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingInfoNewCustomer?: Maybe<Array<Maybe<StringFacet>>>;
  InvoicingSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLink?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutLinkText?: Maybe<Array<Maybe<StringFacet>>>;
  LogoutText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesScaluText?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesSectionHeader?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesText?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignInfo?: Maybe<Array<Maybe<StringFacet>>>;
  PageHeaderText?: Maybe<Array<Maybe<StringFacet>>>;
  SecondaryHeader?: Maybe<Array<Maybe<StringFacet>>>;
  TotalAmount?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetAboutInsuranceSectionHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetAddOnHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetCancellationBlockArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetDiscountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetInvoicingInfoExistingCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetInvoicingInfoNewCustomerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetInvoicingSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetLogoutLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetLogoutLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetLogoutTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetMyPagesButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetMyPagesScaluTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetMyPagesSectionHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetMyPagesTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetNordeaCampaignInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetPageHeaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetSecondaryHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageConfirmationPageCommonFacetTotalAmountArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelConfirmationPageConfirmationPageCommonOrderByInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<OrderBy>;
  AddOnHeaderText?: InputMaybe<OrderBy>;
  CancellationBlock?: InputMaybe<OrderBy>;
  DiscountText?: InputMaybe<OrderBy>;
  InvoicingInfoExistingCustomer?: InputMaybe<OrderBy>;
  InvoicingInfoNewCustomer?: InputMaybe<OrderBy>;
  InvoicingSectionHeader?: InputMaybe<OrderBy>;
  LogoutLink?: InputMaybe<OrderBy>;
  LogoutLinkText?: InputMaybe<OrderBy>;
  LogoutText?: InputMaybe<OrderBy>;
  MyPagesButtonText?: InputMaybe<OrderBy>;
  MyPagesScaluText?: InputMaybe<OrderBy>;
  MyPagesSectionHeader?: InputMaybe<OrderBy>;
  MyPagesText?: InputMaybe<OrderBy>;
  NordeaCampaignInfo?: InputMaybe<OrderBy>;
  PageHeaderText?: InputMaybe<OrderBy>;
  SecondaryHeader?: InputMaybe<OrderBy>;
  TotalAmount?: InputMaybe<OrderBy>;
};

export type TravelConfirmationPageConfirmationPageCommonWhereInput = {
  AboutInsuranceSectionHeaderText?: InputMaybe<SearchableStringFilterInput>;
  AddOnHeaderText?: InputMaybe<SearchableStringFilterInput>;
  CancellationBlock?: InputMaybe<SearchableStringFilterInput>;
  DiscountText?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoExistingCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingInfoNewCustomer?: InputMaybe<SearchableStringFilterInput>;
  InvoicingSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  LogoutLink?: InputMaybe<SearchableStringFilterInput>;
  LogoutLinkText?: InputMaybe<SearchableStringFilterInput>;
  LogoutText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesButtonText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesScaluText?: InputMaybe<SearchableStringFilterInput>;
  MyPagesSectionHeader?: InputMaybe<SearchableStringFilterInput>;
  MyPagesText?: InputMaybe<SearchableStringFilterInput>;
  NordeaCampaignInfo?: InputMaybe<SearchableStringFilterInput>;
  PageHeaderText?: InputMaybe<SearchableStringFilterInput>;
  SecondaryHeader?: InputMaybe<SearchableStringFilterInput>;
  TotalAmount?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelConfirmationPageFacet = {
  __typename?: 'TravelConfirmationPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationPageCommon?: Maybe<TravelConfirmationPageConfirmationPageCommonFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NextStepEhdHeader?: Maybe<Array<Maybe<StringFacet>>>;
  NextStepEhdInfo?: Maybe<Array<Maybe<StringFacet>>>;
  NextStepMypagesButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  NextStepMypagesInfoText?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TravelConfirmationPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelConfirmationPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelConfirmationPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetNextStepEhdHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetNextStepEhdInfoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetNextStepMypagesButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetNextStepMypagesInfoTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelConfirmationPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelConfirmationPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelConfirmationPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelConfirmationPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TravelConfirmationPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationPageCommon?: InputMaybe<TravelConfirmationPageConfirmationPageCommonOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NextStepEhdHeader?: InputMaybe<OrderBy>;
  NextStepEhdInfo?: InputMaybe<OrderBy>;
  NextStepMypagesButtonText?: InputMaybe<OrderBy>;
  NextStepMypagesInfoText?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TravelConfirmationPageOutput = {
  __typename?: 'TravelConfirmationPageOutput';
  autocomplete?: Maybe<TravelConfirmationPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TravelConfirmationPageFacet>;
  item?: Maybe<TravelConfirmationPage>;
  items?: Maybe<Array<Maybe<TravelConfirmationPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TravelConfirmationPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TravelConfirmationPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationPageCommon?: InputMaybe<TravelConfirmationPageConfirmationPageCommonWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NextStepEhdHeader?: InputMaybe<SearchableStringFilterInput>;
  NextStepEhdInfo?: InputMaybe<SearchableStringFilterInput>;
  NextStepMypagesButtonText?: InputMaybe<SearchableStringFilterInput>;
  NextStepMypagesInfoText?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TravelConfirmationPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TravelConfirmationPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TravelConfirmationPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Entry page for travel products */
export type TravelEntryPage = IContent & IData & {
  __typename?: 'TravelEntryPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CoveredPersonMyselfLabel?: Maybe<Scalars['String']['output']>;
  CoveredPersonQuestion?: Maybe<TravelEntryPageQuestionBase>;
  CoveredPersonSpouseLabel?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  EntryPageCommon?: Maybe<TravelEntryPageEntryPageCommon>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SpouseSsnQuestion?: Maybe<TravelEntryPageQuestionBase>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Entry page for travel products */
export type TravelEntryPageCoveredPersonMyselfLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for travel products */
export type TravelEntryPageCoveredPersonSpouseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for travel products */
export type TravelEntryPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for travel products */
export type TravelEntryPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Entry page for travel products */
export type TravelEntryPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TravelEntryPageAutocomplete = {
  __typename?: 'TravelEntryPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TravelEntryPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelEntryPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TravelEntryPageEntryPageCommon = {
  __typename?: 'TravelEntryPageEntryPageCommon';
  Description?: Maybe<Scalars['String']['output']>;
  SsnQuestion?: Maybe<TravelEntryPageEntryPageCommonQuestionBase>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Terms?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type TravelEntryPageEntryPageCommonDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageEntryPageCommonSubTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageEntryPageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageEntryPageCommonTermsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageEntryPageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelEntryPageEntryPageCommonFacet = {
  __typename?: 'TravelEntryPageEntryPageCommonFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  SsnQuestion?: Maybe<TravelEntryPageEntryPageCommonQuestionBaseFacet>;
  SubTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Terms?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelEntryPageEntryPageCommonFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageEntryPageCommonFacetSubTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageEntryPageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageEntryPageCommonFacetTermsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageEntryPageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelEntryPageEntryPageCommonOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  SsnQuestion?: InputMaybe<TravelEntryPageEntryPageCommonQuestionBaseOrderByInput>;
  SubTitle?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Terms?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type TravelEntryPageEntryPageCommonQuestionBase = {
  __typename?: 'TravelEntryPageEntryPageCommonQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItem>>>;
};


export type TravelEntryPageEntryPageCommonQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageEntryPageCommonQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageEntryPageCommonQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelEntryPageEntryPageCommonQuestionBaseFacet = {
  __typename?: 'TravelEntryPageEntryPageCommonQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet>;
};


export type TravelEntryPageEntryPageCommonQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageEntryPageCommonQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageEntryPageCommonQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelEntryPageEntryPageCommonQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemOrderByInput>;
};

export type TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItem = {
  __typename?: 'TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet = {
  __typename?: 'TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelEntryPageEntryPageCommonQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<TravelEntryPageEntryPageCommonQuestionBaseValidationMessageItemWhereInput>;
};

export type TravelEntryPageEntryPageCommonWhereInput = {
  Description?: InputMaybe<SearchableStringFilterInput>;
  SsnQuestion?: InputMaybe<TravelEntryPageEntryPageCommonQuestionBaseWhereInput>;
  SubTitle?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Terms?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelEntryPageFacet = {
  __typename?: 'TravelEntryPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CoveredPersonMyselfLabel?: Maybe<Array<Maybe<StringFacet>>>;
  CoveredPersonQuestion?: Maybe<TravelEntryPageQuestionBaseFacet>;
  CoveredPersonSpouseLabel?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EntryPageCommon?: Maybe<TravelEntryPageEntryPageCommonFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SpouseSsnQuestion?: Maybe<TravelEntryPageQuestionBaseFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TravelEntryPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelEntryPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetCoveredPersonMyselfLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetCoveredPersonSpouseLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelEntryPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelEntryPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelEntryPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelEntryPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TravelEntryPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CoveredPersonMyselfLabel?: InputMaybe<OrderBy>;
  CoveredPersonQuestion?: InputMaybe<TravelEntryPageQuestionBaseOrderByInput>;
  CoveredPersonSpouseLabel?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EntryPageCommon?: InputMaybe<TravelEntryPageEntryPageCommonOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SpouseSsnQuestion?: InputMaybe<TravelEntryPageQuestionBaseOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TravelEntryPageOutput = {
  __typename?: 'TravelEntryPageOutput';
  autocomplete?: Maybe<TravelEntryPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TravelEntryPageFacet>;
  item?: Maybe<TravelEntryPage>;
  items?: Maybe<Array<Maybe<TravelEntryPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TravelEntryPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TravelEntryPageQuestionBase = {
  __typename?: 'TravelEntryPageQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<TravelEntryPageQuestionBaseValidationMessageItem>>>;
};


export type TravelEntryPageQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelEntryPageQuestionBaseFacet = {
  __typename?: 'TravelEntryPageQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<TravelEntryPageQuestionBaseValidationMessageItemFacet>;
};


export type TravelEntryPageQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelEntryPageQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<TravelEntryPageQuestionBaseValidationMessageItemOrderByInput>;
};

export type TravelEntryPageQuestionBaseValidationMessageItem = {
  __typename?: 'TravelEntryPageQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type TravelEntryPageQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelEntryPageQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelEntryPageQuestionBaseValidationMessageItemFacet = {
  __typename?: 'TravelEntryPageQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelEntryPageQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelEntryPageQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelEntryPageQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type TravelEntryPageQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelEntryPageQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<TravelEntryPageQuestionBaseValidationMessageItemWhereInput>;
};

export type TravelEntryPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CoveredPersonMyselfLabel?: InputMaybe<SearchableStringFilterInput>;
  CoveredPersonQuestion?: InputMaybe<TravelEntryPageQuestionBaseWhereInput>;
  CoveredPersonSpouseLabel?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EntryPageCommon?: InputMaybe<TravelEntryPageEntryPageCommonWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SpouseSsnQuestion?: InputMaybe<TravelEntryPageQuestionBaseWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TravelEntryPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TravelEntryPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TravelEntryPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Travel Price Page */
export type TravelPricePage = IContent & IData & {
  __typename?: 'TravelPricePage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PricePageCommon?: Maybe<TravelPricePagePricePageCommon>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Travel Price Page */
export type TravelPricePageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Travel Price Page */
export type TravelPricePage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Travel Price Page */
export type TravelPricePage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TravelPricePageAutocomplete = {
  __typename?: 'TravelPricePageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PricePageCommon?: Maybe<TravelPricePagePricePageCommonAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TravelPricePageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TravelPricePageFacet = {
  __typename?: 'TravelPricePageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PricePageCommon?: Maybe<TravelPricePagePricePageCommonFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TravelPricePageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelPricePageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelPricePageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelPricePageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelPricePageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelPricePageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TravelPricePageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PricePageCommon?: InputMaybe<TravelPricePagePricePageCommonOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TravelPricePageOutput = {
  __typename?: 'TravelPricePageOutput';
  autocomplete?: Maybe<TravelPricePageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TravelPricePageFacet>;
  item?: Maybe<TravelPricePage>;
  items?: Maybe<Array<Maybe<TravelPricePage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TravelPricePageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TravelPricePagePricePageCommon = {
  __typename?: 'TravelPricePagePricePageCommon';
  AboutBonusesModal?: Maybe<TravelPricePagePricePageCommonLabelBase>;
  AddonNotSelectableText?: Maybe<Scalars['String']['output']>;
  BonusHeaderOptionOne?: Maybe<Scalars['String']['output']>;
  BonusHeaderOptionTwo?: Maybe<Scalars['String']['output']>;
  BonusItems?: Maybe<Array<Maybe<TravelPricePagePricePageCommonBonusItem>>>;
  BonusLabel?: Maybe<Scalars['String']['output']>;
  ContinuePurchaseLoaderText?: Maybe<Scalars['String']['output']>;
  DeductibleAmountSelector?: Maybe<TravelPricePagePricePageCommonLabelBase>;
  EditButtonText?: Maybe<Scalars['String']['output']>;
  ErrorMessageNoSelected?: Maybe<Scalars['String']['output']>;
  FixedPriceText?: Maybe<Scalars['String']['output']>;
  IncludedItemsHeader?: Maybe<Scalars['String']['output']>;
  InsuranceAmountSelector?: Maybe<TravelPricePagePricePageCommonLabelBase>;
  NoCoverageSelectedForAddons?: Maybe<Scalars['String']['output']>;
  NordeaCampaignSummary?: Maybe<TravelPricePagePricePageCommonLabelBase>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  RecalculatingLoaderText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageText?: Maybe<Scalars['String']['output']>;
  RecommendedCoverageTitle?: Maybe<Scalars['String']['output']>;
  SelectAddonsHeader?: Maybe<Scalars['String']['output']>;
  SelectInsuranceAmountText?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TopQuestionsTitle?: Maybe<Scalars['String']['output']>;
};


export type TravelPricePagePricePageCommonAddonNotSelectableTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonBonusHeaderOptionOneArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonBonusHeaderOptionTwoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonBonusLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonContinuePurchaseLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonEditButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonFixedPriceTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonIncludedItemsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonRecalculatingLoaderTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonRecommendedCoverageTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonRecommendedCoverageTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonSelectAddonsHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelPricePagePricePageCommonAutocomplete = {
  __typename?: 'TravelPricePagePricePageCommonAutocomplete';
  ErrorMessageNoSelected?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TravelPricePagePricePageCommonAutocompleteErrorMessageNoSelectedArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePagePricePageCommonAutocompleteNoCoverageSelectedForAddonsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePagePricePageCommonAutocompleteSelectInsuranceAmountTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelPricePagePricePageCommonAutocompleteTopQuestionsTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TravelPricePagePricePageCommonBonusItem = {
  __typename?: 'TravelPricePagePricePageCommonBonusItem';
  Label?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type TravelPricePagePricePageCommonBonusItemLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonBonusItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelPricePagePricePageCommonBonusItemFacet = {
  __typename?: 'TravelPricePagePricePageCommonBonusItemFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelPricePagePricePageCommonBonusItemFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonBonusItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelPricePagePricePageCommonBonusItemOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type TravelPricePagePricePageCommonBonusItemWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelPricePagePricePageCommonFacet = {
  __typename?: 'TravelPricePagePricePageCommonFacet';
  AboutBonusesModal?: Maybe<TravelPricePagePricePageCommonLabelBaseFacet>;
  AddonNotSelectableText?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionOne?: Maybe<Array<Maybe<StringFacet>>>;
  BonusHeaderOptionTwo?: Maybe<Array<Maybe<StringFacet>>>;
  BonusItems?: Maybe<TravelPricePagePricePageCommonBonusItemFacet>;
  BonusLabel?: Maybe<Array<Maybe<StringFacet>>>;
  ContinuePurchaseLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  DeductibleAmountSelector?: Maybe<TravelPricePagePricePageCommonLabelBaseFacet>;
  EditButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorMessageNoSelected?: Maybe<Array<Maybe<StringFacet>>>;
  FixedPriceText?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedItemsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  InsuranceAmountSelector?: Maybe<TravelPricePagePricePageCommonLabelBaseFacet>;
  NoCoverageSelectedForAddons?: Maybe<Array<Maybe<StringFacet>>>;
  NordeaCampaignSummary?: Maybe<TravelPricePagePricePageCommonLabelBaseFacet>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RecalculatingLoaderText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageText?: Maybe<Array<Maybe<StringFacet>>>;
  RecommendedCoverageTitle?: Maybe<Array<Maybe<StringFacet>>>;
  SelectAddonsHeader?: Maybe<Array<Maybe<StringFacet>>>;
  SelectInsuranceAmountText?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  TopQuestionsTitle?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelPricePagePricePageCommonFacetAddonNotSelectableTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetBonusHeaderOptionOneArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetBonusHeaderOptionTwoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetBonusLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetContinuePurchaseLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetEditButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetErrorMessageNoSelectedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetFixedPriceTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetIncludedItemsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetNoCoverageSelectedForAddonsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetRecalculatingLoaderTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetRecommendedCoverageTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetRecommendedCoverageTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetSelectAddonsHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetSelectInsuranceAmountTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonFacetTopQuestionsTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelPricePagePricePageCommonLabelBase = {
  __typename?: 'TravelPricePagePricePageCommonLabelBase';
  Content?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
};


export type TravelPricePagePricePageCommonLabelBaseContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonLabelBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelPricePagePricePageCommonLabelBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelPricePagePricePageCommonLabelBaseFacet = {
  __typename?: 'TravelPricePagePricePageCommonLabelBaseFacet';
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelPricePagePricePageCommonLabelBaseFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonLabelBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelPricePagePricePageCommonLabelBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelPricePagePricePageCommonLabelBaseOrderByInput = {
  Content?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
};

export type TravelPricePagePricePageCommonLabelBaseWhereInput = {
  Content?: InputMaybe<SearchableStringFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelPricePagePricePageCommonOrderByInput = {
  AboutBonusesModal?: InputMaybe<TravelPricePagePricePageCommonLabelBaseOrderByInput>;
  AddonNotSelectableText?: InputMaybe<OrderBy>;
  BonusHeaderOptionOne?: InputMaybe<OrderBy>;
  BonusHeaderOptionTwo?: InputMaybe<OrderBy>;
  BonusItems?: InputMaybe<TravelPricePagePricePageCommonBonusItemOrderByInput>;
  BonusLabel?: InputMaybe<OrderBy>;
  ContinuePurchaseLoaderText?: InputMaybe<OrderBy>;
  DeductibleAmountSelector?: InputMaybe<TravelPricePagePricePageCommonLabelBaseOrderByInput>;
  EditButtonText?: InputMaybe<OrderBy>;
  ErrorMessageNoSelected?: InputMaybe<OrderBy>;
  FixedPriceText?: InputMaybe<OrderBy>;
  IncludedItemsHeader?: InputMaybe<OrderBy>;
  InsuranceAmountSelector?: InputMaybe<TravelPricePagePricePageCommonLabelBaseOrderByInput>;
  NoCoverageSelectedForAddons?: InputMaybe<OrderBy>;
  NordeaCampaignSummary?: InputMaybe<TravelPricePagePricePageCommonLabelBaseOrderByInput>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  RecalculatingLoaderText?: InputMaybe<OrderBy>;
  RecommendedCoverageText?: InputMaybe<OrderBy>;
  RecommendedCoverageTitle?: InputMaybe<OrderBy>;
  SelectAddonsHeader?: InputMaybe<OrderBy>;
  SelectInsuranceAmountText?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  TopQuestionsTitle?: InputMaybe<OrderBy>;
};

export type TravelPricePagePricePageCommonWhereInput = {
  AboutBonusesModal?: InputMaybe<TravelPricePagePricePageCommonLabelBaseWhereInput>;
  AddonNotSelectableText?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionOne?: InputMaybe<SearchableStringFilterInput>;
  BonusHeaderOptionTwo?: InputMaybe<SearchableStringFilterInput>;
  BonusItems?: InputMaybe<TravelPricePagePricePageCommonBonusItemWhereInput>;
  BonusLabel?: InputMaybe<SearchableStringFilterInput>;
  ContinuePurchaseLoaderText?: InputMaybe<SearchableStringFilterInput>;
  DeductibleAmountSelector?: InputMaybe<TravelPricePagePricePageCommonLabelBaseWhereInput>;
  EditButtonText?: InputMaybe<SearchableStringFilterInput>;
  ErrorMessageNoSelected?: InputMaybe<StringFilterInput>;
  FixedPriceText?: InputMaybe<SearchableStringFilterInput>;
  IncludedItemsHeader?: InputMaybe<SearchableStringFilterInput>;
  InsuranceAmountSelector?: InputMaybe<TravelPricePagePricePageCommonLabelBaseWhereInput>;
  NoCoverageSelectedForAddons?: InputMaybe<StringFilterInput>;
  NordeaCampaignSummary?: InputMaybe<TravelPricePagePricePageCommonLabelBaseWhereInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  RecalculatingLoaderText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageText?: InputMaybe<SearchableStringFilterInput>;
  RecommendedCoverageTitle?: InputMaybe<SearchableStringFilterInput>;
  SelectAddonsHeader?: InputMaybe<SearchableStringFilterInput>;
  SelectInsuranceAmountText?: InputMaybe<StringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  TopQuestionsTitle?: InputMaybe<StringFilterInput>;
};

export type TravelPricePageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PricePageCommon?: InputMaybe<TravelPricePagePricePageCommonWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TravelPricePageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TravelPricePageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TravelPricePageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** Top questions For travel products */
export type TravelTopQuestionsPage = IContent & IData & {
  __typename?: 'TravelTopQuestionsPage';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FamilyMemberFirstNameQuestion?: Maybe<TravelTopQuestionsPageQuestionBase>;
  FamilyMemberInformationLabel?: Maybe<Scalars['String']['output']>;
  FamilyMemberLastNameQuestion?: Maybe<TravelTopQuestionsPageQuestionBase>;
  FamilyMemberMunicipalityQuestion?: Maybe<TravelTopQuestionsPageQuestionBase>;
  FamilyMemberPostalCodeQuestion?: Maybe<TravelTopQuestionsPageQuestionBase>;
  FamilyMemberStreetAddressQuestion?: Maybe<TravelTopQuestionsPageQuestionBase>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopQuestionsCommon?: Maybe<TravelTopQuestionsPageTopQuestionsCommon>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Top questions For travel products */
export type TravelTopQuestionsPageFamilyMemberInformationLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For travel products */
export type TravelTopQuestionsPageNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For travel products */
export type TravelTopQuestionsPage_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Top questions For travel products */
export type TravelTopQuestionsPage_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TravelTopQuestionsPageAutocomplete = {
  __typename?: 'TravelTopQuestionsPageAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TravelTopQuestionsPageAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TravelTopQuestionsPageAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TravelTopQuestionsPageFacet = {
  __typename?: 'TravelTopQuestionsPageFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FamilyMemberFirstNameQuestion?: Maybe<TravelTopQuestionsPageQuestionBaseFacet>;
  FamilyMemberInformationLabel?: Maybe<Array<Maybe<StringFacet>>>;
  FamilyMemberLastNameQuestion?: Maybe<TravelTopQuestionsPageQuestionBaseFacet>;
  FamilyMemberMunicipalityQuestion?: Maybe<TravelTopQuestionsPageQuestionBaseFacet>;
  FamilyMemberPostalCodeQuestion?: Maybe<TravelTopQuestionsPageQuestionBaseFacet>;
  FamilyMemberStreetAddressQuestion?: Maybe<TravelTopQuestionsPageQuestionBaseFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopQuestionsCommon?: Maybe<TravelTopQuestionsPageTopQuestionsCommonFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type TravelTopQuestionsPageFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelTopQuestionsPageFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelTopQuestionsPageFacetFamilyMemberInformationLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelTopQuestionsPageFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelTopQuestionsPageFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TravelTopQuestionsPageFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type TravelTopQuestionsPageOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FamilyMemberFirstNameQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseOrderByInput>;
  FamilyMemberInformationLabel?: InputMaybe<OrderBy>;
  FamilyMemberLastNameQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseOrderByInput>;
  FamilyMemberMunicipalityQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseOrderByInput>;
  FamilyMemberPostalCodeQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseOrderByInput>;
  FamilyMemberStreetAddressQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopQuestionsCommon?: InputMaybe<TravelTopQuestionsPageTopQuestionsCommonOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type TravelTopQuestionsPageOutput = {
  __typename?: 'TravelTopQuestionsPageOutput';
  autocomplete?: Maybe<TravelTopQuestionsPageAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TravelTopQuestionsPageFacet>;
  item?: Maybe<TravelTopQuestionsPage>;
  items?: Maybe<Array<Maybe<TravelTopQuestionsPage>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TravelTopQuestionsPageOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TravelTopQuestionsPageQuestionBase = {
  __typename?: 'TravelTopQuestionsPageQuestionBase';
  Label?: Maybe<Scalars['String']['output']>;
  Placeholder?: Maybe<Scalars['String']['output']>;
  Popover?: Maybe<Scalars['String']['output']>;
  ValidationMessages?: Maybe<Array<Maybe<TravelTopQuestionsPageQuestionBaseValidationMessageItem>>>;
};


export type TravelTopQuestionsPageQuestionBaseLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelTopQuestionsPageQuestionBasePlaceholderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelTopQuestionsPageQuestionBasePopoverArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelTopQuestionsPageQuestionBaseFacet = {
  __typename?: 'TravelTopQuestionsPageQuestionBaseFacet';
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Placeholder?: Maybe<Array<Maybe<StringFacet>>>;
  Popover?: Maybe<Array<Maybe<StringFacet>>>;
  ValidationMessages?: Maybe<TravelTopQuestionsPageQuestionBaseValidationMessageItemFacet>;
};


export type TravelTopQuestionsPageQuestionBaseFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageQuestionBaseFacetPlaceholderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageQuestionBaseFacetPopoverArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelTopQuestionsPageQuestionBaseOrderByInput = {
  Label?: InputMaybe<OrderBy>;
  Placeholder?: InputMaybe<OrderBy>;
  Popover?: InputMaybe<OrderBy>;
  ValidationMessages?: InputMaybe<TravelTopQuestionsPageQuestionBaseValidationMessageItemOrderByInput>;
};

export type TravelTopQuestionsPageQuestionBaseValidationMessageItem = {
  __typename?: 'TravelTopQuestionsPageQuestionBaseValidationMessageItem';
  Key?: Maybe<Scalars['String']['output']>;
  Value?: Maybe<Scalars['String']['output']>;
};


export type TravelTopQuestionsPageQuestionBaseValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelTopQuestionsPageQuestionBaseValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelTopQuestionsPageQuestionBaseValidationMessageItemFacet = {
  __typename?: 'TravelTopQuestionsPageQuestionBaseValidationMessageItemFacet';
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelTopQuestionsPageQuestionBaseValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageQuestionBaseValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelTopQuestionsPageQuestionBaseValidationMessageItemOrderByInput = {
  Key?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
};

export type TravelTopQuestionsPageQuestionBaseValidationMessageItemWhereInput = {
  Key?: InputMaybe<SearchableStringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelTopQuestionsPageQuestionBaseWhereInput = {
  Label?: InputMaybe<SearchableStringFilterInput>;
  Placeholder?: InputMaybe<SearchableStringFilterInput>;
  Popover?: InputMaybe<SearchableStringFilterInput>;
  ValidationMessages?: InputMaybe<TravelTopQuestionsPageQuestionBaseValidationMessageItemWhereInput>;
};

export type TravelTopQuestionsPageTopQuestionsCommon = {
  __typename?: 'TravelTopQuestionsPageTopQuestionsCommon';
  FormTitle?: Maybe<Scalars['String']['output']>;
  PolicyHolderLabel?: Maybe<Scalars['String']['output']>;
  SubmitButtonText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type TravelTopQuestionsPageTopQuestionsCommonFormTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelTopQuestionsPageTopQuestionsCommonPolicyHolderLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelTopQuestionsPageTopQuestionsCommonSubmitButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TravelTopQuestionsPageTopQuestionsCommonTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TravelTopQuestionsPageTopQuestionsCommonFacet = {
  __typename?: 'TravelTopQuestionsPageTopQuestionsCommonFacet';
  FormTitle?: Maybe<Array<Maybe<StringFacet>>>;
  PolicyHolderLabel?: Maybe<Array<Maybe<StringFacet>>>;
  SubmitButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TravelTopQuestionsPageTopQuestionsCommonFacetFormTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageTopQuestionsCommonFacetPolicyHolderLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageTopQuestionsCommonFacetSubmitButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TravelTopQuestionsPageTopQuestionsCommonFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TravelTopQuestionsPageTopQuestionsCommonOrderByInput = {
  FormTitle?: InputMaybe<OrderBy>;
  PolicyHolderLabel?: InputMaybe<OrderBy>;
  SubmitButtonText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type TravelTopQuestionsPageTopQuestionsCommonWhereInput = {
  FormTitle?: InputMaybe<SearchableStringFilterInput>;
  PolicyHolderLabel?: InputMaybe<SearchableStringFilterInput>;
  SubmitButtonText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
};

export type TravelTopQuestionsPageWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FamilyMemberFirstNameQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseWhereInput>;
  FamilyMemberInformationLabel?: InputMaybe<SearchableStringFilterInput>;
  FamilyMemberLastNameQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseWhereInput>;
  FamilyMemberMunicipalityQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseWhereInput>;
  FamilyMemberPostalCodeQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseWhereInput>;
  FamilyMemberStreetAddressQuestion?: InputMaybe<TravelTopQuestionsPageQuestionBaseWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopQuestionsCommon?: InputMaybe<TravelTopQuestionsPageTopQuestionsCommonWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TravelTopQuestionsPageWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TravelTopQuestionsPageWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TravelTopQuestionsPageWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

/** A message describing a specific validation error. */
export type ValidationMessageItem = IContent & IData & {
  __typename?: 'ValidationMessageItem';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  /** A key to identify the error e.g. 'required' */
  Key?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** The actual error message */
  Value?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** A message describing a specific validation error. */
export type ValidationMessageItemKeyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A message describing a specific validation error. */
export type ValidationMessageItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A message describing a specific validation error. */
export type ValidationMessageItemValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A message describing a specific validation error. */
export type ValidationMessageItem_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** A message describing a specific validation error. */
export type ValidationMessageItem_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ValidationMessageItemAutocomplete = {
  __typename?: 'ValidationMessageItemAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ValidationMessageItemAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ValidationMessageItemAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ValidationMessageItemFacet = {
  __typename?: 'ValidationMessageItemFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Key?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Value?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ValidationMessageItemFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ValidationMessageItemFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ValidationMessageItemFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ValidationMessageItemFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ValidationMessageItemFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ValidationMessageItemFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacetValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ValidationMessageItemFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ValidationMessageItemOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Key?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Value?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type ValidationMessageItemOutput = {
  __typename?: 'ValidationMessageItemOutput';
  autocomplete?: Maybe<ValidationMessageItemAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ValidationMessageItemFacet>;
  item?: Maybe<ValidationMessageItem>;
  items?: Maybe<Array<Maybe<ValidationMessageItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ValidationMessageItemOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ValidationMessageItemWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Key?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Value?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ValidationMessageItemWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ValidationMessageItemWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ValidationMessageItemWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum VariationIncludeMode {
  All = 'ALL',
  None = 'NONE',
  Some = 'SOME'
}

export type VariationInput = {
  include?: InputMaybe<VariationIncludeMode>;
  includeOriginal?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Yes and No Answer Content */
export type YesAndNoAnswerContent = IContent & IData & {
  __typename?: 'YesAndNoAnswerContent';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  /** No */
  No?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SimpleAddress?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** Yes */
  Yes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _sortOrder?: Maybe<Scalars['Int']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


/** Yes and No Answer Content */
export type YesAndNoAnswerContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Yes and No Answer Content */
export type YesAndNoAnswerContentNoArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Yes and No Answer Content */
export type YesAndNoAnswerContentYesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Yes and No Answer Content */
export type YesAndNoAnswerContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


/** Yes and No Answer Content */
export type YesAndNoAnswerContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type YesAndNoAnswerContentAutocomplete = {
  __typename?: 'YesAndNoAnswerContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SimpleAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type YesAndNoAnswerContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocompleteSimpleAddressArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type YesAndNoAnswerContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type YesAndNoAnswerContentFacet = {
  __typename?: 'YesAndNoAnswerContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  No?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SimpleAddress?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Yes?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
  _sortOrder?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type YesAndNoAnswerContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YesAndNoAnswerContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YesAndNoAnswerContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetNoArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YesAndNoAnswerContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetSimpleAddressArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YesAndNoAnswerContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type YesAndNoAnswerContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacetYesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type YesAndNoAnswerContentFacet_SortOrderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type YesAndNoAnswerContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  No?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SimpleAddress?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Yes?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
  _sortOrder?: InputMaybe<OrderBy>;
};

export type YesAndNoAnswerContentOutput = {
  __typename?: 'YesAndNoAnswerContentOutput';
  autocomplete?: Maybe<YesAndNoAnswerContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<YesAndNoAnswerContentFacet>;
  item?: Maybe<YesAndNoAnswerContent>;
  items?: Maybe<Array<Maybe<YesAndNoAnswerContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type YesAndNoAnswerContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type YesAndNoAnswerContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  No?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SimpleAddress?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Yes?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<YesAndNoAnswerContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<YesAndNoAnswerContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<YesAndNoAnswerContentWhereInput>>>;
  _sortOrder?: InputMaybe<IntFilterInput>;
};

export enum System_Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL'
}

export type UsePinnedInput = {
  collectionId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phrase?: InputMaybe<Scalars['String']['input']>;
};

export type ButtonBaseFieldsFragment = { __typename?: 'ButtonBase', Name?: string | null, Label?: string | null };

export type EntryPageCommonFieldsFragment = { __typename?: 'EntryPageCommon', Name?: string | null, Description?: string | null, SubTitle?: string | null, SubmitButtonText?: string | null, Terms?: string | null, Title?: string | null, SsnQuestion?: { __typename?: 'EntryPageCommonQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'EntryPageCommonQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null };

export type InfoBoxFieldsFragment = { __typename?: 'InfoBox', Name?: string | null, Header?: string | null, Content?: string | null, Icon?: string | null, Popover?: string | null, Variant?: string | null, CallToAction?: { __typename?: 'InfoBoxButtonBase', Label?: string | null } | null };

export type LabelBaseFieldsFragment = { __typename?: 'LabelBase', Name?: string | null, Label?: string | null, Content?: string | null, Popover?: string | null };

export type LinkFieldsFragment = { __typename?: 'Link', Label?: string | null, Href?: string | null };

export type LinkFragment = { __typename?: 'Link', Label?: string | null, Href?: string | null };

export type MultiSelectProductCommonFieldsFragment = { __typename?: 'MultiSelectProductCommon', Name?: string | null, ErrorMessageNoSelected?: string | null, NoCoverageSelectedForAddons?: string | null, TotalPriceAmountLabel?: string | null };

export type PersonalDetailsBlockFieldsFragment = { __typename?: 'PersonalDetailsBlock', Name?: string | null, SocialSecurityNumber?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, FirstName?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, LastName?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, StreetAddress?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, PostalCode?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, PostOffice?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null };

export type PricePageCommonFieldsFragment = { __typename?: 'PricePageCommon', Name?: string | null, Title?: string | null, SubmitButtonText?: string | null, PolicyHolderLabel?: string | null, BonusLabel?: string | null, SelectAddonsHeader?: string | null, IncludedItemsHeader?: string | null, RecommendedCoverageTitle?: string | null, RecommendedCoverageText?: string | null, ErrorMessageNoSelected?: string | null, NoCoverageSelectedForAddons?: string | null, EditButtonText?: string | null, RecalculatingLoaderText?: string | null, ContinuePurchaseLoaderText?: string | null, FixedPriceText?: string | null, SelectInsuranceAmountText?: string | null, AddonNotSelectableText?: string | null, TopQuestionsTitle?: string | null, DeductibleAmountSelector?: { __typename?: 'PricePageCommonLabelBase', Label?: string | null, Content?: string | null, Popover?: string | null } | null, InsuranceAmountSelector?: { __typename?: 'PricePageCommonLabelBase', Label?: string | null, Content?: string | null, Popover?: string | null } | null, NordeaCampaignSummary?: { __typename?: 'PricePageCommonLabelBase', Label?: string | null, Content?: string | null, Popover?: string | null } | null };

export type QuestionBaseFieldsFragment = { __typename?: 'QuestionBase', Name?: string | null, Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'QuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null };

export type RadioButtonInputFieldsFragment = { __typename?: 'RadioButtonInput', Name?: string | null, Label?: string | null, Popover?: string | null, RadionButtonValues?: Array<{ __typename?: 'RadioButtonInputRadioButtonValueItem', Label?: string | null, Value?: string | null, DefaultChecked?: boolean | null } | null> | null, ValidationMessages?: Array<{ __typename?: 'RadioButtonInputValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null };

export type TopQuestionsCommonFieldsFragment = { __typename?: 'TopQuestionsCommon', Name?: string | null, FormTitle?: string | null, PolicyHolderLabel?: string | null, SubmitButtonText?: string | null, Title?: string | null };

export type FooterQueryVariables = Exact<{
  locale?: InputMaybe<Array<InputMaybe<Locales>> | InputMaybe<Locales>>;
  urlPattern: Scalars['String']['input'];
}>;


export type FooterQuery = { __typename?: 'Query', IfContentPage?: { __typename?: 'IfContentPageOutput', item?: { __typename?: 'IfContentPage', MainContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?:
            | { __typename: 'Addon' }
            | { __typename: 'BabyCommonBlock' }
            | { __typename: 'BabyCommonPage' }
            | { __typename: 'BabyConfirmationPage' }
            | { __typename: 'BabyEntryPage' }
            | { __typename: 'BabyPricePage' }
            | { __typename: 'BabyTopQuestionsPage' }
            | { __typename: 'BonusItem' }
            | { __typename: 'ButtonBase' }
            | { __typename: 'CampaignCardContent' }
            | { __typename: 'CheckoutPageCommon' }
            | { __typename: 'ConfirmationPageCommon' }
            | { __typename: 'Content' }
            | { __typename: 'Coverage' }
            | { __typename: 'CubeDiscountContent' }
            | { __typename: 'CurrencyPeriodSuffix' }
            | { __typename: 'ElectronicHealthDeclerationContent' }
            | { __typename: 'EntryPageCommon' }
            | { __typename: 'FooterContent' }
            | { __typename: 'GlobalContentPage' }
            | { __typename: 'HouseholderCommonBlock' }
            | { __typename: 'HouseholderCommonPage' }
            | { __typename: 'HouseholderConfirmationPage' }
            | { __typename: 'HouseholderEntryPage' }
            | { __typename: 'HouseholderPricePage' }
            | { __typename: 'HouseholderTopQuestionsPage' }
            | { __typename: 'HtmlElement' }
            | { __typename: 'IfCheckoutPage' }
            | { __typename: 'IfCommonPage' }
            | { __typename: 'IfConfirmationPage' }
            | { __typename: 'IfContentPage' }
            | { __typename: 'IfDomainPage' }
            | { __typename: 'IfEntryPage' }
            | { __typename: 'IfExperiencePage' }
            | { __typename: 'IfMigrationFolderPage' }
            | { __typename: 'IfPricePage' }
            | { __typename: 'IfProduct' }
            | { __typename: 'IfSitePage' }
            | { __typename: 'IfTopQuestionsPage' }
            | { __typename: 'IfWebshopPage' }
            | { __typename: 'IncludedItem' }
            | { __typename: 'InfoBox' }
            | { __typename: 'LabelBase', Name?: string | null, Label?: string | null, Content?: string | null, Popover?: string | null }
            | { __typename: 'Link', Label?: string | null, Href?: string | null }
            | { __typename: 'LinkTextAndUrl' }
            | { __typename: 'MultiSelectProductCommon' }
            | { __typename: 'PersonalDetailsBlock' }
            | { __typename: 'PersonalizationRegistryPage' }
            | { __typename: 'PricePageCommon' }
            | { __typename: 'PriceSummarySectionContent' }
            | { __typename: 'PromoCard' }
            | { __typename: 'QuestionBase' }
            | { __typename: 'RadioButtonInput' }
            | { __typename: 'RadioButtonValueItem' }
            | { __typename: 'RecommendationTagCard' }
            | { __typename: 'TermsAndConditionItem' }
            | { __typename: 'TopMenuContent' }
            | { __typename: 'TopQuestionsCommon' }
            | { __typename: 'TravelCommonBlock' }
            | { __typename: 'TravelCommonPage' }
            | { __typename: 'TravelConfirmationPage' }
            | { __typename: 'TravelEntryPage' }
            | { __typename: 'TravelPricePage' }
            | { __typename: 'TravelTopQuestionsPage' }
            | { __typename: 'ValidationMessageItem' }
            | { __typename: 'YesAndNoAnswerContent' }
           | null } | null } | null> | null } | null } | null };

export type ProductEntryPageQueryVariables = Exact<{
  locale?: InputMaybe<Array<InputMaybe<Locales>> | InputMaybe<Locales>>;
  urlPattern: Scalars['String']['input'];
}>;


export type ProductEntryPageQuery = { __typename?: 'Query', IfContentPage?: { __typename?: 'IfContentPageOutput', item?: { __typename?: 'IfContentPage', MainContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?:
            | { __typename: 'Addon' }
            | { __typename: 'BabyCommonBlock' }
            | { __typename: 'BabyCommonPage' }
            | { __typename: 'BabyConfirmationPage' }
            | { __typename: 'BabyEntryPage' }
            | { __typename: 'BabyPricePage' }
            | { __typename: 'BabyTopQuestionsPage' }
            | { __typename: 'BonusItem' }
            | { __typename: 'ButtonBase', Name?: string | null, Label?: string | null }
            | { __typename: 'CampaignCardContent' }
            | { __typename: 'CheckoutPageCommon' }
            | { __typename: 'ConfirmationPageCommon' }
            | { __typename: 'Content' }
            | { __typename: 'Coverage' }
            | { __typename: 'CubeDiscountContent' }
            | { __typename: 'CurrencyPeriodSuffix' }
            | { __typename: 'ElectronicHealthDeclerationContent' }
            | { __typename: 'EntryPageCommon', Name?: string | null, Description?: string | null, SubTitle?: string | null, SubmitButtonText?: string | null, Terms?: string | null, Title?: string | null, SsnQuestion?: { __typename?: 'EntryPageCommonQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'EntryPageCommonQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null }
            | { __typename: 'FooterContent' }
            | { __typename: 'GlobalContentPage' }
            | { __typename: 'HouseholderCommonBlock' }
            | { __typename: 'HouseholderCommonPage' }
            | { __typename: 'HouseholderConfirmationPage' }
            | { __typename: 'HouseholderEntryPage' }
            | { __typename: 'HouseholderPricePage' }
            | { __typename: 'HouseholderTopQuestionsPage' }
            | { __typename: 'HtmlElement' }
            | { __typename: 'IfCheckoutPage' }
            | { __typename: 'IfCommonPage' }
            | { __typename: 'IfConfirmationPage' }
            | { __typename: 'IfContentPage' }
            | { __typename: 'IfDomainPage' }
            | { __typename: 'IfEntryPage' }
            | { __typename: 'IfExperiencePage' }
            | { __typename: 'IfMigrationFolderPage' }
            | { __typename: 'IfPricePage' }
            | { __typename: 'IfProduct' }
            | { __typename: 'IfSitePage' }
            | { __typename: 'IfTopQuestionsPage' }
            | { __typename: 'IfWebshopPage' }
            | { __typename: 'IncludedItem' }
            | { __typename: 'InfoBox' }
            | { __typename: 'LabelBase' }
            | { __typename: 'Link' }
            | { __typename: 'LinkTextAndUrl' }
            | { __typename: 'MultiSelectProductCommon' }
            | { __typename: 'PersonalDetailsBlock' }
            | { __typename: 'PersonalizationRegistryPage' }
            | { __typename: 'PricePageCommon' }
            | { __typename: 'PriceSummarySectionContent' }
            | { __typename: 'PromoCard' }
            | { __typename: 'QuestionBase', Name?: string | null, Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'QuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null }
            | { __typename: 'RadioButtonInput', Name?: string | null, Label?: string | null, Popover?: string | null, RadionButtonValues?: Array<{ __typename?: 'RadioButtonInputRadioButtonValueItem', Label?: string | null, Value?: string | null, DefaultChecked?: boolean | null } | null> | null, ValidationMessages?: Array<{ __typename?: 'RadioButtonInputValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null }
            | { __typename: 'RadioButtonValueItem' }
            | { __typename: 'RecommendationTagCard' }
            | { __typename: 'TermsAndConditionItem' }
            | { __typename: 'TopMenuContent' }
            | { __typename: 'TopQuestionsCommon' }
            | { __typename: 'TravelCommonBlock' }
            | { __typename: 'TravelCommonPage' }
            | { __typename: 'TravelConfirmationPage' }
            | { __typename: 'TravelEntryPage' }
            | { __typename: 'TravelPricePage' }
            | { __typename: 'TravelTopQuestionsPage' }
            | { __typename: 'ValidationMessageItem' }
            | { __typename: 'YesAndNoAnswerContent' }
           | null } | null } | null> | null } | null } | null };

export type ProductPricePageQueryVariables = Exact<{
  locale?: InputMaybe<Array<InputMaybe<Locales>> | InputMaybe<Locales>>;
  urlPattern: Scalars['String']['input'];
}>;


export type ProductPricePageQuery = { __typename?: 'Query', IfContentPage?: { __typename?: 'IfContentPageOutput', item?: { __typename?: 'IfContentPage', MainContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?:
            | { __typename: 'Addon' }
            | { __typename: 'BabyCommonBlock' }
            | { __typename: 'BabyCommonPage' }
            | { __typename: 'BabyConfirmationPage' }
            | { __typename: 'BabyEntryPage' }
            | { __typename: 'BabyPricePage' }
            | { __typename: 'BabyTopQuestionsPage' }
            | { __typename: 'BonusItem' }
            | { __typename: 'ButtonBase' }
            | { __typename: 'CampaignCardContent' }
            | { __typename: 'CheckoutPageCommon' }
            | { __typename: 'ConfirmationPageCommon' }
            | { __typename: 'Content' }
            | { __typename: 'Coverage' }
            | { __typename: 'CubeDiscountContent' }
            | { __typename: 'CurrencyPeriodSuffix' }
            | { __typename: 'ElectronicHealthDeclerationContent' }
            | { __typename: 'EntryPageCommon' }
            | { __typename: 'FooterContent' }
            | { __typename: 'GlobalContentPage' }
            | { __typename: 'HouseholderCommonBlock' }
            | { __typename: 'HouseholderCommonPage' }
            | { __typename: 'HouseholderConfirmationPage' }
            | { __typename: 'HouseholderEntryPage' }
            | { __typename: 'HouseholderPricePage' }
            | { __typename: 'HouseholderTopQuestionsPage' }
            | { __typename: 'HtmlElement' }
            | { __typename: 'IfCheckoutPage' }
            | { __typename: 'IfCommonPage' }
            | { __typename: 'IfConfirmationPage' }
            | { __typename: 'IfContentPage' }
            | { __typename: 'IfDomainPage' }
            | { __typename: 'IfEntryPage' }
            | { __typename: 'IfExperiencePage' }
            | { __typename: 'IfMigrationFolderPage' }
            | { __typename: 'IfPricePage' }
            | { __typename: 'IfProduct' }
            | { __typename: 'IfSitePage' }
            | { __typename: 'IfTopQuestionsPage' }
            | { __typename: 'IfWebshopPage' }
            | { __typename: 'IncludedItem' }
            | { __typename: 'InfoBox', Name?: string | null, Header?: string | null, Content?: string | null, Icon?: string | null, Popover?: string | null, Variant?: string | null, CallToAction?: { __typename?: 'InfoBoxButtonBase', Label?: string | null } | null }
            | { __typename: 'LabelBase', Name?: string | null, Label?: string | null, Content?: string | null, Popover?: string | null }
            | { __typename: 'Link' }
            | { __typename: 'LinkTextAndUrl' }
            | { __typename: 'MultiSelectProductCommon', Name?: string | null, ErrorMessageNoSelected?: string | null, NoCoverageSelectedForAddons?: string | null, TotalPriceAmountLabel?: string | null }
            | { __typename: 'PersonalDetailsBlock', Name?: string | null, SocialSecurityNumber?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, FirstName?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, LastName?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, StreetAddress?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, PostalCode?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null, PostOffice?: { __typename?: 'PersonalDetailsBlockQuestionBase', Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'PersonalDetailsBlockQuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null } | null }
            | { __typename: 'PersonalizationRegistryPage' }
            | { __typename: 'PricePageCommon', Name?: string | null, Title?: string | null, SubmitButtonText?: string | null, PolicyHolderLabel?: string | null, BonusLabel?: string | null, SelectAddonsHeader?: string | null, IncludedItemsHeader?: string | null, RecommendedCoverageTitle?: string | null, RecommendedCoverageText?: string | null, ErrorMessageNoSelected?: string | null, NoCoverageSelectedForAddons?: string | null, EditButtonText?: string | null, RecalculatingLoaderText?: string | null, ContinuePurchaseLoaderText?: string | null, FixedPriceText?: string | null, SelectInsuranceAmountText?: string | null, AddonNotSelectableText?: string | null, TopQuestionsTitle?: string | null, DeductibleAmountSelector?: { __typename?: 'PricePageCommonLabelBase', Label?: string | null, Content?: string | null, Popover?: string | null } | null, InsuranceAmountSelector?: { __typename?: 'PricePageCommonLabelBase', Label?: string | null, Content?: string | null, Popover?: string | null } | null, NordeaCampaignSummary?: { __typename?: 'PricePageCommonLabelBase', Label?: string | null, Content?: string | null, Popover?: string | null } | null }
            | { __typename: 'PriceSummarySectionContent' }
            | { __typename: 'PromoCard' }
            | { __typename: 'QuestionBase', Name?: string | null, Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'QuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null }
            | { __typename: 'RadioButtonInput', Name?: string | null, Label?: string | null, Popover?: string | null, RadionButtonValues?: Array<{ __typename?: 'RadioButtonInputRadioButtonValueItem', Label?: string | null, Value?: string | null, DefaultChecked?: boolean | null } | null> | null, ValidationMessages?: Array<{ __typename?: 'RadioButtonInputValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null }
            | { __typename: 'RadioButtonValueItem' }
            | { __typename: 'RecommendationTagCard' }
            | { __typename: 'TermsAndConditionItem' }
            | { __typename: 'TopMenuContent' }
            | { __typename: 'TopQuestionsCommon' }
            | { __typename: 'TravelCommonBlock' }
            | { __typename: 'TravelCommonPage' }
            | { __typename: 'TravelConfirmationPage' }
            | { __typename: 'TravelEntryPage' }
            | { __typename: 'TravelPricePage' }
            | { __typename: 'TravelTopQuestionsPage' }
            | { __typename: 'ValidationMessageItem' }
            | { __typename: 'YesAndNoAnswerContent' }
           | null } | null } | null> | null } | null } | null };

export type ProductTopQuestionsPageQueryVariables = Exact<{
  locale?: InputMaybe<Array<InputMaybe<Locales>> | InputMaybe<Locales>>;
  urlPattern: Scalars['String']['input'];
}>;


export type ProductTopQuestionsPageQuery = { __typename?: 'Query', IfContentPage?: { __typename?: 'IfContentPageOutput', item?: { __typename?: 'IfContentPage', MainContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?:
            | { __typename: 'Addon' }
            | { __typename: 'BabyCommonBlock' }
            | { __typename: 'BabyCommonPage' }
            | { __typename: 'BabyConfirmationPage' }
            | { __typename: 'BabyEntryPage' }
            | { __typename: 'BabyPricePage' }
            | { __typename: 'BabyTopQuestionsPage' }
            | { __typename: 'BonusItem' }
            | { __typename: 'ButtonBase' }
            | { __typename: 'CampaignCardContent' }
            | { __typename: 'CheckoutPageCommon' }
            | { __typename: 'ConfirmationPageCommon' }
            | { __typename: 'Content' }
            | { __typename: 'Coverage' }
            | { __typename: 'CubeDiscountContent' }
            | { __typename: 'CurrencyPeriodSuffix' }
            | { __typename: 'ElectronicHealthDeclerationContent' }
            | { __typename: 'EntryPageCommon' }
            | { __typename: 'FooterContent' }
            | { __typename: 'GlobalContentPage' }
            | { __typename: 'HouseholderCommonBlock' }
            | { __typename: 'HouseholderCommonPage' }
            | { __typename: 'HouseholderConfirmationPage' }
            | { __typename: 'HouseholderEntryPage' }
            | { __typename: 'HouseholderPricePage' }
            | { __typename: 'HouseholderTopQuestionsPage' }
            | { __typename: 'HtmlElement' }
            | { __typename: 'IfCheckoutPage' }
            | { __typename: 'IfCommonPage' }
            | { __typename: 'IfConfirmationPage' }
            | { __typename: 'IfContentPage' }
            | { __typename: 'IfDomainPage' }
            | { __typename: 'IfEntryPage' }
            | { __typename: 'IfExperiencePage' }
            | { __typename: 'IfMigrationFolderPage' }
            | { __typename: 'IfPricePage' }
            | { __typename: 'IfProduct' }
            | { __typename: 'IfSitePage' }
            | { __typename: 'IfTopQuestionsPage' }
            | { __typename: 'IfWebshopPage' }
            | { __typename: 'IncludedItem' }
            | { __typename: 'InfoBox' }
            | { __typename: 'LabelBase', Name?: string | null, Label?: string | null, Content?: string | null, Popover?: string | null }
            | { __typename: 'Link' }
            | { __typename: 'LinkTextAndUrl' }
            | { __typename: 'MultiSelectProductCommon' }
            | { __typename: 'PersonalDetailsBlock' }
            | { __typename: 'PersonalizationRegistryPage' }
            | { __typename: 'PricePageCommon' }
            | { __typename: 'PriceSummarySectionContent' }
            | { __typename: 'PromoCard' }
            | { __typename: 'QuestionBase', Name?: string | null, Label?: string | null, Placeholder?: string | null, Popover?: string | null, ValidationMessages?: Array<{ __typename?: 'QuestionBaseValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null }
            | { __typename: 'RadioButtonInput', Name?: string | null, Label?: string | null, Popover?: string | null, RadionButtonValues?: Array<{ __typename?: 'RadioButtonInputRadioButtonValueItem', Label?: string | null, Value?: string | null, DefaultChecked?: boolean | null } | null> | null, ValidationMessages?: Array<{ __typename?: 'RadioButtonInputValidationMessageItem', Key?: string | null, Value?: string | null } | null> | null }
            | { __typename: 'RadioButtonValueItem' }
            | { __typename: 'RecommendationTagCard' }
            | { __typename: 'TermsAndConditionItem' }
            | { __typename: 'TopMenuContent' }
            | { __typename: 'TopQuestionsCommon', Name?: string | null, FormTitle?: string | null, PolicyHolderLabel?: string | null, SubmitButtonText?: string | null, Title?: string | null }
            | { __typename: 'TravelCommonBlock' }
            | { __typename: 'TravelCommonPage' }
            | { __typename: 'TravelConfirmationPage' }
            | { __typename: 'TravelEntryPage' }
            | { __typename: 'TravelPricePage' }
            | { __typename: 'TravelTopQuestionsPage' }
            | { __typename: 'ValidationMessageItem' }
            | { __typename: 'YesAndNoAnswerContent' }
           | null } | null } | null> | null } | null } | null };

export type SchemaTypenameQueryVariables = Exact<{ [key: string]: never; }>;


export type SchemaTypenameQuery = { __typename: 'Query' };

export type TopMenuContentQueryVariables = Exact<{
  locale?: InputMaybe<Array<InputMaybe<Locales>> | InputMaybe<Locales>>;
  urlPattern: Scalars['String']['input'];
}>;


export type TopMenuContentQuery = { __typename?: 'Query', IfContentPage?: { __typename?: 'IfContentPageOutput', item?: { __typename?: 'IfContentPage', MainContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?:
            | { __typename: 'Addon' }
            | { __typename: 'BabyCommonBlock' }
            | { __typename: 'BabyCommonPage' }
            | { __typename: 'BabyConfirmationPage' }
            | { __typename: 'BabyEntryPage' }
            | { __typename: 'BabyPricePage' }
            | { __typename: 'BabyTopQuestionsPage' }
            | { __typename: 'BonusItem' }
            | { __typename: 'ButtonBase' }
            | { __typename: 'CampaignCardContent' }
            | { __typename: 'CheckoutPageCommon' }
            | { __typename: 'ConfirmationPageCommon' }
            | { __typename: 'Content' }
            | { __typename: 'Coverage' }
            | { __typename: 'CubeDiscountContent' }
            | { __typename: 'CurrencyPeriodSuffix' }
            | { __typename: 'ElectronicHealthDeclerationContent' }
            | { __typename: 'EntryPageCommon' }
            | { __typename: 'FooterContent' }
            | { __typename: 'GlobalContentPage' }
            | { __typename: 'HouseholderCommonBlock' }
            | { __typename: 'HouseholderCommonPage' }
            | { __typename: 'HouseholderConfirmationPage' }
            | { __typename: 'HouseholderEntryPage' }
            | { __typename: 'HouseholderPricePage' }
            | { __typename: 'HouseholderTopQuestionsPage' }
            | { __typename: 'HtmlElement' }
            | { __typename: 'IfCheckoutPage' }
            | { __typename: 'IfCommonPage' }
            | { __typename: 'IfConfirmationPage' }
            | { __typename: 'IfContentPage' }
            | { __typename: 'IfDomainPage' }
            | { __typename: 'IfEntryPage' }
            | { __typename: 'IfExperiencePage' }
            | { __typename: 'IfMigrationFolderPage' }
            | { __typename: 'IfPricePage' }
            | { __typename: 'IfProduct' }
            | { __typename: 'IfSitePage' }
            | { __typename: 'IfTopQuestionsPage' }
            | { __typename: 'IfWebshopPage' }
            | { __typename: 'IncludedItem' }
            | { __typename: 'InfoBox' }
            | { __typename: 'LabelBase', Name?: string | null, Label?: string | null, Content?: string | null, Popover?: string | null }
            | { __typename: 'Link', Label?: string | null, Href?: string | null }
            | { __typename: 'LinkTextAndUrl' }
            | { __typename: 'MultiSelectProductCommon' }
            | { __typename: 'PersonalDetailsBlock' }
            | { __typename: 'PersonalizationRegistryPage' }
            | { __typename: 'PricePageCommon' }
            | { __typename: 'PriceSummarySectionContent' }
            | { __typename: 'PromoCard' }
            | { __typename: 'QuestionBase' }
            | { __typename: 'RadioButtonInput' }
            | { __typename: 'RadioButtonValueItem' }
            | { __typename: 'RecommendationTagCard' }
            | { __typename: 'TermsAndConditionItem' }
            | { __typename: 'TopMenuContent' }
            | { __typename: 'TopQuestionsCommon' }
            | { __typename: 'TravelCommonBlock' }
            | { __typename: 'TravelCommonPage' }
            | { __typename: 'TravelConfirmationPage' }
            | { __typename: 'TravelEntryPage' }
            | { __typename: 'TravelPricePage' }
            | { __typename: 'TravelTopQuestionsPage' }
            | { __typename: 'ValidationMessageItem' }
            | { __typename: 'YesAndNoAnswerContent' }
           | null } | null } | null> | null } | null } | null };

export const ButtonBaseFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ButtonBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}}]}}]} as unknown as DocumentNode<ButtonBaseFieldsFragment, unknown>;
export const EntryPageCommonFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryPageCommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryPageCommon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"SubmitButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"Terms"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SsnQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}}]}}]} as unknown as DocumentNode<EntryPageCommonFieldsFragment, unknown>;
export const InfoBoxFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InfoBoxFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfoBox"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Header"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Icon"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"Variant"}},{"kind":"Field","name":{"kind":"Name","value":"CallToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}}]}}]}}]} as unknown as DocumentNode<InfoBoxFieldsFragment, unknown>;
export const LabelBaseFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabelBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}}]} as unknown as DocumentNode<LabelBaseFieldsFragment, unknown>;
export const LinkFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Link"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Href"}}]}}]} as unknown as DocumentNode<LinkFieldsFragment, unknown>;
export const LinkFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Link"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Link"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Href"}}]}}]} as unknown as DocumentNode<LinkFragment, unknown>;
export const MultiSelectProductCommonFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiSelectProductCommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectProductCommon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"ErrorMessageNoSelected"}},{"kind":"Field","name":{"kind":"Name","value":"NoCoverageSelectedForAddons"}},{"kind":"Field","name":{"kind":"Name","value":"TotalPriceAmountLabel"}}]}}]} as unknown as DocumentNode<MultiSelectProductCommonFieldsFragment, unknown>;
export const PersonalDetailsBlockFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonalDetailsBlockFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonalDetailsBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"SocialSecurityNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"FirstName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"LastName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"StreetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"PostalCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"PostOffice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}}]}}]} as unknown as DocumentNode<PersonalDetailsBlockFieldsFragment, unknown>;
export const PricePageCommonFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PricePageCommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricePageCommon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SubmitButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyHolderLabel"}},{"kind":"Field","name":{"kind":"Name","value":"BonusLabel"}},{"kind":"Field","name":{"kind":"Name","value":"SelectAddonsHeader"}},{"kind":"Field","name":{"kind":"Name","value":"IncludedItemsHeader"}},{"kind":"Field","name":{"kind":"Name","value":"RecommendedCoverageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"RecommendedCoverageText"}},{"kind":"Field","name":{"kind":"Name","value":"ErrorMessageNoSelected"}},{"kind":"Field","name":{"kind":"Name","value":"NoCoverageSelectedForAddons"}},{"kind":"Field","name":{"kind":"Name","value":"EditButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"RecalculatingLoaderText"}},{"kind":"Field","name":{"kind":"Name","value":"ContinuePurchaseLoaderText"}},{"kind":"Field","name":{"kind":"Name","value":"FixedPriceText"}},{"kind":"Field","name":{"kind":"Name","value":"SelectInsuranceAmountText"}},{"kind":"Field","name":{"kind":"Name","value":"AddonNotSelectableText"}},{"kind":"Field","name":{"kind":"Name","value":"TopQuestionsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"DeductibleAmountSelector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}},{"kind":"Field","name":{"kind":"Name","value":"InsuranceAmountSelector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}},{"kind":"Field","name":{"kind":"Name","value":"NordeaCampaignSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}}]}}]} as unknown as DocumentNode<PricePageCommonFieldsFragment, unknown>;
export const QuestionBaseFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}}]} as unknown as DocumentNode<QuestionBaseFieldsFragment, unknown>;
export const RadioButtonInputFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RadioButtonInputFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RadioButtonInput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"RadionButtonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}}]} as unknown as DocumentNode<RadioButtonInputFieldsFragment, unknown>;
export const TopQuestionsCommonFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopQuestionsCommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopQuestionsCommon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"FormTitle"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyHolderLabel"}},{"kind":"Field","name":{"kind":"Name","value":"SubmitButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}}]} as unknown as DocumentNode<TopQuestionsCommonFieldsFragment, unknown>;
export const FooterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Footer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locales"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IfContentPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Url"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"like"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MainContentArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Expanded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabelBaseFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Link"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabelBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Link"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Link"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Href"}}]}}]} as unknown as DocumentNode<FooterQuery, FooterQueryVariables>;
export const ProductEntryPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductEntryPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locales"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IfContentPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Url"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"like"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MainContentArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Expanded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryPageCommonFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionBaseFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ButtonBaseFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RadioButtonInputFields"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryPageCommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryPageCommon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"SubTitle"}},{"kind":"Field","name":{"kind":"Name","value":"SubmitButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"Terms"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SsnQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ButtonBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RadioButtonInputFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RadioButtonInput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"RadionButtonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}}]} as unknown as DocumentNode<ProductEntryPageQuery, ProductEntryPageQueryVariables>;
export const ProductPricePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductPricePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locales"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IfContentPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Url"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"like"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MainContentArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Expanded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricePageCommonFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabelBaseFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RadioButtonInputFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionBaseFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiSelectProductCommonFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InfoBoxFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonalDetailsBlockFields"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PricePageCommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricePageCommon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"SubmitButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyHolderLabel"}},{"kind":"Field","name":{"kind":"Name","value":"BonusLabel"}},{"kind":"Field","name":{"kind":"Name","value":"SelectAddonsHeader"}},{"kind":"Field","name":{"kind":"Name","value":"IncludedItemsHeader"}},{"kind":"Field","name":{"kind":"Name","value":"RecommendedCoverageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"RecommendedCoverageText"}},{"kind":"Field","name":{"kind":"Name","value":"ErrorMessageNoSelected"}},{"kind":"Field","name":{"kind":"Name","value":"NoCoverageSelectedForAddons"}},{"kind":"Field","name":{"kind":"Name","value":"EditButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"RecalculatingLoaderText"}},{"kind":"Field","name":{"kind":"Name","value":"ContinuePurchaseLoaderText"}},{"kind":"Field","name":{"kind":"Name","value":"FixedPriceText"}},{"kind":"Field","name":{"kind":"Name","value":"SelectInsuranceAmountText"}},{"kind":"Field","name":{"kind":"Name","value":"AddonNotSelectableText"}},{"kind":"Field","name":{"kind":"Name","value":"TopQuestionsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"DeductibleAmountSelector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}},{"kind":"Field","name":{"kind":"Name","value":"InsuranceAmountSelector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}},{"kind":"Field","name":{"kind":"Name","value":"NordeaCampaignSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabelBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RadioButtonInputFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RadioButtonInput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"RadionButtonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiSelectProductCommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MultiSelectProductCommon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"ErrorMessageNoSelected"}},{"kind":"Field","name":{"kind":"Name","value":"NoCoverageSelectedForAddons"}},{"kind":"Field","name":{"kind":"Name","value":"TotalPriceAmountLabel"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InfoBoxFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfoBox"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Header"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Icon"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"Variant"}},{"kind":"Field","name":{"kind":"Name","value":"CallToAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonalDetailsBlockFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonalDetailsBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"SocialSecurityNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"FirstName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"LastName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"StreetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"PostalCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"PostOffice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}}]}}]} as unknown as DocumentNode<ProductPricePageQuery, ProductPricePageQueryVariables>;
export const ProductTopQuestionsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTopQuestionsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locales"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IfContentPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Url"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"like"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MainContentArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Expanded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopQuestionsCommonFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionBaseFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabelBaseFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RadioButtonInputFields"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopQuestionsCommonFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopQuestionsCommon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"FormTitle"}},{"kind":"Field","name":{"kind":"Name","value":"PolicyHolderLabel"}},{"kind":"Field","name":{"kind":"Name","value":"SubmitButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestionBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabelBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RadioButtonInputFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RadioButtonInput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}},{"kind":"Field","name":{"kind":"Name","value":"RadionButtonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}},{"kind":"Field","name":{"kind":"Name","value":"DefaultChecked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ValidationMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Value"}}]}}]}}]} as unknown as DocumentNode<ProductTopQuestionsPageQuery, ProductTopQuestionsPageQueryVariables>;
export const SchemaTypenameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SchemaTypename"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<SchemaTypenameQuery, SchemaTypenameQueryVariables>;
export const TopMenuContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TopMenuContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locales"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IfContentPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Url"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"like"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urlPattern"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"MainContentArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ContentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Expanded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabelBaseFields"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Link"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Href"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabelBaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabelBase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Label"}},{"kind":"Field","name":{"kind":"Name","value":"Content"}},{"kind":"Field","name":{"kind":"Name","value":"Popover"}}]}}]} as unknown as DocumentNode<TopMenuContentQuery, TopMenuContentQueryVariables>;